const languages: { [key: string]: any } = {
  en: {
    'Khmer': 'ភាសាខ្មែរ',
    Copy: 'Copy',
    Copied: 'Copied',
    Oops: 'Oops',
    'We could not find the page.': 'We could not find the page.',
    'You are not authorized to view this page.': 'You are not authorized to view this page.',
    'Min-max': 'Min-max',
    History: 'History',
    Help: 'Help',
    Banker: 'Banker',
    Player: 'Player',
    Undo: 'Undo',
    Clear: 'Clear',
    Bet: 'Bet',
    'Tài Xỉu': 'Tài Xỉu',
    Big: 'Big',
    Small: 'Small',
    Cockfight: 'Cockfight',
    'Quick Play': 'Quick Play',
    'Normal mode': 'Normal mode',
    'Open Tài Xỉu tables': 'Open Tài Xỉu tables',
    'Tài Xỉu table selector': 'Tài Xỉu table selector',
    'Keep the live arena visible': 'Keep the live arena visible',
    'Mock Tài Xỉu feed': 'Mock Tài Xỉu feed',
    'Prototype data only': 'Prototype data only',
    'Total 11–17': 'Total 11–17',
    'Total 4–10': 'Total 4–10',
    Odd: 'Odd',
    Even: 'Even',
    'Bet chips': 'Bet chips',
    Submitting: 'Submitting',
    Rolling: 'Rolling',
    'Recent results': 'Recent results',
    'Close Quick Play': 'Close Quick Play',
    'Choose a betting area first': 'Choose a betting area first',
    'No active Tài Xỉu round': 'No active Tài Xỉu round',
    'Some bets could not be submitted': 'Some bets could not be submitted',
    'Bet accepted': 'Bet accepted',
    Jackpot: 'Jackpot',
    'No fight at the moment': 'No fight at the moment',
    'F{fightNumber} is {fightStatus}': 'F{fightNumber} is {fightStatus}',
    Hrs: 'Hrs',
    Min: 'Min',
    Sec: 'Sec',
    'Load more': 'Load more',
    loading: 'loading',
    'Congratulations!': 'Congratulations!',
    'Major ticket': 'Major ticket',
    'Claim your prize': 'Claim your prize',
    'Current jackpot': 'Current jackpot',
    'Past winner': 'Past winner',
    'My tickets': 'My tickets',
    'Super draw': 'Super draw',
    Winners: 'Winners',
    Today: 'Today',
    'No tickets earned': 'No tickets earned',
    'You earn lucky draw ticket #{ticketId}': 'You earn lucky draw ticket #{ticketId}',
    'Instant prize': 'Instant prize',
    Date: 'Date',
    Time: 'Time',
    Ante: 'Ante',
    Turnover: 'Turnover',
    Round: 'Round',
    All: 'All',
    'You can\'t place bet': 'You can\'t place bet',
    Odds: 'Odds',
    Results: 'Results',
    'Win/lose': 'Win/lose',
    Id: 'Id',
    Match: 'Match',
    'Start time': 'Start time',
    Created: 'Created',
    Confirmed: 'Confirmed',
    Closing: 'Closing',
    Closed: 'Closed',
    Started: 'Started',
    Ended: 'Ended',
    Declared: 'Declared',
    Approved: 'Approved',
    Processed: 'Processed',
    Cancelled: 'Cancelled',
    Hold: 'Hold',
    Close: 'Close',
    Draw: 'Draw',
    'Bet detail': 'Bet detail',
    Yesterday: 'Yesterday',
    'This week': 'This week',
    'Last week': 'Last week',
    Viet: 'Tiếng Việt',
    Thai: 'ภาษาไทย',
    Indo: 'Bahasa indo',
    'Account disabled': 'Account disabled',
    'Invalid token': 'Invalid token',
    'Draw will be declared after 10-minute countdown': 'Draw will be declared after 10-minute countdown',
    Balance: 'Balance',
    Tnc: 'Tnc',
    Progress: 'Progress',
    Open: 'Open',
    'Okay, got it.': 'Okay, got it.',
    'Please come back again': 'Please come back again',
    Voided: 'Voided',
    'Jackpot history': 'Jackpot history',
    'Jackpot help': 'Jackpot help',
    'Lucky draw': 'Lucky draw',
    'ANTE FOR JACKPOT GAME': 'ANTE FOR JACKPOT GAME',
    'Along with your bet, a small portion (known as the "ante") is automatically collected and added to the jackpot pool. This pool is a special fund that accumulates over time, contributed to by all players participating in the game.': 'Along with your bet, a small portion (known as the "ante") is automatically collected and added to the jackpot pool. This pool is a special fund that accumulates over time, contributed to by all players participating in the game.',
    'ACCUMULATING PROGRESS FOR JACKPOT GAME': 'ACCUMULATING PROGRESS FOR JACKPOT GAME',
    'Each time you play, you make progress towards triggering the jackpot game. This progress is measured through a meter that fills up a little more each time you bet.': 'Each time you play, you make progress towards triggering the jackpot game. This progress is measured through a meter that fills up a little more each time you bet.',
    'JACKPOT GAME OCCURRENCE': 'JACKPOT GAME OCCURRENCE',
    'Once you have accumulated enough progress, the jackpot game is triggered. This is a special event where you have the chance to win big prizes.': 'Once you have accumulated enough progress, the jackpot game is triggered. This is a special event where you have the chance to win big prizes.',
    'Whether you win a Major, Minor, or Mini ticket, you\'re guaranteed an instant prize payout, with the value varying based on the type of ticket. Each ticket color represents a different prize level.': 'Whether you win a Major, Minor, or Mini ticket, you\'re guaranteed an instant prize payout, with the value varying based on the type of ticket. Each ticket color represents a different prize level.',
    'Each ticket type indicates the number of winners and the size of the prize. The lucky draw happens at the end of a countdown, creating anticipation and excitement. So, whether you have a Major, Minor, or Mini ticket, stay tuned for the draw to see if you\'ve won!': 'Each ticket type indicates the number of winners and the size of the prize. The lucky draw happens at the end of a countdown, creating anticipation and excitement. So, whether you have a Major, Minor, or Mini ticket, stay tuned for the draw to see if you\'ve won!',
    'Instant prize & lucky draw': 'Instant prize & lucky draw',
    '{arena} Video Stream': '{arena} Video Stream',
    'Toggle video auto scale': 'Toggle video auto scale',
    'Reload the streaming': 'Reload the streaming',
    Commission: 'Commission',
    Total: 'Total',
    Win: 'Win',
    'Your session expired, please login again.': 'Your session expired, please login again.',
    'Go to login page': 'Go to login page',
    Chinese: '简体中文',
    Statement: 'Statement',
    Main: 'Main',
    Limits: 'Limits',
    Settings: 'Settings',
    Notification: 'Notification',
    Logout: 'Logout',
    General: 'General',
    'To read more': 'To read more',
    'Jackpot prize': 'Jackpot prize',
    Schedules: 'Schedules',
    'Schedule details': 'Schedule details',
    Save: 'Save',
    Custom: 'Custom',
    Maximum: 'Maximum',
    'Float Video': 'Float Video',
    Spanish: 'Español',
    Pakistan: 'اُردُو ',
    Korean: '한국어',
    Japanese: '日本語',
    'Stream locked': 'Stream locked',
    'You need at least {CURRENCY} {AMOUNT} in your wallet to watch this stream.': 'You need at least {CURRENCY} {AMOUNT} in your wallet to watch this stream.',
    'Cockfighting Rules': 'Cockfighting Rules',
    Burmese: 'မြန်မာဘာသာစကား',
    'Bengali-Bangladesh': 'বাংলা',
    'Traditional Chinese': '繁體中文',
    'Hindi-India': 'हिन्दी',
    Earning: 'Earning',
    'Bet not successful': 'Bet not successful',
    'Betting is paused. Please try again shortly. E25': 'Betting is paused. Please try again shortly. E25',
    'Bet guide': 'Bet guide',
    'Placing bet': 'Placing bet',
    'Select bet chip': 'Select bet chip',
    'Place chip by clicking on preferred bet selection': 'Place chip by clicking on preferred bet selection',
    'Click Bet button to confirm your bet': 'Click Bet button to confirm your bet',
    'Fair game rules': 'Fair game rules',
    'Live streaming': 'Live streaming',
    'Unforeseen issues such as internet connectivity, power supply, or weather disruptions caused the live stream to be interrupted before the fight began.': 'Unforeseen issues such as internet connectivity, power supply, or weather disruptions caused the live stream to be interrupted before the fight began.',
    'If the fight is not displayed on the game site, all bets will be refunded.': 'If the fight is not displayed on the game site, all bets will be refunded.',
    'Arena management decision': 'Arena management decision',
    'Arena management reserves the right to cancel any match; announcements regarding arena decisions will be made on a case-by-case basis.': 'Arena management reserves the right to cancel any match; announcements regarding arena decisions will be made on a case-by-case basis.',
    'Bet not closed in time': 'Bet not closed in time',
    'Bets placed after the fight began will be void and refunded to members due to unforeseen technical issues.': 'Bets placed after the fight began will be void and refunded to members due to unforeseen technical issues.',
    'Terms & Conditions': 'Terms & Conditions',
    'Philippines Cockfighting': 'Philippines Cockfighting',
    'Challenge Rules': 'Challenge Rules',
    'Banker / Meron': 'Banker / Meron',
    'Player / Wala': 'Player / Wala',
    'Draw / No Winner': 'Draw / No Winner',
    'During the Carreo Procedure (3 UP & 3 DOWN), neither rooster lands two (2) successful pecks, or': 'During the Carreo Procedure (3 UP & 3 DOWN), neither rooster lands two (2) successful pecks, or',
    'No winner is declared within 10 minutes from the first contact.': 'No winner is declared within 10 minutes from the first contact.',
    '*Arena Judge decision is final.': '*Arena Judge decision is final.',
    Cambodia: 'Cambodia',
    'Cockfight Rules': 'Cockfight Rules',
    'Touching or Catching =': 'Touching or Catching =',
    'Automatic Loss': 'Automatic Loss',
    'No External Help': 'No External Help',
    'No fixing, No beak adjustment': 'No fixing, No beak adjustment',
    'No water': 'No water',
    'Defeated if': 'Defeated if',
    'Lies Flat': 'Lies Flat',
    'Runs Away / Cries': 'Runs Away / Cries',
    'No Retaliation × 3': 'No Retaliation × 3',
    'Standing beats Kneeling;': 'Standing beats Kneeling;',
    'Kneeling beats Lying Flat': 'Kneeling beats Lying Flat',
    'NO ABUSED or POISONING ALLOWED': 'NO ABUSED or POISONING ALLOWED',
    'Tabletop Game Guide': 'Tabletop Game Guide',
    'RULE: DON\'T FALL OFF!': 'RULE: DON\'T FALL OFF!',
    'Roosters fight on the table top arena.': 'Roosters fight on the table top arena.',
    'First rooster to touch the floor LOSES.': 'First rooster to touch the floor LOSES.',
    'Rooster remaining on the table WINS.': 'Rooster remaining on the table WINS.',
    'Draw when both rooster fall off at the same time': 'Draw when both rooster fall off at the same time',
    'A match is declared DRAW (NO WINNER) if:': 'A match is declared DRAW (NO WINNER) if:',
    'The match began, but Arena Management determined that cock was injured. Arena management has the right to cancel the fight if neither cock has a cut or bleed. Any other unforeseeable events.': 'The match began, but Arena Management determined that cock was injured. Arena management has the right to cancel the fight if neither cock has a cut or bleed. Any other unforeseeable events.',
    Philippines: 'Philippines',
    Tabletop: 'Tabletop',
    'Max bet reached for this selection.': 'Max bet reached for this selection.',
    'This arena has ended': 'This arena has ended',
    'Thank you for your support': 'Thank you for your support',
    Portuguese: 'Português',
    Uzbek: 'Uzbek',
  },
  zh: {
    'Khmer': 'ភាសាខ្មែរ',
    Copy: '复制',
    Copied: '已复制',
    Oops: '哎呀',
    'We could not find the page.': '我们找不到该页面。',
    'You are not authorized to view this page.': '您无权查看此页面。',
    'Min-max': '最小-最大',
    History: '投注历史',
    Help: '帮助',
    Banker: '庄',
    Player: '闲',
    Undo: '撤销',
    Bet: '投注',
    Jackpot: '奖池',
    'No fight at the moment': '目前没有赛事',
    'F{fightNumber} is {fightStatus}': '赛事{fightNumber}状态： {fightStatus}',
    Hrs: '时',
    Min: '分',
    Sec: '秒',
    'Load more': '加载更多',
    loading: '正在加载',
    'Congratulations!': '恭喜！',
    'Major ticket': '主要彩票',
    'Claim your prize': '领取您的奖品',
    'Current jackpot': '当前累积奖池',
    'Past winner': '往期获胜者',
    'My tickets': '我的彩票',
    'Super draw': '超级抽奖',
    Winners: '获奖者',
    Today: '今天',
    'No tickets earned': '目前无彩票',
    'You earn lucky draw ticket #{ticketId}': '您获得幸运抽奖票 #{ticketId}',
    'Instant prize': '即时奖励',
    Date: '日期',
    Time: '时间',
    Ante: '底注',
    'You can\'t place bet': '无法下注',
    Odds: '赔率',
    Results: '结果',
    'Win/lose': '赢/输',
    Id: '编号',
    Match: '赛事',
    'Start time': '开始时间',
    Created: '创建',
    Confirmed: '投注开始',
    Closing: '投注即将结束',
    Closed: '投注结束',
    Started: '已开始',
    Ended: '已结束',
    Declared: '已宣布',
    Approved: '已批准',
    Processed: '已处理',
    Cancelled: '已取消',
    Hold: '暂停',
    Close: '关闭',
    Draw: '平局',
    'Bet detail': '投注详情',
    Yesterday: '昨天',
    'This week': '本周',
    'Last week': '上周',
    Viet: 'Tiếng Việt',
    Thai: 'ภาษาไทย',
    Indo: 'Bahasa indo',
    'Account disabled': '账户已禁用',
    'Invalid token': '认证无效',
    'Draw will be declared after 10-minute countdown': '持续超过10分钟的战斗将被宣布为平局。',
    Balance: '余额',
    Tnc: '条款和条件',
    Progress: '进度',
    Open: '投注开始',
    'Okay, got it.': '好的，明白了。',
    'Please come back again': '请再次回来',
    Voided: '作废',
    'Jackpot history': '奖池历史',
    'Jackpot help': '奖池帮助',
    'Lucky draw': '幸运抽奖',
    'ANTE FOR JACKPOT GAME': '奖池游戏的底注',
    'Along with your bet, a small portion (known as the "ante") is automatically collected and added to the jackpot pool. This pool is a special fund that accumulates over time, contributed to by all players participating in the game.': '与您的投注同时，一小部分（称为“底注”）会自动收集并添加到累积奖池中。这个奖池是一个特殊的基金，随着时间的推移而累积，由所有参与游戏的玩家共同贡献。',
    'ACCUMULATING PROGRESS FOR JACKPOT GAME': '奖池游戏的进度累积',
    'Each time you play, you make progress towards triggering the jackpot game. This progress is measured through a meter that fills up a little more each time you bet.': '每次您玩游戏时，都会向触发游戏奖池的目标迈进一步。这个进度通过一个计量器来计算，每次您投注时，计量器就会稍微增加一点。',
    'JACKPOT GAME OCCURRENCE': '游戏奖池',
    'Once you have accumulated enough progress, the jackpot game is triggered. This is a special event where you have the chance to win big prizes.': '一旦您累积了足够的进度，奖池游戏就会被触发。这是一个特别的事件，您有机会赢得大奖。\n\n',
    'Whether you win a Major, Minor, or Mini ticket, you\'re guaranteed an instant prize payout, with the value varying based on the type of ticket. Each ticket color represents a different prize level.': '无论您赢得大奖、小奖还是迷你奖票，您都保证能获得即时奖金支付，其价值根据票种类而有所不同。每种票的颜色代表不同的奖励级别。',
    'Each ticket type indicates the number of winners and the size of the prize. The lucky draw happens at the end of a countdown, creating anticipation and excitement. So, whether you have a Major, Minor, or Mini ticket, stay tuned for the draw to see if you\'ve won!': '每种票类型都表示了获胜者的数量和奖品的大小。幸运抽奖在倒计时结束时进行，创造了期待和兴奋。因此，无论您持有大奖、小奖还是迷你奖票，请等待抽奖结果，看看您是否赢得了奖品！',
    'Instant prize & lucky draw': '即时奖励 & 幸运抽奖',
    '{arena} Video Stream': '{arena} 视频直播',
    'Toggle video auto scale': '切换视频自动缩放',
    'Reload the streaming': '刷新直播流',
    Commission: '佣金',
    Total: '总计',
    Win: '赢',
    'Your session expired, please login again.': '您的会话已过期，请重新登录。',
    'Go to login page': '前往登录页面',
    Chinese: '简体中文',
    Statement: '对账单',
    Main: '主页',
    Limits: '限制',
    Settings: '设置',
    Notification: '通知',
    Logout: '登出',
    General: '帮助',
    'To read more': '阅读更多',
    'Jackpot prize': '奖励',
    Schedules: '赛事日历',
    'Schedule details': '赛事详情',
    Save: '保存',
    Custom: '自定义',
    Maximum: '最大限额',
    'Float Video': '浮动视频',
    Spanish: 'Español',
    Pakistan: 'اُردُو ',
    Korean: '한국어',
    Japanese: '日本語',
    'Stream locked': '直播已锁定',
    'You need at least {CURRENCY} {AMOUNT} in your wallet to watch this stream.': '您的钱包余额需至少达到 {CURRENCY} {AMOUNT} 才能观看此直播。',
    'Cockfighting Rules': '斗鸡规则',
    Burmese: 'မြန်မာဘာသာစကား',
    'Bengali-Bangladesh': 'বাংলা',
    'Traditional Chinese': '繁體中文',
    'Hindi-India': 'हिन्दी',
    Earning: '盈利',
    'Bet not successful': '下注未成功',
    'Betting is paused. Please try again shortly. E25': '投注已暂停。请稍后再试。E25',
    'Bet guide': '下注指南',
    'Placing bet': '下注方式',
    'Select bet chip': '选择下注筹码',
    'Place chip by clicking on preferred bet selection': '点击您想下注的位置放置筹码',
    'Click Bet button to confirm your bet': '点击“下注”按钮确认下注',
    'Fair game rules': '公平游戏规则',
    'Live streaming': '现场直播',
    'Unforeseen issues such as internet connectivity, power supply, or weather disruptions caused the live stream to be interrupted before the fight began.': '由于网络连接、电力供应或天气等不可预见的问题，导致比赛开始前直播中断。',
    'If the fight is not displayed on the game site, all bets will be refunded.': '如果比赛未在游戏网站显示，所有下注将会退款。',
    'Arena management decision': '赛场管理决定',
    'Arena management reserves the right to cancel any match; announcements regarding arena decisions will be made on a case-by-case basis.': '赛场管理方保留取消任何比赛的权利；有关赛场决定的公告将根据具体情况发布。',
    'Bet not closed in time': '下注未及时关闭',
    'Bets placed after the fight began will be void and refunded to members due to unforeseen technical issues.': '由于不可预见的技术问题，比赛开始后所下注单将作废并退还给会员。',
    'Terms & Conditions': '条款与条件',
    'Philippines Cockfighting': '菲律宾斗鸡',
    'Challenge Rules': '挑战规则',
    'Banker / Meron': '庄家 / Meron',
    'Player / Wala': '玩家 / Wala',
    'Draw / No Winner': '平局 / 无胜方',
    'During the Carreo Procedure (3 UP & 3 DOWN), neither rooster lands two (2) successful pecks, or': '在 Carreo 程序（3 UP & 3 DOWN）期间，若双方斗鸡均未完成两（2）次有效啄击，或',
    'No winner is declared within 10 minutes from the first contact.': '从第一次接触开始后 10 分钟内未宣布胜方。',
    '*Arena Judge decision is final.': '*赛场裁判的决定为最终决定。',
    Cambodia: '柬埔寨',
    'Cockfight Rules': '斗鸡规则',
    'Touching or Catching =': '触碰或抓住 =',
    'Automatic Loss': '自动判负',
    'No External Help': '不得外部协助',
    'No fixing, No beak adjustment': '不得修整，不得调整鸡嘴',
    'No water': '不得喂水',
    'Defeated if': '判负条件',
    'Lies Flat': '平躺',
    'Runs Away / Cries': '逃跑 / 鸣叫',
    'No Retaliation × 3': '连续三次不反击',
    'Standing beats Kneeling;': '站立胜过跪伏；',
    'Kneeling beats Lying Flat': '跪伏胜过平躺',
    'NO ABUSED or POISONING ALLOWED': '严禁虐待或投毒',
    'Tabletop Game Guide': '桌面赛游戏指南',
    'RULE: DON\'T FALL OFF!': '规则：不要掉下去！',
    'Roosters fight on the table top arena.': '斗鸡在桌面赛场上进行比赛。',
    'First rooster to touch the floor LOSES.': '第一只触碰地面的斗鸡判负。',
    'Rooster remaining on the table WINS.': '留在桌面上的斗鸡获胜。',
    'Draw when both rooster fall off at the same time': '双方斗鸡同时掉下桌面则判为平局',
    'A match is declared DRAW (NO WINNER) if:': '以下情况比赛将判定为平局（无胜方）：',
    'The match began, but Arena Management determined that cock was injured. Arena management has the right to cancel the fight if neither cock has a cut or bleed. Any other unforeseeable events.': '比赛已经开始，但赛场管理方判定斗鸡受伤。若双方斗鸡均无割伤或流血，赛场管理方有权取消比赛。以及任何其他不可预见的事件。',
    Philippines: '菲律宾',
    Tabletop: '桌面赛',
    'Max bet reached for this selection.': '该选项已达到最高投注额。',
    'This arena has ended': '本场已结束',
    'Thank you for your support': '感谢您的支持',
    Portuguese: 'Português',
    Uzbek: 'Uzbek',
  },
  vn: {
    'Khmer': 'ភាសាខ្មែរ',
    Copy: 'Sao chép',
    Copied: 'Đã sao chép',
    Oops: 'Ối',
    'We could not find the page.': 'Chúng tôi không thể tìm thấy trang này.',
    'You are not authorized to view this page.': 'Bạn không được phép xem trang này',
    'Min-max': 'tối thiểu - tối đa',
    History: 'Lịch sử',
    Help: 'Thể lệ cược',
    Banker: 'Đỏ',
    Big: 'Tài',
    Small: 'Xỉu',
    Odd: 'Lẻ',
    Even: 'Chẵn',
    Player: 'Xanh',
    Undo: 'Hoàn Trả',
    Bet: 'Cược',
    Jackpot: 'Jackpot',
    'No fight at the moment': 'Hiện tại không có trận đấu',
    'F{fightNumber} is {fightStatus}': 'F{fightNumber} là {fightStatus}',
    Hrs: 'Giờ',
    Min: 'Phút',
    Sec: 'Giây',
    'Load more': 'Tải thêm',
    loading: 'đang tải',
    'Congratulations!': 'Chúc mừng!',
    'Major ticket': 'Vé chính',
    'Claim your prize': 'Yêu cầu giải thưởng ',
    'Current jackpot': 'Jackpot hiện tại',
    'Past winner': 'Người thắng cũ',
    'My tickets': 'Vé của tôi',
    'Super draw': 'Siêu rút thăm',
    Winners: 'Người chiến thắng ',
    Today: 'Hôm nay',
    'No tickets earned': 'Không kiếm được vé',
    'You earn lucky draw ticket #{ticketId}': 'Bạn kiếm được vé rút thăm may mắn #{ticketId}',
    'Instant prize': 'Thắng nhanh',
    Date: 'Ngày',
    Time: 'Thời gian cược ',
    Ante: 'Phí đặt cược',
    Turnover: 'Doanh thu',
    Round: 'Vòng',
    All: 'Tất cả',
    'You can\'t place bet': 'Bạn không thể đặt cược',
    Odds: 'Tỷ lệ',
    Results: 'Kết quả',
    'Win/lose': 'Thắng/Thua',
    Id: 'Sảnh',
    Match: 'Trận đấu',
    'Start time': 'Bắt đầu',
    Created: 'Tạo',
    Confirmed: 'Đã xác nhận',
    Closing: 'Đóng cược',
    Closed: 'Đã đóng',
    Started: 'Đã bắt đầu',
    Ended: 'Đã kết thúc',
    Declared: 'Khai báo',
    Approved: 'Tán thành',
    Processed: 'Xử lý',
    Cancelled: 'Đã hủy',
    Hold: 'Giữ',
    Close: 'Đóng',
    Draw: 'Draw',
    'Bet detail': 'Chi tiết đặt cược',
    Yesterday: 'Hôm qua',
    'This week': 'Tuần này',
    'Last week': 'Tuần trước',
    Viet: 'Tiếng Việt',
    Thai: 'ภาษาไทย',
    Indo: 'Bahasa indo',
    'Account disabled': 'Tài khoản bị vô hiệu hóa',
    'Invalid token': 'Mã không hợp lệ',
    'Draw will be declared after 10-minute countdown': 'Trận hòa sẽ được công bố sau 10 phút đếm ngược',
    Balance: 'Quỹ',
    Tnc: 'Điều khoản và Điều kiện',
    Progress: 'Tiến triển',
    Open: 'Mở',
    'Okay, got it.': 'Được rồi hiểu rồi.',
    'Please come back again': 'Xin vui lòng quay lại sau',
    Voided: 'Vô hiệu',
    'Jackpot history': 'Lịch sử Jackpot',
    'Jackpot help': 'Trợ giúp Jackpot',
    'Lucky draw': 'Rút thăm may mắn',
    'ANTE FOR JACKPOT GAME': 'ANTE CHO TRÒ CHƠI JACKPOT',
    'Along with your bet, a small portion (known as the "ante") is automatically collected and added to the jackpot pool. This pool is a special fund that accumulates over time, contributed to by all players participating in the game.': 'Cùng với cược của bạn, một phần nhỏ (gọi là "ante") sẽ tự động được thu thập và thêm vào quỹ jackpot. Quỹ này là một khoản tiền đặc biệt tích lũy theo thời gian, do tất cả người chơi tham gia trò chơi đóng góp.',
    'ACCUMULATING PROGRESS FOR JACKPOT GAME': 'TIẾN ĐỘ TÍCH LŨY CHO TRÒ CHƠI JACKPOT\n',
    'Each time you play, you make progress towards triggering the jackpot game. This progress is measured through a meter that fills up a little more each time you bet.': 'Mỗi lần bạn chơi, bạn sẽ tiến bộ trong việc kích hoạt trò chơi jackpot. Tiến độ này được đo lường qua một mét số liệu, lấp đầy một chút mỗi lần bạn đặt cược.\n',
    'JACKPOT GAME OCCURRENCE': 'XUẤT HIỆN TRÒ CHƠI JACKPOT',
    'Once you have accumulated enough progress, the jackpot game is triggered. This is a special event where you have the chance to win big prizes.': 'Khi bạn tích lũy đủ tiến trình, trò chơi jackpot sẽ được kích hoạt. Đây là một sự kiện đặc biệt nơi bạn có cơ hội giành được những giải thưởng lớn.\n',
    'Whether you win a Major, Minor, or Mini ticket, you\'re guaranteed an instant prize payout, with the value varying based on the type of ticket. Each ticket color represents a different prize level.': 'Dù bạn giành được vé Major, Minor, hay Mini, bạn đều được đảm bảo nhận thưởng ngay lập tức, với giá trị thưởng thay đổi tùy theo loại vé. Mỗi màu vé tượng trưng cho một mức giải thưởng khác nhau.',
    'Each ticket type indicates the number of winners and the size of the prize. The lucky draw happens at the end of a countdown, creating anticipation and excitement. So, whether you have a Major, Minor, or Mini ticket, stay tuned for the draw to see if you\'ve won!': 'Mỗi loại vé chỉ ra số lượng người chiến thắng và giá trị của giải thưởng. Cuộc rút thăm may mắn sẽ diễn ra vào cuối một quãng thời gian đếm ngược, tạo nên sự hồi hộp và phấn khích. Vậy nên, dù bạn có vé Major, Minor, hay Mini, hãy chú ý theo dõi cuộc rút thăm để xem bạn có giành chiến thắng hay không!',
    'Instant prize & lucky draw': 'Thắng nhanh & Rút thăm may mắn',
    '{arena} Video Stream': '{arena} dòng video',
    'Toggle video auto scale': 'quy mô video tự động',
    'Reload the streaming': 'tải lại luồng',
    Commission: 'Hoa hồng',
    Total: 'Tổng cộng',
    Win: 'Thắng',
    'Your session expired, please login again.': 'Phiên của bạn đã hết hạn, vui lòng đăng nhập lại.',
    'Go to login page': 'Tới trang đăng nhập',
    Chinese: '简体中文',
    Statement: 'Báo cáo',
    Main: 'Trang chính',
    Limits: 'Giới hạn',
    Settings: 'Cài đặt',
    Notification: 'Thông báo',
    Logout: 'Đăng xuất',
    General: 'Chung',
    'To read more': 'Để đọc thêm',
    'Jackpot prize': 'Giải độc đắc',
    Schedules: 'Lịch trình',
    'Schedule details': 'Chi tiết lịch trình',
    Save: 'Lưu lại',
    Custom: 'Chọn ngày',
    Maximum: 'Tối đa',
    'Float Video': 'Video nổi',
    Spanish: 'Español',
    Pakistan: 'اُردُو ',
    Korean: '한국어',
    Japanese: '日本語',
    'Stream locked': 'Tiêu đề: Luồng bị khóa',
    'You need at least {CURRENCY} {AMOUNT} in your wallet to watch this stream.': 'Nội dung: Bạn cần ít nhất {CURRENCY} {AMOUNT} trong ví để xem luồng này.',
    'Cockfighting Rules': 'Luật Đá Gà',
    Burmese: 'မြန်မာဘာသာစကား',
    'Bengali-Bangladesh': 'বাংলা',
    'Traditional Chinese': '繁體中文',
    'Hindi-India': 'हिन्दी',
    Earning: 'Lợi nhuận',
    'Bet not successful': 'Cược không thành công',
    'Betting is paused. Please try again shortly. E25': 'Cược đang tạm dừng. Vui lòng thử lại sau. E25',
    'Bet guide': 'Hướng dẫn cược',
    'Placing bet': 'Đặt cược',
    'Select bet chip': 'Chọn chip cược',
    'Place chip by clicking on preferred bet selection': 'Đặt chip bằng cách nhấp vào lựa chọn cược mong muốn',
    'Click Bet button to confirm your bet': 'Nhấp nút Cược để xác nhận cược của bạn',
    'Fair game rules': 'Quy tắc trò chơi công bằng',
    'Live streaming': 'Phát trực tiếp',
    'Unforeseen issues such as internet connectivity, power supply, or weather disruptions caused the live stream to be interrupted before the fight began.': 'Các sự cố không lường trước như kết nối internet, nguồn điện hoặc thời tiết đã khiến phát trực tiếp bị gián đoạn trước khi trận đấu bắt đầu.',
    'If the fight is not displayed on the game site, all bets will be refunded.': 'Nếu trận đấu không hiển thị trên trang game, tất cả cược sẽ được hoàn trả.',
    'Arena management decision': 'Quyết định của ban quản lý trường đấu',
    'Arena management reserves the right to cancel any match; announcements regarding arena decisions will be made on a case-by-case basis.': 'Ban quản lý trường đấu có quyền hủy bất kỳ trận đấu nào; thông báo về quyết định của trường đấu sẽ được đưa ra tùy từng trường hợp.',
    'Bet not closed in time': 'Cược không được đóng kịp thời',
    'Bets placed after the fight began will be void and refunded to members due to unforeseen technical issues.': 'Các cược đặt sau khi trận đấu bắt đầu sẽ bị hủy và hoàn trả cho thành viên do sự cố kỹ thuật không lường trước.',
    'Terms & Conditions': 'Điều khoản & Điều kiện',
    'Philippines Cockfighting': 'Đá gà Philippines',
    'Challenge Rules': 'Quy tắc thách đấu',
    'Banker / Meron': 'Banker / Meron',
    'Player / Wala': 'Player / Wala',
    'Draw / No Winner': 'Hòa / Không có người thắng',
    'During the Carreo Procedure (3 UP & 3 DOWN), neither rooster lands two (2) successful pecks, or': 'Trong quy trình Carreo (3 UP & 3 DOWN), nếu không có gà nào mổ trúng hai (2) lần thành công, hoặc',
    'No winner is declared within 10 minutes from the first contact.': 'Không có người thắng được công bố trong vòng 10 phút kể từ lần tiếp xúc đầu tiên.',
    '*Arena Judge decision is final.': '*Quyết định của trọng tài trường đấu là quyết định cuối cùng.',
    Cambodia: 'Campuchia',
    'Cockfight Rules': 'Quy tắc đá gà',
    'Touching or Catching =': 'Chạm hoặc bắt =',
    'Automatic Loss': 'Tự động thua',
    'No External Help': 'Không được hỗ trợ từ bên ngoài',
    'No fixing, No beak adjustment': 'Không sửa chữa, không chỉnh mỏ',
    'No water': 'Không cho nước',
    'Defeated if': 'Bị xử thua nếu',
    'Lies Flat': 'Nằm bẹp',
    'Runs Away / Cries': 'Bỏ chạy / Kêu la',
    'No Retaliation × 3': 'Không phản công × 3',
    'Standing beats Kneeling;': 'Đứng thắng quỳ;',
    'Kneeling beats Lying Flat': 'Quỳ thắng nằm bẹp',
    'NO ABUSED or POISONING ALLOWED': 'NGHIÊM CẤM NGƯỢC ĐÃI HOẶC ĐẦU ĐỘC',
    'Tabletop Game Guide': 'Hướng dẫn game đá gà trên bàn',
    'RULE: DON\'T FALL OFF!': 'QUY TẮC: KHÔNG ĐƯỢC RƠI XUỐNG!',
    'Roosters fight on the table top arena.': 'Gà đá thi đấu trên sàn bàn.',
    'First rooster to touch the floor LOSES.': 'Gà đầu tiên chạm sàn sẽ THUA.',
    'Rooster remaining on the table WINS.': 'Gà còn lại trên bàn sẽ THẮNG.',
    'Draw when both rooster fall off at the same time': 'Hòa khi cả hai gà rơi khỏi bàn cùng lúc',
    'A match is declared DRAW (NO WINNER) if:': 'Một trận đấu được tuyên bố HÒA (KHÔNG CÓ NGƯỜI THẮNG) nếu:',
    'The match began, but Arena Management determined that cock was injured. Arena management has the right to cancel the fight if neither cock has a cut or bleed. Any other unforeseeable events.': 'Trận đấu đã bắt đầu, nhưng ban quản lý trường đấu xác định gà bị thương. Ban quản lý trường đấu có quyền hủy trận đấu nếu không có gà nào bị cắt hoặc chảy máu. Hoặc có bất kỳ sự kiện không lường trước nào khác.',
    Philippines: 'Philippines',
    Tabletop: 'Đá gà trên bàn',
    'Max bet reached for this selection.': 'Lựa chọn này đã đạt mức cược tối đa.',
    'This arena has ended': 'Đấu trường này đã kết thúc',
    'Thank you for your support': 'Cảm ơn bạn đã ủng hộ',
    Portuguese: 'Português',
    Uzbek: 'Uzbek',
  },
  th: {
    'Khmer': 'ភាសាខ្មែរ',
    Copy: 'คัดลอก',
    Copied: 'คัดลอกแล้ว',
    Oops: 'อุ๊ปส์',
    'We could not find the page.': 'ไม่พบข้อมูล',
    'You are not authorized to view this page.': 'ไม่ได้รับอนุญาตให้ดูหน้านี้',
    'Min-max': 'ขั้นต่ำ/สุงสุด',
    History: 'ประวัติ',
    Help: 'ช่วยเหลือ',
    Banker: 'Banker',
    Player: 'Player',
    Undo: 'ยกเลิก',
    Bet: 'เดิมพัน',
    Jackpot: 'แจ็คพอต',
    'No fight at the moment': 'ไม่มีการแข่งขันในขณะนี้!',
    'F{fightNumber} is {fightStatus}': 'F{fightNumber} {fightStatus}',
    Hrs: 'ชั่วโมง',
    Min: 'นาที',
    Sec: 'วินาที',
    'Load more': 'โหลดเพิ่ม',
    loading: 'กำลังโหลด',
    'Congratulations!': 'ยินดีด้วย!',
    'Major ticket': 'ตั๋วหลัก',
    'Claim your prize': 'รับรางวัล',
    'Current jackpot': 'แจ็คพอตปัจจุบัน',
    'Past winner': 'ผู้ชนะที่ผ่านมา',
    'My tickets': 'รายการประวัติ',
    'Super draw': 'จับรางวัลใหญ่',
    Winners: 'ผู้ชนะ',
    Today: 'วันนี้',
    'No tickets earned': 'ไม่มีรายการได้รับ',
    'You earn lucky draw ticket #{ticketId}': 'คุณได้รับตั๋วจับรางวัล #{ticketId}',
    'Instant prize': 'รางวัลทันที',
    Date: 'วันที่',
    Time: 'เวลา',
    Ante: 'อันเต้',
    'You can\'t place bet': 'คุณไม่สามารถวางเดิมพันได้',
    Odds: 'ราคาต่อรอง',
    Results: 'ผลลัพธ์',
    'Win/lose': 'ชนะ/แพ้',
    Id: 'Id',
    Match: 'จับคู่',
    'Start time': 'เวลาเริ่มต้น',
    Created: 'สร้าง',
    Confirmed: 'ยืนยันแล้ว',
    Closing: 'ปิดเร็ว ๆ นี้',
    Closed: 'ปิด',
    Started: 'เริ่ม',
    Ended: 'สิ้นสุดแล้ว',
    Declared: 'ประกาศ',
    Approved: 'อนุมัติ',
    Processed: 'ดำเนินการแล้ว',
    Cancelled: 'ยกเลิก',
    Hold: 'ถือ',
    Close: 'ปิด',
    Draw: 'เสมอ',
    'Bet detail': 'รายละเอียดการเดิมพัน',
    Yesterday: 'เมื่อวาน',
    'This week': 'ในสัปดาห์นี้',
    'Last week': 'อาทิตย์ที่แล้ว',
    Viet: 'Tiếng Việt',
    Thai: 'ภาษาไทย',
    Indo: 'Bahasa indo',
    'Account disabled': 'บัญชีถูกปิดใช้งาน',
    'Invalid token': 'การเข้าสู่ระบบไม่ถูกต้อง, โปรดลองใหม่',
    'Draw will be declared after 10-minute countdown': 'การจับฉลากจะประกาศหลังจากนับถอยหลัง 10 นาที',
    Balance: 'ยอดตงเหลือ',
    Tnc: 'ข้อกำหนดและเงื่อนไข',
    Progress: 'ความคืบหน้า',
    Open: 'กำลังดำเนินการแข่งขัน',
    'Okay, got it.': 'โอเค เข้าใจแล้ว',
    'Please come back again': 'กรุณากลับมาอีกครั้ง',
    Voided: 'เป็นโมฆะ',
    'Jackpot history': 'ประวัติแจ็คพอต',
    'Jackpot help': 'ช่วยเหลือ',
    'Lucky draw': 'สุ่มรางวัลจับฉลาก',
    'ANTE FOR JACKPOT GAME': 'การเดิมพันเพื่อเข้าร่วมเกมแจ็คพอต\n',
    'Along with your bet, a small portion (known as the "ante") is automatically collected and added to the jackpot pool. This pool is a special fund that accumulates over time, contributed to by all players participating in the game.': 'พร้อมกับการเดิมพันของคุณ, ส่วนเล็กๆ (ที่เรียกว่า "การเดิมพันแรก") จะถูกเก็บไว้โดยอัตโนมัติและเพิ่มเข้าไปในกองเงินแจ็คพอต. กองเงินนี้เป็นกองทุนพิเศษที่สะสมไปเรื่อยๆ โดยมีการสนับสนุนจากผู้เล่นทุกคนที่เข้าร่วมเกม.\n',
    'ACCUMULATING PROGRESS FOR JACKPOT GAME': 'สะสมความคืบหน้าเพื่อเกมแจ็คพอต\n',
    'Each time you play, you make progress towards triggering the jackpot game. This progress is measured through a meter that fills up a little more each time you bet.': 'ทุกครั้งที่คุณเล่น, คุณจะทำความคืบหน้าเพื่อเปิดใช้งานเกมแจ็คพอต. ความคืบหน้านี้จะถูกวัดผ่านมิเตอร์ที่เติมขึ้นเล็กน้อยทุกครั้งที่คุณวางเดิมพัน.\n',
    'JACKPOT GAME OCCURRENCE': 'เกิดเหตุการณ์เกมแจ็คพอต',
    'Once you have accumulated enough progress, the jackpot game is triggered. This is a special event where you have the chance to win big prizes.': 'เมื่อคุณสะสมความคืบหน้าได้เพียงพอ, เกมแจ็คพอตจะถูกเริ่มต้น. นี่คือเหตุการณ์พิเศษที่คุณมีโอกาสชนะรางวัลใหญ่.',
    'Whether you win a Major, Minor, or Mini ticket, you\'re guaranteed an instant prize payout, with the value varying based on the type of ticket. Each ticket color represents a different prize level.': 'ไม่ว่าคุณจะชนะตั๋ว Major, Minor, หรือ Mini, คุณจะได้รับการจ่ายรางวัลทันที, โดยมูลค่าของรางวัลจะแตกต่างกันไปตามประเภทของตั๋ว. สีของตั๋วแต่ละสีแทนระดับรางวัลที่แตกต่างกัน.\n',
    'Each ticket type indicates the number of winners and the size of the prize. The lucky draw happens at the end of a countdown, creating anticipation and excitement. So, whether you have a Major, Minor, or Mini ticket, stay tuned for the draw to see if you\'ve won!': 'ประเภทตั๋วแต่ละประเภทจะบ่งบอกถึงจำนวนผู้ชนะและขนาดของรางวัล. การจับฉลากโชคดีจะเกิดขึ้นที่ปลายของการนับถอยหลัง, สร้างความตื่นเต้นและความคาดหวัง. ดังนั้น, ไม่ว่าคุณจะมีตั๋ว Major, Minor, หรือ Mini, โปรดติดตามการจับฉลากเพื่อดูว่าคุณชนะหรือไม่!\n',
    'Instant prize & lucky draw': 'รางวัลด่วน & จับฉลากรางวัล',
    '{arena} Video Stream': '{arena} ถ่ายทอดสด',
    'Toggle video auto scale': 'ปรับขนาดวิดีโอ',
    'Reload the streaming': 'โหลดวิดีโอซ้ำ',
    Commission: 'คอมมิชชั่น',
    Total: 'ทั้งหมด',
    Win: 'ชนะ',
    'Your session expired, please login again.': 'เซสชั่นของคุณหมดอายุแล้ว กรุณาเข้าสู่ระบบอีกครั้ง',
    'Go to login page': 'กลับไปล็อคอิน',
    Chinese: '简体中文',
    Statement: 'รายการบัญชี',
    Main: 'หน้าหลัก',
    Limits: 'จำกัดเดิมพัน',
    Settings: 'การตั้งค่า',
    Notification: 'การแจ้งเตือน',
    Logout: 'ออกจากระบบ',
    General: 'ทั่วไป',
    'To read more': 'อ่านเพิ่มเติม',
    'Jackpot prize': 'รางวัลแจ็คพอต',
    Schedules: 'ตารางเวลา',
    'Schedule details': 'รายละเอียดแข่งขัน',
    Save: 'บันทึก',
    Custom: 'กำหนด',
    Maximum: 'สูงสุด',
    'Float Video': 'วิดีโอลอย',
    Spanish: 'Español',
    Pakistan: 'اُردُو ',
    Korean: '한국어',
    Japanese: '日本語',
    'Stream locked': 'หัวข้อ: สตรีมถูกล็อก',
    'You need at least {CURRENCY} {AMOUNT} in your wallet to watch this stream.': 'ข้อความ: คุณต้องมียอดเงินอย่างน้อย {CURRENCY} {AMOUNT} ในกระเป๋าเงินจึงจะรับชมสตรีมนี้ได้',
    'Cockfighting Rules': 'กติกาการชนไก่',
    Burmese: 'မြန်မာဘာသာစကား',
    'Bengali-Bangladesh': 'বাংলা',
    'Traditional Chinese': '繁體中文',
    'Hindi-India': 'हिन्दी',
    Earning: 'กำไร',
    'Bet not successful': 'เดิมพันไม่สำเร็จ',
    'Betting is paused. Please try again shortly. E25': 'การวางเดิมพันถูกหยุดชั่วคราว กรุณาลองใหม่อีกครั้งในไม่ช้า E25',
    'Bet guide': 'คู่มือการเดิมพัน',
    'Placing bet': 'การวางเดิมพัน',
    'Select bet chip': 'เลือกชิปเดิมพัน',
    'Place chip by clicking on preferred bet selection': 'วางชิปโดยคลิกตัวเลือกเดิมพันที่ต้องการ',
    'Click Bet button to confirm your bet': 'คลิกปุ่มเดิมพันเพื่อยืนยันการเดิมพันของคุณ',
    'Fair game rules': 'กติกาเกมที่เป็นธรรม',
    'Live streaming': 'ถ่ายทอดสด',
    'Unforeseen issues such as internet connectivity, power supply, or weather disruptions caused the live stream to be interrupted before the fight began.': 'ปัญหาที่ไม่คาดคิด เช่น การเชื่อมต่ออินเทอร์เน็ต ไฟฟ้า หรือสภาพอากาศ ทำให้การถ่ายทอดสดถูกขัดจังหวะก่อนการชกเริ่มต้น',
    'If the fight is not displayed on the game site, all bets will be refunded.': 'หากการแข่งขันไม่แสดงบนเว็บไซต์เกม เดิมพันทั้งหมดจะถูกคืนเงิน',
    'Arena management decision': 'การตัดสินใจของฝ่ายจัดการสนาม',
    'Arena management reserves the right to cancel any match; announcements regarding arena decisions will be made on a case-by-case basis.': 'ฝ่ายจัดการสนามขอสงวนสิทธิ์ในการยกเลิกการแข่งขันใด ๆ โดยประกาศเกี่ยวกับการตัดสินใจของสนามจะพิจารณาเป็นกรณีไป',
    'Bet not closed in time': 'ปิดรับเดิมพันไม่ทันเวลา',
    'Bets placed after the fight began will be void and refunded to members due to unforeseen technical issues.': 'การเดิมพันที่วางหลังจากการชกเริ่มต้นแล้วจะถือเป็นโมฆะและคืนเงินให้สมาชิก เนื่องจากปัญหาทางเทคนิคที่ไม่คาดคิด',
    'Terms & Conditions': 'ข้อกำหนดและเงื่อนไข',
    'Philippines Cockfighting': 'ไก่ชนฟิลิปปินส์',
    'Challenge Rules': 'กติกาการท้าชน',
    'Banker / Meron': 'เจ้ามือ / Meron',
    'Player / Wala': 'ผู้เล่น / Wala',
    'Draw / No Winner': 'เสมอ / ไม่มีผู้ชนะ',
    'During the Carreo Procedure (3 UP & 3 DOWN), neither rooster lands two (2) successful pecks, or': 'ระหว่างขั้นตอน Carreo (3 UP & 3 DOWN) หากไม่มีไก่ตัวใดจิกสำเร็จสอง (2) ครั้ง หรือ',
    'No winner is declared within 10 minutes from the first contact.': 'ไม่มีการประกาศผู้ชนะภายใน 10 นาที นับจากการสัมผัสครั้งแรก',
    '*Arena Judge decision is final.': '*คำตัดสินของกรรมการสนามถือเป็นที่สิ้นสุด',
    Cambodia: 'กัมพูชา',
    'Cockfight Rules': 'กติกาไก่ชน',
    'Touching or Catching =': 'การแตะหรือการจับ =',
    'Automatic Loss': 'แพ้อัตโนมัติ',
    'No External Help': 'ห้ามความช่วยเหลือจากภายนอก',
    'No fixing, No beak adjustment': 'ห้ามแก้ไข ห้ามปรับจะงอยปาก',
    'No water': 'ห้ามให้น้ำ',
    'Defeated if': 'ถือว่าแพ้หาก',
    'Lies Flat': 'นอนราบ',
    'Runs Away / Cries': 'วิ่งหนี / ร้อง',
    'No Retaliation × 3': 'ไม่โต้กลับ × 3',
    'Standing beats Kneeling;': 'ยืนชนะคุกเข่า;',
    'Kneeling beats Lying Flat': 'คุกเข่าชนะนอนราบ',
    'NO ABUSED or POISONING ALLOWED': 'ห้ามทารุณกรรมหรือวางยาโดยเด็ดขาด',
    'Tabletop Game Guide': 'คู่มือเกมโต๊ะไก่ชน',
    'RULE: DON\'T FALL OFF!': 'กติกา: อย่าตกจากโต๊ะ!',
    'Roosters fight on the table top arena.': 'ไก่ชนต่อสู้กันบนสนามโต๊ะ',
    'First rooster to touch the floor LOSES.': 'ไก่ตัวแรกที่แตะพื้นจะแพ้',
    'Rooster remaining on the table WINS.': 'ไก่ที่ยังอยู่บนโต๊ะจะชนะ',
    'Draw when both rooster fall off at the same time': 'เสมอเมื่อไก่ทั้งสองตัวตกจากโต๊ะพร้อมกัน',
    'A match is declared DRAW (NO WINNER) if:': 'การแข่งขันจะถูกประกาศว่าเสมอ ไม่มีผู้ชนะ หาก:',
    'The match began, but Arena Management determined that cock was injured. Arena management has the right to cancel the fight if neither cock has a cut or bleed. Any other unforeseeable events.': 'การแข่งขันเริ่มแล้ว แต่ฝ่ายจัดการสนามพิจารณาว่าไก่ได้รับบาดเจ็บ ฝ่ายจัดการสนามมีสิทธิ์ยกเลิกการแข่งขัน หากไก่ทั้งสองตัวไม่มีบาดแผลหรือเลือดออก รวมถึงเหตุการณ์ไม่คาดคิดอื่น ๆ',
    Philippines: 'ฟิลิปปินส์',
    Tabletop: 'โต๊ะไก่ชน',
    'Max bet reached for this selection.': 'ตัวเลือกนี้ถึงวงเงินเดิมพันสูงสุดแล้ว',
    'This arena has ended': 'สนามนี้สิ้นสุดแล้ว',
    'Thank you for your support': 'ขอบคุณสำหรับการสนับสนุน',
    Portuguese: 'Português',
    Uzbek: 'Uzbek',
  },
  id: {
    'Khmer': 'ភាសាខ្មែរ',
    Copy: 'Menyalin',
    Copied: 'Disalin',
    Oops: 'Ups',
    'We could not find the page.': 'Kami tidak dapat menemukan halaman tersebut.',
    'You are not authorized to view this page.': 'Anda tidak berwenang untuk melihat halaman ini.',
    'Min-max': 'Min-Maks',
    History: 'Sejarah',
    Help: 'Membantu',
    Banker: 'Banker',
    Player: 'Player',
    Undo: 'Membuka',
    Bet: 'Bet',
    Jackpot: 'Jackpot',
    'No fight at the moment': 'Tidak ada pertarungan saat ini!',
    'F{fightNumber} is {fightStatus}': 'F{fightNumber} di {fightStatus}',
    Hrs: 'Jam',
    Min: 'Menit',
    Sec: 'Detik',
    'Load more': 'Muat lebih banyak',
    loading: 'memuat',
    'Congratulations!': 'Selamat!',
    'Major ticket': 'Tiket utama',
    'Claim your prize': 'Klaim hadiah Anda',
    'Current jackpot': 'Jackpot saat ini',
    'Past winner': 'Pemenang',
    'My tickets': 'Tiket saya',
    'Super draw': 'Undian Super',
    Winners: 'Pemenang',
    Today: 'Hari ini',
    'No tickets earned': 'Tidak ada tiket yang diperoleh',
    'You earn lucky draw ticket #{ticketId}': 'Anda mendapatkan tiket undian berhadiah #{ticketId}',
    'Instant prize': 'Hadiah instan',
    Date: 'Tanggal',
    Time: 'Waktu',
    Ante: 'Ante',
    'You can\'t place bet': 'Anda tidak dapat memasang taruhan',
    Odds: 'Peluang',
    Results: 'Hasil',
    'Win/lose': 'M/K',
    Id: 'Id',
    Match: 'Kontes',
    'Start time': 'Waktu mulai',
    Created: 'Dibuat',
    Confirmed: 'Dikonfirmasi',
    Closing: 'Penutupan',
    Closed: 'Tertutup',
    Started: 'Dimulai',
    Ended: 'Berakhir',
    Declared: 'Dinyatakan',
    Approved: 'Disetujui',
    Processed: 'Diproses',
    Cancelled: 'Dibatalkan',
    Hold: 'Memegang',
    Close: 'Menutup',
    Draw: 'Draw',
    'Bet detail': 'Detail taruhan',
    Yesterday: 'Kemarin',
    'This week': 'Minggu ini',
    'Last week': 'Minggu lalu',
    Viet: 'Tiếng Việt',
    Thai: 'ภาษาไทย',
    Indo: 'Bahasa indo',
    'Account disabled': 'Akun dinonaktifkan',
    'Invalid token': 'Token tidak valid',
    'Draw will be declared after 10-minute countdown': 'Pengundian akan diumumkan setelah hitungan mundur 10 menit',
    Balance: 'Dana',
    Tnc: 'S&K',
    Progress: 'Kemajuan',
    Open: 'Membuka',
    'Okay, got it.': 'OK saya mengerti.',
    'Please come back again': 'Silakan kembali lagi',
    Voided: 'Tidak berlaku',
    'Jackpot history': 'Riwayat Jackpot',
    'Jackpot help': 'Bantuan Jackpot',
    'Lucky draw': 'Undian Beruntung',
    'ANTE FOR JACKPOT GAME': 'ANTE UNTUK PERMAINAN JACKPOT',
    'Along with your bet, a small portion (known as the "ante") is automatically collected and added to the jackpot pool. This pool is a special fund that accumulates over time, contributed to by all players participating in the game.': 'Bersamaan dengan taruhan Anda, sebuah bagian kecil (dikenal sebagai "ante") secara otomatis dikumpulkan dan ditambahkan ke kolam jackpot. Kolam ini adalah dana khusus yang terakumulasi dari waktu ke waktu, dengan kontribusi dari semua pemain yang berpartisipasi dalam permainan.\n',
    'ACCUMULATING PROGRESS FOR JACKPOT GAME': 'MENGAKUMULASI PROGRES UNTUK PERMAINAN JACKPOT',
    'Each time you play, you make progress towards triggering the jackpot game. This progress is measured through a meter that fills up a little more each time you bet.': 'Setiap kali Anda bermain, Anda membuat kemajuan menuju pemicu permainan jackpot. Kemajuan ini diukur melalui sebuah meter yang terisi sedikit lebih banyak setiap kali Anda bertaruh.',
    'JACKPOT GAME OCCURRENCE': 'TERJADINYA PERMAINAN JACKPOT',
    'Once you have accumulated enough progress, the jackpot game is triggered. This is a special event where you have the chance to win big prizes.': 'Setelah Anda mengakumulasi cukup progres, permainan jackpot dipicu. Ini adalah sebuah acara spesial di mana Anda memiliki kesempatan untuk memenangkan hadiah besar.',
    'Whether you win a Major, Minor, or Mini ticket, you\'re guaranteed an instant prize payout, with the value varying based on the type of ticket. Each ticket color represents a different prize level.': 'Baik Anda memenangkan tiket Mayor, Minor, atau Mini, Anda dijamin mendapatkan pembayaran hadiah seketika, dengan nilai bervariasi berdasarkan jenis tiket. Setiap warna tiket mewakili level hadiah yang berbeda.\n',
    'Each ticket type indicates the number of winners and the size of the prize. The lucky draw happens at the end of a countdown, creating anticipation and excitement. So, whether you have a Major, Minor, or Mini ticket, stay tuned for the draw to see if you\'ve won!': 'Setiap jenis tiket menunjukkan jumlah pemenang dan besaran hadiah. Pengundian beruntung terjadi di akhir hitungan mundur, menciptakan antisipasi dan kegembiraan. Jadi, apakah Anda memiliki tiket Mayor, Minor, atau Mini, tetaplah pantau pengundian untuk melihat apakah Anda menang!\n',
    'Instant prize & lucky draw': 'Hadiah instan & Undian Beruntung',
    '{arena} Video Stream': '{arena} aliran video',
    'Toggle video auto scale': 'skala otomatis video',
    'Reload the streaming': 'memuat ulang aliran',
    Commission: 'Komisi',
    Total: 'Total',
    Win: 'Menang',
    'Your session expired, please login again.': 'Sesi Anda telah habis, silakan login kembali.',
    'Go to login page': 'Buka halaman masuk',
    Chinese: '简体中文',
    Statement: 'Pernyataan',
    Main: 'Halaman Utama',
    Limits: 'Batasan',
    Settings: 'Pengaturan',
    Notification: 'Notifikasi',
    Logout: 'Keluar',
    General: 'Umum',
    'To read more': 'Untuk membaca lebih lanjut',
    'Jackpot prize': 'Hadiah Jackpot',
    Schedules: 'Jadwal',
    'Schedule details': 'Detail Jadwal',
    Save: 'Simpan',
    Custom: 'Adat',
    Maximum: 'Maksimum',
    'Float Video': 'Video mengambang',
    Spanish: 'Español',
    Pakistan: 'اُردُو ',
    Korean: '한국어',
    Japanese: '日本語',
    'Stream locked': 'Judul: Stream terkunci',
    'You need at least {CURRENCY} {AMOUNT} in your wallet to watch this stream.': 'Isi: Anda memerlukan saldo minimal {CURRENCY} {AMOUNT} di dompet untuk menonton stream ini.',
    'Cockfighting Rules': 'Peraturan',
    Burmese: 'မြန်မာဘာသာစကား',
    'Bengali-Bangladesh': 'বাংলা',
    'Traditional Chinese': '繁體中文',
    'Hindi-India': 'हिन्दी',
    Earning: 'Keuntungan',
    'Bet not successful': 'Taruhan tidak berhasil',
    'Betting is paused. Please try again shortly. E25': 'Taruhan sedang dijeda. Silakan coba lagi sebentar lagi. E25',
    'Bet guide': 'Panduan taruhan',
    'Placing bet': 'Memasang taruhan',
    'Select bet chip': 'Pilih chip taruhan',
    'Place chip by clicking on preferred bet selection': 'Tempatkan chip dengan mengklik pilihan taruhan yang diinginkan',
    'Click Bet button to confirm your bet': 'Klik tombol Bet untuk mengonfirmasi taruhan Anda',
    'Fair game rules': 'Aturan permainan yang adil',
    'Live streaming': 'Siaran langsung',
    'Unforeseen issues such as internet connectivity, power supply, or weather disruptions caused the live stream to be interrupted before the fight began.': 'Masalah tak terduga seperti koneksi internet, pasokan listrik, atau gangguan cuaca menyebabkan siaran langsung terputus sebelum pertandingan dimulai.',
    'If the fight is not displayed on the game site, all bets will be refunded.': 'Jika pertandingan tidak ditampilkan di situs game, semua taruhan akan dikembalikan.',
    'Arena management decision': 'Keputusan manajemen arena',
    'Arena management reserves the right to cancel any match; announcements regarding arena decisions will be made on a case-by-case basis.': 'Manajemen arena berhak membatalkan pertandingan apa pun; pengumuman terkait keputusan arena akan dibuat berdasarkan kasus per kasus.',
    'Bet not closed in time': 'Taruhan tidak ditutup tepat waktu',
    'Bets placed after the fight began will be void and refunded to members due to unforeseen technical issues.': 'Taruhan yang dipasang setelah pertandingan dimulai akan dibatalkan dan dikembalikan kepada anggota karena masalah teknis yang tidak terduga.',
    'Terms & Conditions': 'Syarat & Ketentuan',
    'Philippines Cockfighting': 'Sabung Ayam Filipina',
    'Challenge Rules': 'Aturan Tantangan',
    'Banker / Meron': 'Banker / Meron',
    'Player / Wala': 'Player / Wala',
    'Draw / No Winner': 'Seri / Tidak Ada Pemenang',
    'During the Carreo Procedure (3 UP & 3 DOWN), neither rooster lands two (2) successful pecks, or': 'Selama Prosedur Carreo (3 UP & 3 DOWN), jika tidak ada ayam yang berhasil melakukan dua (2) patukan, atau',
    'No winner is declared within 10 minutes from the first contact.': 'Tidak ada pemenang yang diumumkan dalam waktu 10 menit sejak kontak pertama.',
    '*Arena Judge decision is final.': '*Keputusan juri arena bersifat final.',
    Cambodia: 'Kamboja',
    'Cockfight Rules': 'Aturan Sabung Ayam',
    'Touching or Catching =': 'Menyentuh atau Menangkap =',
    'Automatic Loss': 'Kalah Otomatis',
    'No External Help': 'Tidak Ada Bantuan dari Luar',
    'No fixing, No beak adjustment': 'Tidak boleh memperbaiki, tidak boleh menyesuaikan paruh',
    'No water': 'Tidak boleh memberi air',
    'Defeated if': 'Dinyatakan kalah jika',
    'Lies Flat': 'Berbaring rata',
    'Runs Away / Cries': 'Lari / Berkokok menangis',
    'No Retaliation × 3': 'Tidak membalas serangan × 3',
    'Standing beats Kneeling;': 'Berdiri mengalahkan Berlutut;',
    'Kneeling beats Lying Flat': 'Berlutut mengalahkan Berbaring rata',
    'NO ABUSED or POISONING ALLOWED': 'DILARANG KERAS MELAKUKAN PENYIKSAAN ATAU PERACUNAN',
    'Tabletop Game Guide': 'Panduan Game Meja',
    'RULE: DON\'T FALL OFF!': 'ATURAN: JANGAN JATUH!',
    'Roosters fight on the table top arena.': 'Ayam bertarung di arena atas meja.',
    'First rooster to touch the floor LOSES.': 'Ayam pertama yang menyentuh lantai KALAH.',
    'Rooster remaining on the table WINS.': 'Ayam yang tetap berada di atas meja MENANG.',
    'Draw when both rooster fall off at the same time': 'Seri jika kedua ayam jatuh dari meja pada waktu yang sama',
    'A match is declared DRAW (NO WINNER) if:': 'Pertandingan dinyatakan SERI (TIDAK ADA PEMENANG) jika:',
    'The match began, but Arena Management determined that cock was injured. Arena management has the right to cancel the fight if neither cock has a cut or bleed. Any other unforeseeable events.': 'Pertandingan telah dimulai, tetapi Manajemen Arena menentukan bahwa ayam terluka. Manajemen arena berhak membatalkan pertandingan jika tidak ada ayam yang terluka atau berdarah. Termasuk kejadian tak terduga lainnya.',
    Philippines: 'Filipina',
    Tabletop: 'Meja',
    'Max bet reached for this selection.': 'Batas taruhan tercapai.',
    'This arena has ended': 'Arena ini telah berakhir',
    'Thank you for your support': 'Terima kasih atas dukungan Anda',
    Portuguese: 'Português',
    Uzbek: 'Uzbek',
  },
  es: {
    'Khmer': 'ភាសាខ្មែរ',
    Copy: 'Copiar',
    Copied: 'Copiado',
    Oops: 'Ups',
    'We could not find the page.': 'No pudimos encontrar la página.',
    'You are not authorized to view this page.': 'No estás autorizado para ver esta página.',
    'Min-max': 'Mín-max',
    History: 'Historial',
    Help: 'Ayuda',
    Banker: 'Banker',
    Player: 'Player',
    Undo: 'Deshacer',
    Bet: 'Apuesta',
    Jackpot: 'Jackpot',
    'No fight at the moment': 'No hay peleas en este momento',
    'F{fightNumber} is {fightStatus}': 'La pelea {fightNumber} está {fightStatus}',
    Hrs: 'Hrs',
    Min: 'Min',
    Sec: 'Seg',
    'Load more': 'Cargar más',
    loading: 'cargando',
    'Congratulations!': '¡Felicidades!',
    'Major ticket': 'Boleto mayor',
    'Claim your prize': 'Reclama tu premio',
    'Current jackpot': 'Jackpot actual',
    'Past winner': 'Ganador anterior',
    'My tickets': 'Mis boletos',
    'Super draw': 'Sorteo especial',
    Winners: 'Ganadores',
    Today: 'Hoy',
    'No tickets earned': 'No se han ganado boletos',
    'You earn lucky draw ticket #{ticketId}': 'Has ganado el boleto de sorteo de la suerte #{ticketId}',
    'Instant prize': 'Premio instantáneo',
    Date: 'Fecha',
    Time: 'Hora',
    Ante: 'La cuota',
    'You can\'t place bet': 'No puedes realizar la apuesta',
    Odds: 'Probabilidades',
    Results: 'Resultados',
    'Win/lose': 'Ganar/perder',
    Id: 'Id',
    Match: 'Partido',
    'Start time': 'Hora de inicio',
    Created: 'Creado',
    Confirmed: 'Confirmado',
    Closing: 'Cerrando',
    Closed: 'Cerrado',
    Started: 'Iniciado',
    Ended: 'Terminado',
    Declared: 'Declarado',
    Approved: 'Aprobado',
    Processed: 'Procesado',
    Cancelled: 'Cancelado',
    Hold: 'Mantener',
    Close: 'Cerrar',
    Draw: 'Empate',
    'Bet detail': 'Detalle de la apuesta',
    Yesterday: 'Ayer',
    'This week': 'Esta semana',
    'Last week': 'La semana pasada',
    Viet: 'Tiếng Việt',
    Thai: 'ภาษาไทย',
    Indo: 'Bahasa indo',
    'Account disabled': 'Cuenta deshabilitada',
    'Invalid token': 'Token inválido',
    'Draw will be declared after 10-minute countdown': 'El empate se declarará después de una cuenta regresiva de 10 minutos',
    Balance: 'Saldo',
    Tnc: 'Términos y condiciones',
    Progress: 'Progreso',
    Open: 'Abierto',
    'Okay, got it.': 'Está bien, entendido.',
    'Please come back again': 'Por favor, vuelve otra vez',
    Voided: 'Anulado',
    'Jackpot history': 'Historial de Jackpot',
    'Jackpot help': 'Ayuda de Jackpot',
    'Lucky draw': 'Sorteo de la suerte',
    'ANTE FOR JACKPOT GAME': 'APOSTAR PARA EL JUEGO DE JACKPOT ',
    'Along with your bet, a small portion (known as the "ante") is automatically collected and added to the jackpot pool. This pool is a special fund that accumulates over time, contributed to by all players participating in the game.': 'Junto con tu apuesta, se recoge automáticamente una pequeña parte (conocida como el "ante") y se añade al fondo del jackpot. Este fondo es un fondo especial que se acumula con el tiempo, contribuido por todos los jugadores que participan en el juego.',
    'ACCUMULATING PROGRESS FOR JACKPOT GAME': 'PROGRESO ACUMULADO PARA EL JUEGO DE JACKPOT ',
    'Each time you play, you make progress towards triggering the jackpot game. This progress is measured through a meter that fills up a little more each time you bet.': 'Cada vez que juegas, haces progreso hacia activar el juego de jackpot. Este progreso se mide a través de un medidor que se llena un poco más cada vez que apuestas.',
    'JACKPOT GAME OCCURRENCE': 'OCURRENCIA DEL JUEGO DE JACKPOT ',
    'Once you have accumulated enough progress, the jackpot game is triggered. This is a special event where you have the chance to win big prizes.': 'Una vez que has acumulado suficiente progreso, se activa el juego de jackpot. Este es un evento especial donde tienes la oportunidad de ganar grandes premios. ',
    'Whether you win a Major, Minor, or Mini ticket, you\'re guaranteed an instant prize payout, with the value varying based on the type of ticket. Each ticket color represents a different prize level.': 'Ya sea que ganes un boleto Mayor, Menor o Mini, tienes garantizado un pago de premio instantáneo, con el valor variando según el tipo de boleto. Cada color de boleto representa un nivel de premio diferente.',
    'Each ticket type indicates the number of winners and the size of the prize. The lucky draw happens at the end of a countdown, creating anticipation and excitement. So, whether you have a Major, Minor, or Mini ticket, stay tuned for the draw to see if you\'ve won!': 'Cada tipo de boleto indica el número de ganadores y el tamaño del premio. El sorteo de la suerte ocurre al final de una cuenta regresiva, creando anticipación y emoción. Así que, ya sea que tengas un boleto Mayor, Menor o Mini, ¡mantente atento al sorteo para ver si has ganado!',
    'Instant prize & lucky draw': 'Premio instantáneo y sorteo de la suerte',
    '{arena} Video Stream': '{arena} Transmisión en video',
    'Toggle video auto scale': 'Alternar escala automática del video',
    'Reload the streaming': 'Recargar la transmisión',
    Commission: 'Comisión',
    Total: 'Total',
    Win: 'Ganar',
    'Your session expired, please login again.': 'Tu sesión ha expirado, por favor inicia sesión nuevamente.',
    'Go to login page': 'Ir a la página de inicio de sesión',
    Chinese: '简体中文',
    Statement: 'Declaración',
    Main: 'Principal',
    Limits: 'Límites',
    Settings: 'Configuración',
    Notification: 'Notificación',
    Logout: 'Cerrar sesión',
    General: 'General',
    'To read more': 'Para leer más',
    'Jackpot prize': 'Premio de Jackpot',
    Schedules: 'Horarios',
    'Schedule details': 'Detalles del horario',
    Save: 'Guardar',
    Custom: 'Personalizar',
    Maximum: 'Máximo',
    'Float Video': 'Video flotante',
    Spanish: 'Español',
    Pakistan: 'اُردُو ',
    Korean: '한국어',
    Japanese: '日本語',
    'Stream locked': 'Título: Transmisión bloqueada',
    'You need at least {CURRENCY} {AMOUNT} in your wallet to watch this stream.': 'Texto: Necesitas al menos {CURRENCY} {AMOUNT} en tu billetera para ver esta transmisión.',
    'Cockfighting Rules': 'Reglas de Pelea de Gallos',
    Burmese: 'မြန်မာဘာသာစကား',
    'Bengali-Bangladesh': 'বাংলা',
    'Traditional Chinese': '繁體中文',
    'Hindi-India': 'हिन्दी',
    Earning: 'Ganancia',
    'Bet not successful': 'Apuesta no exitosa',
    'Betting is paused. Please try again shortly. E25': 'Las apuestas están pausadas. Inténtelo de nuevo en breve. E25',
    'Bet guide': 'Guía de apuestas',
    'Placing bet': 'Realizar apuesta',
    'Select bet chip': 'Seleccione ficha de apuesta',
    'Place chip by clicking on preferred bet selection': 'Coloque la ficha haciendo clic en la selección de apuesta preferida',
    'Click Bet button to confirm your bet': 'Haga clic en el botón Apostar para confirmar su apuesta',
    'Fair game rules': 'Reglas de juego justo',
    'Live streaming': 'Transmisión en vivo',
    'Unforeseen issues such as internet connectivity, power supply, or weather disruptions caused the live stream to be interrupted before the fight began.': 'Problemas imprevistos como conexión a internet, suministro eléctrico o condiciones climáticas hicieron que la transmisión en vivo se interrumpiera antes de que comenzara la pelea.',
    'If the fight is not displayed on the game site, all bets will be refunded.': 'Si la pelea no se muestra en el sitio del juego, todas las apuestas serán reembolsadas.',
    'Arena management decision': 'Decisión de la administración de la arena',
    'Arena management reserves the right to cancel any match; announcements regarding arena decisions will be made on a case-by-case basis.': 'La administración de la arena se reserva el derecho de cancelar cualquier combate; los anuncios sobre decisiones de la arena se harán caso por caso.',
    'Bet not closed in time': 'Apuesta no cerrada a tiempo',
    'Bets placed after the fight began will be void and refunded to members due to unforeseen technical issues.': 'Las apuestas realizadas después de que la pelea haya comenzado serán anuladas y reembolsadas a los miembros debido a problemas técnicos imprevistos.',
    'Terms & Conditions': 'Términos y Condiciones',
    'Philippines Cockfighting': 'Pelea de gallos de Filipinas',
    'Challenge Rules': 'Reglas del desafío',
    'Banker / Meron': 'Banquero / Meron',
    'Player / Wala': 'Jugador / Wala',
    'Draw / No Winner': 'Empate / Sin ganador',
    'During the Carreo Procedure (3 UP & 3 DOWN), neither rooster lands two (2) successful pecks, or': 'Durante el Procedimiento Carreo (3 UP & 3 DOWN), si ningún gallo logra dos (2) picotazos exitosos, o',
    'No winner is declared within 10 minutes from the first contact.': 'No se declara ningún ganador dentro de los 10 minutos desde el primer contacto.',
    '*Arena Judge decision is final.': '*La decisión del juez de la arena es final.',
    Cambodia: 'Camboya',
    'Cockfight Rules': 'Reglas de pelea de gallos',
    'Touching or Catching =': 'Tocar o agarrar =',
    'Automatic Loss': 'Pérdida automática',
    'No External Help': 'Sin ayuda externa',
    'No fixing, No beak adjustment': 'No arreglos, no ajuste del pico',
    'No water': 'Sin agua',
    'Defeated if': 'Derrotado si',
    'Lies Flat': 'Se queda tendido',
    'Runs Away / Cries': 'Huye / Grita',
    'No Retaliation × 3': 'Sin contraataque × 3',
    'Standing beats Kneeling;': 'De pie vence a arrodillado;',
    'Kneeling beats Lying Flat': 'Arrodillado vence a tendido',
    'NO ABUSED or POISONING ALLOWED': 'NO SE PERMITE MALTRATO NI ENVENENAMIENTO',
    'Tabletop Game Guide': 'Guía del juego de mesa',
    'RULE: DON\'T FALL OFF!': 'REGLA: ¡NO CAERSE!',
    'Roosters fight on the table top arena.': 'Los gallos pelean en la arena de mesa.',
    'First rooster to touch the floor LOSES.': 'El primer gallo que toque el suelo PIERDE.',
    'Rooster remaining on the table WINS.': 'El gallo que permanezca en la mesa GANA.',
    'Draw when both rooster fall off at the same time': 'Empate cuando ambos gallos caen de la mesa al mismo tiempo',
    'A match is declared DRAW (NO WINNER) if:': 'Un combate se declara EMPATE (SIN GANADOR) si:',
    'The match began, but Arena Management determined that cock was injured. Arena management has the right to cancel the fight if neither cock has a cut or bleed. Any other unforeseeable events.': 'El combate comenzó, pero la administración de la arena determinó que el gallo estaba lesionado. La administración de la arena tiene derecho a cancelar la pelea si ningún gallo tiene corte o sangrado. Cualquier otro evento imprevisible.',
    Philippines: 'Filipinas',
    Tabletop: 'Mesa',
    'Max bet reached for this selection.': 'Límite de apuesta alcanzado para esta selección.',
    'This arena has ended': 'Esta arena ha finalizado',
    'Thank you for your support': 'Gracias por su apoyo',
    Portuguese: 'Português',
    Uzbek: 'Uzbek',
  },
  pk: {
    'Khmer': 'ភាសាខ្មែរ',
    Copy: 'کاپی',
    Copied: 'کاپی',
    Oops: 'افوہ',
    'We could not find the page.': 'ہم صفحہ تلاش نہیں کر سکے۔',
    'You are not authorized to view this page.': 'آپ اس صفحہ کو دیکھنے کے مجاز نہیں ہیں۔',
    'Min-max': 'کم از کم زیادہ سے زیادہ',
    History: 'تاریخ',
    Help: 'مدد',
    Banker: 'Banker',
    Player: 'Player',
    Undo: 'کالعدم',
    Bet: 'شرط لگانا',
    Jackpot: 'جیک پاٹ',
    'No fight at the moment': 'اس وقت کوئی لڑائی نہیں۔',
    'F{fightNumber} is {fightStatus}': 'F{fightNumber} ہے {fightStatus}',
    Hrs: 'گھنٹے',
    Min: 'کم از کم',
    Sec: 'سیکنڈ',
    'Load more': 'مزید لوڈ کریں۔',
    loading: 'لوڈ ہو رہا ہے',
    'Congratulations!': 'مبارک ہو!',
    'Major ticket': 'اہم ٹکٹ',
    'Claim your prize': 'اپنے انعام کا دعوی کریں۔',
    'Current jackpot': 'موجودہ جیک پاٹ',
    'Past winner': 'ماضی کا فاتح',
    'My tickets': 'میرے ٹکٹ',
    'Super draw': 'سپر ڈرا',
    Winners: 'فاتحین',
    Today: 'آج',
    'No tickets earned': 'کوئی ٹکٹ نہیں کمایا',
    'You earn lucky draw ticket #{ticketId}': 'آپ لکی ڈرا ٹکٹ حاصل کرتے ہیں۔#{ticketId}',
    'Instant prize': 'فوری انعام',
    Date: 'تاریخ',
    Time: 'وقت',
    Ante: 'اینٹی',
    'You can\'t place bet': 'آپ شرط نہیں لگا سکتے',
    Odds: 'مشکلات',
    Results: 'نتائج',
    'Win/lose': 'جیت / ہار',
    Id: 'آئی ڈی',
    Match: 'میچ',
    'Start time': 'آغاز کا وقت',
    Created: 'بنایا',
    Confirmed: 'تصدیق شدہ',
    Closing: 'بند کرنا',
    Closed: 'بند',
    Started: 'شروع کر دیا۔',
    Ended: 'ختم ہوا۔',
    Declared: 'اعلان کیا',
    Approved: 'منظور شدہ',
    Processed: 'پروسیس شدہ',
    Cancelled: 'منسوخ',
    Hold: 'پکڑو',
    Close: 'بند',
    Draw: 'ڈرا',
    'Bet detail': 'شرط کی تفصیل',
    Yesterday: 'کل',
    'This week': 'اس ہفتے',
    'Last week': 'گزشتہ ہفتے',
    Viet: 'Tiếng Việt',
    Thai: 'ภาษาไทย',
    Indo: 'Bahasa indo',
    'Account disabled': 'اکاؤنٹ غیر فعال',
    'Invalid token': 'غلط ٹوکن',
    'Draw will be declared after 10-minute countdown': 'قرعہ اندازی کا اعلان 10 منٹ کا الٹی گنتی کے بعد کیا جائے گا۔',
    Balance: 'توازن',
    Tnc: 'Tnc',
    Progress: 'پیش رفت',
    Open: 'کھولیں۔',
    'Okay, got it.': 'ٹھیک ہے، سمجھ گیا۔',
    'Please come back again': 'براہ کرم دوبارہ واپس آجائیں۔',
    Voided: 'کالعدم',
    'Jackpot history': 'جیک پاٹ کی تاریخ',
    'Jackpot help': 'جیک پاٹ مدد',
    'Lucky draw': 'لکی ڈرا',
    'ANTE FOR JACKPOT GAME': 'جیک پاٹ گیم کے لیے پہلے',
    'Along with your bet, a small portion (known as the "ante") is automatically collected and added to the jackpot pool. This pool is a special fund that accumulates over time, contributed to by all players participating in the game.': 'آپ کی شرط کے ساتھ، ایک چھوٹا سا حصہ (جسے "اینٹ" کہا جاتا ہے) خود بخود جمع ہو جاتا ہے اور جیک پاٹ پول میں شامل کر دیا جاتا ہے۔ یہ پول ایک خاص فنڈ ہے جو وقت کے ساتھ ساتھ جمع ہوتا ہے، جس میں گیم میں حصہ لینے والے تمام کھلاڑی حصہ ڈالتے ہیں۔',
    'ACCUMULATING PROGRESS FOR JACKPOT GAME': 'جیک پاٹ گیم کے لیے جمع ہونے والی پیشرفت',
    'Each time you play, you make progress towards triggering the jackpot game. This progress is measured through a meter that fills up a little more each time you bet.': 'جب بھی آپ کھیلتے ہیں، آپ جیک پاٹ گیم کو متحرک کرنے کی طرف پیشرفت کرتے ہیں۔ اس پیشرفت کو ایک میٹر سے ماپا جاتا ہے جو ہر بار جب آپ شرط لگاتے ہیں تو تھوڑا سا زیادہ بھر جاتا ہے۔\n',
    'JACKPOT GAME OCCURRENCE': 'جیک پاٹ گیم کا واقعہ',
    'Once you have accumulated enough progress, the jackpot game is triggered. This is a special event where you have the chance to win big prizes.': 'ایک بار جب آپ کافی پیش رفت جمع کر لیتے ہیں، تو جیک پاٹ گیم شروع ہو جاتی ہے۔ یہ ایک خاص تقریب ہے جہاں آپ کو بڑے انعامات جیتنے کا موقع ملتا ہے۔',
    'Whether you win a Major, Minor, or Mini ticket, you\'re guaranteed an instant prize payout, with the value varying based on the type of ticket. Each ticket color represents a different prize level.': 'چاہے آپ میجر، مائنر، یا منی ٹکٹ جیتیں، آپ کو فوری انعام کی ادائیگی کی ضمانت دی جاتی ہے، جس کی قیمت ٹکٹ کی قسم کی بنیاد پر مختلف ہوتی ہے۔ ہر ٹکٹ کا رنگ مختلف انعامی سطح کی نمائندگی کرتا ہے۔',
    'Each ticket type indicates the number of winners and the size of the prize. The lucky draw happens at the end of a countdown, creating anticipation and excitement. So, whether you have a Major, Minor, or Mini ticket, stay tuned for the draw to see if you\'ve won!': 'ہر ٹکٹ کی قسم جیتنے والوں کی تعداد اور انعام کے سائز کی نشاندہی کرتی ہے۔ لکی قرعہ اندازی الٹی گنتی کے اختتام پر ہوتی ہے، جس سے امید اور جوش پیدا ہوتا ہے۔ لہذا، چاہے آپ کے پاس میجر، مائنر، یا منی ٹکٹ ہو، یہ دیکھنے کے لیے قرعہ اندازی کے لیے دیکھتے رہیں کہ آیا آپ جیت گئے ہیں!',
    'Instant prize & lucky draw': 'فوری انعام اور لکی ڈرا',
    '{arena} Video Stream': '{arena} ویڈیو سلسلہ',
    'Toggle video auto scale': 'ویڈیو آٹو اسکیل کو ٹوگل کریں۔',
    'Reload the streaming': 'سلسلہ بندی کو دوبارہ لوڈ کریں۔',
    Commission: 'کمیشن',
    Total: 'کل',
    Win: 'جیتو',
    'Your session expired, please login again.': 'آپ کے سیشن کی میعاد ختم ہوگئی، براہ کرم دوبارہ لاگ ان کریں۔',
    'Go to login page': 'لاگ ان پیج پر جائیں۔',
    Chinese: '简体中文',
    Statement: 'بیان',
    Main: 'مین',
    Limits: 'حدود',
    Settings: 'ترتیبات',
    Notification: 'اطلاع',
    Logout: 'لاگ آؤٹ',
    General: 'جنرل',
    'To read more': 'مزید پڑھنے کے لیے',
    'Jackpot prize': 'جیک پاٹ کا انعام',
    Schedules: 'شیڈولز',
    'Schedule details': 'شیڈول کی تفصیلات',
    Save: 'محفوظ کریں۔',
    Custom: 'حسب ضرورت',
    Maximum: 'زیادہ سے زیادہ',
    'Float Video': 'فلوٹ ویڈیو',
    Spanish: 'Español',
    Pakistan: 'اُردُو ',
    Korean: '한국어',
    Japanese: '日本語',
    'Stream locked': 'عنوان: اسٹریم مقفل ہے',
    'You need at least {CURRENCY} {AMOUNT} in your wallet to watch this stream.': 'متن: یہ اسٹریم دیکھنے کے لیے آپ کے والیٹ میں کم از کم {CURRENCY} {AMOUNT} ہونا ضروری ہے۔',
    'Cockfighting Rules': 'مرغوں کی لڑائی کے قواعد',
    Burmese: 'မြန်မာဘာသာစကား',
    'Bengali-Bangladesh': 'বাংলা',
    'Traditional Chinese': '繁體中文',
    'Hindi-India': 'हिन्दी',
    Earning: 'منافع',
    'Bet not successful': 'شرط کامیاب نہیں ہوئی',
    'Betting is paused. Please try again shortly. E25': 'شرط لگانا عارضی طور پر روک دیا گیا ہے۔ براہ کرم تھوڑی دیر بعد دوبارہ کوشش کریں۔ E25',
    'Bet guide': 'شرط لگانے کی رہنمائی',
    'Placing bet': 'شرط لگانا',
    'Select bet chip': 'بیٹ چِپ منتخب کریں',
    'Place chip by clicking on preferred bet selection': 'اپنی پسند کی شرط کے انتخاب پر کلک کرکے چِپ رکھیں',
    'Click Bet button to confirm your bet': 'اپنی شرط کی تصدیق کے لیے Bet بٹن پر کلک کریں',
    'Fair game rules': 'منصفانہ کھیل کے اصول',
    'Live streaming': 'براہ راست نشریات',
    'Unforeseen issues such as internet connectivity, power supply, or weather disruptions caused the live stream to be interrupted before the fight began.': 'انٹرنیٹ کنکشن، بجلی کی فراہمی یا موسم کی خرابی جیسے غیر متوقع مسائل کی وجہ سے لڑائی شروع ہونے سے پہلے براہ راست نشریات منقطع ہو گئی۔',
    'If the fight is not displayed on the game site, all bets will be refunded.': 'اگر لڑائی گیم سائٹ پر ظاہر نہ ہو تو تمام شرطیں واپس کر دی جائیں گی۔',
    'Arena management decision': 'ارینا انتظامیہ کا فیصلہ',
    'Arena management reserves the right to cancel any match; announcements regarding arena decisions will be made on a case-by-case basis.': 'ارینا انتظامیہ کسی بھی مقابلے کو منسوخ کرنے کا حق محفوظ رکھتی ہے؛ ارینا کے فیصلوں سے متعلق اعلانات ہر معاملے کی بنیاد پر کیے جائیں گے۔',
    'Bet not closed in time': 'شرط وقت پر بند نہیں ہوئی',
    'Bets placed after the fight began will be void and refunded to members due to unforeseen technical issues.': 'لڑائی شروع ہونے کے بعد لگائی گئی شرطیں غیر مؤثر قرار دی جائیں گی اور غیر متوقع تکنیکی مسائل کی وجہ سے اراکین کو واپس کر دی جائیں گی۔',
    'Terms & Conditions': 'شرائط و ضوابط',
    'Philippines Cockfighting': 'فلپائن مرغوں کی لڑائی',
    'Challenge Rules': 'چیلنج کے اصول',
    'Banker / Meron': 'بینکر / Meron',
    'Player / Wala': 'پلیئر / Wala',
    'Draw / No Winner': 'برابر / کوئی فاتح نہیں',
    'During the Carreo Procedure (3 UP & 3 DOWN), neither rooster lands two (2) successful pecks, or': 'Carreo طریقہ کار (3 UP & 3 DOWN) کے دوران، اگر کوئی بھی مرغا دو (2) کامیاب چونچیں نہ مارے، یا',
    'No winner is declared within 10 minutes from the first contact.': 'پہلے رابطے سے 10 منٹ کے اندر کوئی فاتح اعلان نہ کیا جائے۔',
    '*Arena Judge decision is final.': '*ارینا جج کا فیصلہ حتمی ہے۔',
    Cambodia: 'کمبوڈیا',
    'Cockfight Rules': 'مرغوں کی لڑائی کے اصول',
    'Touching or Catching =': 'چھونا یا پکڑنا =',
    'Automatic Loss': 'خودکار شکست',
    'No External Help': 'کوئی بیرونی مدد نہیں',
    'No fixing, No beak adjustment': 'کوئی درستگی نہیں، چونچ کی کوئی ایڈجسٹمنٹ نہیں',
    'No water': 'پانی نہیں',
    'Defeated if': 'شکست اگر',
    'Lies Flat': 'سیدھا لیٹ جائے',
    'Runs Away / Cries': 'بھاگ جائے / آواز نکالے',
    'No Retaliation × 3': 'تین بار جوابی حملہ نہ کرے',
    'Standing beats Kneeling;': 'کھڑا ہونا گھٹنے ٹیکنے سے بہتر ہے؛',
    'Kneeling beats Lying Flat': 'گھٹنے ٹیکنا سیدھا لیٹنے سے بہتر ہے',
    'NO ABUSED or POISONING ALLOWED': 'بدسلوکی یا زہر دینے کی اجازت نہیں',
    'Tabletop Game Guide': 'ٹیبل ٹاپ گیم گائیڈ',
    'RULE: DON\'T FALL OFF!': 'قاعدہ: نیچے نہ گریں!',
    'Roosters fight on the table top arena.': 'مرغے ٹیبل ٹاپ ارینا پر لڑتے ہیں۔',
    'First rooster to touch the floor LOSES.': 'جو مرغا پہلے فرش کو چھوئے گا وہ ہار جائے گا۔',
    'Rooster remaining on the table WINS.': 'جو مرغا میز پر باقی رہے گا وہ جیتے گا۔',
    'Draw when both rooster fall off at the same time': 'اگر دونوں مرغے ایک ہی وقت میں میز سے گریں تو مقابلہ برابر ہوگا',
    'A match is declared DRAW (NO WINNER) if:': 'مقابلہ برابر یعنی کوئی فاتح نہیں قرار دیا جائے گا اگر:',
    'The match began, but Arena Management determined that cock was injured. Arena management has the right to cancel the fight if neither cock has a cut or bleed. Any other unforeseeable events.': 'مقابلہ شروع ہو چکا ہو، لیکن ارینا انتظامیہ یہ طے کرے کہ مرغا زخمی ہے۔ اگر کسی مرغے کو کٹ یا خون نہ ہو تو ارینا انتظامیہ کو لڑائی منسوخ کرنے کا حق ہے۔ یا کوئی بھی دوسرا غیر متوقع واقعہ پیش آئے۔',
    Philippines: 'فلپائن',
    Tabletop: 'ٹیبل ٹاپ',
    'Max bet reached for this selection.': 'اس انتخاب کی شرط حد پوری ہو گئی ہے۔',
    'This arena has ended': 'یہ ارینا ختم ہو چکا ہے',
    'Thank you for your support': 'آپ کی حمایت کا شکریہ',
    Portuguese: 'Português',
    Uzbek: 'Uzbek',
  },
  kr: {
    'Khmer': 'ភាសាខ្មែរ',
    Copy: 'Copy',
    Copied: '복사됨',
    Oops: 'Oops',
    'We could not find the page.': '페이지를 찾을 수 없습니다.',
    'You are not authorized to view this page.': '이 페이지를 볼 수 있는 권한이 없습니다.',
    'Min-max': '최소-최대',
    History: '기록',
    Help: '도움말',
    Banker: 'Banker',
    Player: 'Player',
    Undo: '되돌리기',
    Bet: '베팅',
    Jackpot: '잭팟',
    'No fight at the moment': '현재 경기가 없습니다',
    'F{fightNumber} is {fightStatus}': 'F{fightNumber}은(는) {fightStatus}입니다',
    Hrs: '시간',
    Min: '분',
    Sec: '초',
    'Load more': '더 보기',
    loading: '로딩 중',
    'Congratulations!': '축하합니다!',
    'Major ticket': '메이저 티켓',
    'Claim your prize': '상품을 수령하세요',
    'Current jackpot': '현재 잭팟',
    'Past winner': '지난 우승자',
    'My tickets': '내 티켓',
    'Super draw': '슈퍼 드로우',
    Winners: '우승자',
    Today: '오늘',
    'No tickets earned': '획득한 티켓이 없습니다',
    'You earn lucky draw ticket #{ticketId}': '행운의 드로우 티켓 #{ticketId}을(를) 획득했습니다',
    'Instant prize': '즉시 상품',
    Date: '날짜',
    Time: '시간',
    Ante: '앤티 수수료',
    'You can\'t place bet': '베팅할 수 없습니다',
    Odds: '배당률',
    Results: '결과',
    'Win/lose': '승/패',
    Id: 'ID',
    Match: '경기',
    'Start time': '시작 시간',
    Created: '생성됨',
    Confirmed: '확인됨',
    Closing: '마감 중',
    Closed: '마감됨',
    Started: '시작됨',
    Ended: '종료됨',
    Declared: '선언됨',
    Approved: '승인됨',
    Processed: '처리됨',
    Cancelled: '취소됨',
    Hold: '보류',
    Close: '닫기',
    Draw: '무승부',
    'Bet detail': '베팅 상세',
    Yesterday: '어제',
    'This week': '이번 주',
    'Last week': '지난주',
    Viet: 'Tiếng Việt',
    Thai: 'ภาษาไทย',
    Indo: 'Bahasa indo',
    'Account disabled': '계정이 비활성화되었습니다',
    'Invalid token': '유효하지 않은 토큰',
    'Draw will be declared after 10-minute countdown': '무승부는 10분 카운트다운 후 선언됩니다',
    Balance: '잔액',
    Tnc: '이용 약관',
    Progress: '진행 상황',
    Open: '열기',
    'Okay, got it.': '알겠습니다',
    'Please come back again': '다시 방문해주세요',
    Voided: '무효화됨',
    'Jackpot history': '잭팟 기록',
    'Jackpot help': '잭팟 도움말',
    'Lucky draw': '행운의 드로우',
    'ANTE FOR JACKPOT GAME': '잭팟 게임의 안테',
    'Along with your bet, a small portion (known as the "ante") is automatically collected and added to the jackpot pool. This pool is a special fund that accumulates over time, contributed to by all players participating in the game.': '베팅과 함께 소액(“안테”라고 함)이 자동으로 수집되어 잭팟 풀에 추가됩니다. 이 풀은 모든 게임 참가자들이 기여하는 특별 기금입니다.',
    'ACCUMULATING PROGRESS FOR JACKPOT GAME': '잭팟 게임 진행 상황 축적',
    'Each time you play, you make progress towards triggering the jackpot game. This progress is measured through a meter that fills up a little more each time you bet.': '플레이할 때마다 잭팟 게임을 트리거하는 진행 상황이 조금씩 축적됩니다. 이 진행 상황은 베팅할 때마다 미터가 채워지는 방식으로 측정됩니다.',
    'JACKPOT GAME OCCURRENCE': '잭팟 게임 발생',
    'Once you have accumulated enough progress, the jackpot game is triggered. This is a special event where you have the chance to win big prizes.': '진행 상황이 충분히 축적되면 잭팟 게임이 트리거됩니다. 이는 큰 상품을 얻을 기회가 있는 특별 이벤트입니다.',
    'Whether you win a Major, Minor, or Mini ticket, you\'re guaranteed an instant prize payout, with the value varying based on the type of ticket. Each ticket color represents a different prize level.': '메이저, 마이너 또는 미니 티켓을 획득하더라도 즉시 상품 지급이 보장됩니다. 상품의 가치는 티켓 유형에 따라 달라집니다. 각 티켓 색상이 다른 상품 수준을 나타냅니다.',
    'Each ticket type indicates the number of winners and the size of the prize. The lucky draw happens at the end of a countdown, creating anticipation and excitement. So, whether you have a Major, Minor, or Mini ticket, stay tuned for the draw to see if you\'ve won!': '각 티켓 유형은 우승자 수와 상품 크기를 나타냅니다. 행운의 드로우는 카운트다운이 끝날 때 진행되며 기대감과 흥미를 제공합니다. 메이저, 마이너 또는 미니 티켓을 보유한 경우 드로우 결과를 확인해보세요!',
    'Instant prize & lucky draw': '즉시 상품 & 행운의 드로우',
    '{arena} Video Stream': '{arena} 비디오 스트림',
    'Toggle video auto scale': '비디오 자동 크기 조정을 전환',
    'Reload the streaming': '스트리밍 다시 로드',
    Commission: '수수료',
    Total: '총합',
    Win: '승리',
    'Your session expired, please login again.': '세션이 만료되었습니다. 다시 로그인하세요.',
    'Go to login page': '로그인 페이지로 이동',
    Chinese: '简体中文',
    Statement: '명세서',
    Main: '메인',
    Limits: '제한',
    Settings: '설정',
    Notification: '알림',
    Logout: '로그아웃',
    General: '일반',
    'To read more': '더 읽기',
    'Jackpot prize': '잭팟 상품',
    Schedules: '일정',
    'Schedule details': '일정 세부사항',
    Save: '저장',
    Custom: '사용자 지정',
    Maximum: '최대값',
    'Float Video': '떠 있는 비디오',
    Spanish: 'Español',
    Pakistan: 'اُردُو ',
    Korean: '한국어',
    Japanese: '日本語',
    'Stream locked': '제목: 스트림 잠김',
    'You need at least {CURRENCY} {AMOUNT} in your wallet to watch this stream.': '본문: 이 스트림을 시청하려면 지갑에 최소 {CURRENCY} {AMOUNT} 이상이 있어야 합니다.',
    'Cockfighting Rules': '투계 규칙',
    Burmese: 'မြန်မာဘာသာစကား',
    'Bengali-Bangladesh': 'বাংলা',
    'Traditional Chinese': '繁體中文',
    'Hindi-India': 'हिन्दी',
    Earning: '수익',
    'Bet not successful': '베팅 실패',
    'Betting is paused. Please try again shortly. E25': '베팅이 일시 중지되었습니다. 잠시 후 다시 시도해 주세요. E25',
    'Bet guide': '베팅 가이드',
    'Placing bet': '베팅하기',
    'Select bet chip': '베팅 칩 선택',
    'Place chip by clicking on preferred bet selection': '원하는 베팅 항목을 클릭하여 칩을 놓으세요',
    'Click Bet button to confirm your bet': 'Bet 버튼을 클릭하여 베팅을 확인하세요',
    'Fair game rules': '공정한 게임 규칙',
    'Live streaming': '라이브 스트리밍',
    'Unforeseen issues such as internet connectivity, power supply, or weather disruptions caused the live stream to be interrupted before the fight began.': '인터넷 연결, 전력 공급 또는 날씨 문제와 같은 예기치 못한 사유로 경기 시작 전에 라이브 스트리밍이 중단되었습니다.',
    'If the fight is not displayed on the game site, all bets will be refunded.': '경기가 게임 사이트에 표시되지 않으면 모든 베팅은 환불됩니다.',
    'Arena management decision': '경기장 관리 결정',
    'Arena management reserves the right to cancel any match; announcements regarding arena decisions will be made on a case-by-case basis.': '경기장 관리 측은 모든 경기를 취소할 권리를 보유하며, 경기장 결정에 관한 공지는 사안별로 안내됩니다.',
    'Bet not closed in time': '베팅 마감 지연',
    'Bets placed after the fight began will be void and refunded to members due to unforeseen technical issues.': '예기치 못한 기술 문제로 인해 경기 시작 후 접수된 베팅은 무효 처리되며 회원에게 환불됩니다.',
    'Terms & Conditions': '이용 약관',
    'Philippines Cockfighting': '필리핀 투계',
    'Challenge Rules': '챌린지 규칙',
    'Banker / Meron': '뱅커 / Meron',
    'Player / Wala': '플레이어 / Wala',
    'Draw / No Winner': '무승부 / 승자 없음',
    'During the Carreo Procedure (3 UP & 3 DOWN), neither rooster lands two (2) successful pecks, or': 'Carreo 절차(3 UP & 3 DOWN) 중 어느 닭도 두 (2) 번의 유효한 쪼기를 성공하지 못한 경우, 또는',
    'No winner is declared within 10 minutes from the first contact.': '첫 접촉 후 10분 이내에 승자가 선언되지 않은 경우.',
    '*Arena Judge decision is final.': '*경기장 심판의 결정은 최종입니다.',
    Cambodia: '캄보디아',
    'Cockfight Rules': '투계 규칙',
    'Touching or Catching =': '접촉 또는 잡기 =',
    'Automatic Loss': '자동 패배',
    'No External Help': '외부 도움 금지',
    'No fixing, No beak adjustment': '수정 금지, 부리 조정 금지',
    'No water': '물 제공 금지',
    'Defeated if': '패배 조건',
    'Lies Flat': '바닥에 납작하게 눕는 경우',
    'Runs Away / Cries': '도망가거나 우는 경우',
    'No Retaliation × 3': '반격 없음 × 3',
    'Standing beats Kneeling;': '서 있는 상태는 무릎 꿇은 상태를 이깁니다;',
    'Kneeling beats Lying Flat': '무릎 꿇은 상태는 바닥에 누운 상태를 이깁니다',
    'NO ABUSED or POISONING ALLOWED': '학대 또는 독극물 사용 금지',
    'Tabletop Game Guide': '테이블탑 게임 가이드',
    'RULE: DON\'T FALL OFF!': '규칙: 떨어지지 마세요!',
    'Roosters fight on the table top arena.': '닭들은 테이블탑 경기장에서 싸웁니다.',
    'First rooster to touch the floor LOSES.': '먼저 바닥에 닿는 닭이 패배합니다.',
    'Rooster remaining on the table WINS.': '테이블 위에 남아 있는 닭이 승리합니다.',
    'Draw when both rooster fall off at the same time': '두 닭이 동시에 떨어지면 무승부입니다',
    'A match is declared DRAW (NO WINNER) if:': '다음의 경우 경기는 무승부(승자 없음)로 선언됩니다:',
    'The match began, but Arena Management determined that cock was injured. Arena management has the right to cancel the fight if neither cock has a cut or bleed. Any other unforeseeable events.': '경기가 시작되었지만 경기장 관리 측이 닭이 부상당했다고 판단한 경우. 어느 닭도 상처나 출혈이 없을 경우 경기장 관리 측은 경기를 취소할 권리가 있습니다. 기타 예측할 수 없는 사건도 포함됩니다.',
    Philippines: '필리핀',
    Tabletop: '테이블탑',
    'Max bet reached for this selection.': '이 선택의 최대 베팅 한도에 도달했습니다.',
    'This arena has ended': '이 아레나는 종료되었습니다',
    'Thank you for your support': '응원해 주셔서 감사합니다',
    Portuguese: 'Português',
    Uzbek: 'Uzbek',
  },
  jp: {
    'Khmer': 'ភាសាខ្មែរ',
    Copy: 'コピー',
    Copied: 'コピーされました',
    Oops: 'おっと',
    'We could not find the page.': 'ページが見つかりませんでした。',
    'You are not authorized to view this page.': 'このページを表示する権限がありません。',
    'Min-max': '最小-最大',
    History: '履歴',
    Help: 'ヘルプ',
    Banker: 'Banker',
    Player: 'Player',
    Undo: '元に戻す',
    Bet: '賭け',
    Jackpot: 'ジャックポット',
    'No fight at the moment': '現在、試合はありません',
    'F{fightNumber} is {fightStatus}': 'F{fightNumber}は{fightStatus}です',
    Hrs: '時間',
    Min: '分',
    Sec: '秒',
    'Load more': 'もっと読み込む',
    loading: '読み込み中',
    'Congratulations!': 'おめでとうございます！',
    'Major ticket': 'メジャーチケット',
    'Claim your prize': '賞品を受け取る',
    'Current jackpot': '現在のジャックポット',
    'Past winner': '過去の勝者',
    'My tickets': '私のチケット',
    'Super draw': 'スーパードロー',
    Winners: '勝者',
    Today: '今日',
    'No tickets earned': '獲得したチケットはありません',
    'You earn lucky draw ticket #{ticketId}': 'ラッキードローチケット #{ticketId} を獲得しました',
    'Instant prize': '即時賞品',
    Date: '日付',
    Time: '時間',
    Ante: 'アンテ',
    'You can\'t place bet': '賭けることができません',
    Odds: 'オッズ',
    Results: '結果',
    'Win/lose': '勝/負',
    Id: 'ID',
    Match: '試合',
    'Start time': '開始時間',
    Created: '作成済み',
    Confirmed: '確認済み',
    Closing: '締切中',
    Closed: '締切済み',
    Started: '開始済み',
    Ended: '終了済み',
    Declared: '宣言済み',
    Approved: '承認済み',
    Processed: '処理済み',
    Cancelled: 'キャンセル済み',
    Hold: '保留',
    Close: '閉じる',
    Draw: '引き分け',
    'Bet detail': 'ベット詳細',
    Yesterday: '昨日',
    'This week': '今週',
    'Last week': '先週',
    Viet: 'Tiếng Việt',
    Thai: 'ภาษาไทย',
    Indo: 'Bahasa indo',
    'Account disabled': 'アカウントが無効です',
    'Invalid token': '無効なトークン',
    'Draw will be declared after 10-minute countdown': '引き分けは10分間のカウントダウン後に宣言されます',
    Balance: '残高',
    Tnc: '利用規約',
    Progress: '進行状況',
    Open: '開く',
    'Okay, got it.': '了解しました',
    'Please come back again': 'また来てください',
    Voided: '無効化されました',
    'Jackpot history': 'ジャックポット履歴',
    'Jackpot help': 'ジャックポットヘルプ',
    'Lucky draw': 'ラッキードロー',
    'ANTE FOR JACKPOT GAME': 'ジャックポットゲームのアンテ',
    'Along with your bet, a small portion (known as the "ante") is automatically collected and added to the jackpot pool. This pool is a special fund that accumulates over time, contributed to by all players participating in the game.': '賭けと一緒に、小額（「アンテ」と呼ばれる）が自動的に集められ、ジャックポットプールに追加されます。このプールは特別な基金で、ゲームに参加するすべてのプレイヤーが積み立てます。',
    'ACCUMULATING PROGRESS FOR JACKPOT GAME': 'ジャックポットゲームの進行状況を蓄積する',
    'Each time you play, you make progress towards triggering the jackpot game. This progress is measured through a meter that fills up a little more each time you bet.': '「プレイするたびに、ジャックポットゲームをトリガーする進行状況が少しずつ蓄積されます。この進行状況は、賭けるたびに少しずつメーターが満たされることで測定されます。」',
    'JACKPOT GAME OCCURRENCE': 'ジャックポットゲームの発生',
    'Once you have accumulated enough progress, the jackpot game is triggered. This is a special event where you have the chance to win big prizes.': '進行状況が十分に蓄積されると、ジャックポットゲームがトリガーされます。これは、大きな賞品を獲得するチャンスがある特別なイベントです。',
    'Whether you win a Major, Minor, or Mini ticket, you\'re guaranteed an instant prize payout, with the value varying based on the type of ticket. Each ticket color represents a different prize level.': 'メジャー、マイナー、またはミニチケットのどれを獲得しても、即時賞品の支払いが保証されます。賞品の価値はチケットの種類によって異なります。それぞれのチケットカラーが異なる賞品レベルを表しています。',
    'Each ticket type indicates the number of winners and the size of the prize. The lucky draw happens at the end of a countdown, creating anticipation and excitement. So, whether you have a Major, Minor, or Mini ticket, stay tuned for the draw to see if you\'ve won!': '各チケットタイプは、勝者の数と賞品の大きさを示しています。ラッキードローはカウントダウンの終了時に行われ、期待感と興奮をもたらします。メジャー、マイナー、またはミニチケットをお持ちの方は、ドローの結果をお楽しみに！',
    'Instant prize & lucky draw': '即時賞品 & ラッキードロー',
    '{arena} Video Stream': '{arena} ビデオストリーム',
    'Toggle video auto scale': 'ビデオの自動スケールを切り替える',
    'Reload the streaming': 'ストリーミングを再読み込みする',
    Commission: 'コミッション',
    Total: '合計',
    Win: '勝利',
    'Your session expired, please login again.': 'セッションの有効期限が切れました。再度ログインしてください。',
    'Go to login page': 'ログインページに移動する',
    Chinese: '简体中文',
    Statement: 'ステートメント',
    Main: 'メイン',
    Limits: '制限',
    Settings: '設定',
    Notification: '通知',
    Logout: 'ログアウト',
    General: '一般',
    'To read more': 'さらに読む',
    'Jackpot prize': 'ジャックポット賞品',
    Schedules: 'スケジュール',
    'Schedule details': 'スケジュール詳細',
    Save: '保存',
    Custom: 'カスタム',
    Maximum: '最大値',
    'Float Video': '浮動ビデオ',
    Spanish: 'Español',
    Pakistan: 'اُردُو ',
    Korean: '한국어',
    Japanese: '日本語',
    'Stream locked': 'タイトル：配信はロックされています',
    'You need at least {CURRENCY} {AMOUNT} in your wallet to watch this stream.': '本文：この配信を視聴するには、ウォレット残高が少なくとも {CURRENCY} {AMOUNT} 必要です。',
    'Cockfighting Rules': '闘鶏のルール',
    Burmese: 'မြန်မာဘာသာစကား',
    'Bengali-Bangladesh': 'বাংলা',
    'Traditional Chinese': '繁體中文',
    'Hindi-India': 'हिन्दी',
    Earning: '利益',
    'Bet not successful': 'ベットに失敗しました',
    'Betting is paused. Please try again shortly. E25': 'ベットは一時停止中です。しばらくしてからもう一度お試しください。E25',
    'Bet guide': 'ベットガイド',
    'Placing bet': 'ベットする',
    'Select bet chip': 'ベットチップを選択',
    'Place chip by clicking on preferred bet selection': '希望するベット項目をクリックしてチップを置いてください',
    'Click Bet button to confirm your bet': 'Bet ボタンをクリックしてベットを確定してください',
    'Fair game rules': 'フェアゲームルール',
    'Live streaming': 'ライブ配信',
    'Unforeseen issues such as internet connectivity, power supply, or weather disruptions caused the live stream to be interrupted before the fight began.': 'インターネット接続、電力供給、天候などの予期しない問題により、試合開始前にライブ配信が中断されました。',
    'If the fight is not displayed on the game site, all bets will be refunded.': '試合がゲームサイトに表示されない場合、すべてのベットは返金されます。',
    'Arena management decision': 'アリーナ管理者の判断',
    'Arena management reserves the right to cancel any match; announcements regarding arena decisions will be made on a case-by-case basis.': 'アリーナ管理者は、いかなる試合もキャンセルする権利を有します。アリーナの判断に関する告知は、ケースごとに行われます。',
    'Bet not closed in time': 'ベットが時間内に締め切られませんでした',
    'Bets placed after the fight began will be void and refunded to members due to unforeseen technical issues.': '予期しない技術的問題により、試合開始後に行われたベットは無効となり、会員に返金されます。',
    'Terms & Conditions': '利用規約',
    'Philippines Cockfighting': 'フィリピン闘鶏',
    'Challenge Rules': 'チャレンジルール',
    'Banker / Meron': 'バンカー / Meron',
    'Player / Wala': 'プレイヤー / Wala',
    'Draw / No Winner': '引き分け / 勝者なし',
    'During the Carreo Procedure (3 UP & 3 DOWN), neither rooster lands two (2) successful pecks, or': 'Carreo 手順（3 UP & 3 DOWN）中に、どちらの鶏も二（2）回の有効なつつきを成功させなかった場合、または',
    'No winner is declared within 10 minutes from the first contact.': '最初の接触から10分以内に勝者が宣言されない場合。',
    '*Arena Judge decision is final.': '*アリーナ審判の判断が最終決定となります。',
    Cambodia: 'カンボジア',
    'Cockfight Rules': '闘鶏ルール',
    'Touching or Catching =': '触れる、または捕まえる =',
    'Automatic Loss': '自動敗北',
    'No External Help': '外部からの助けは禁止',
    'No fixing, No beak adjustment': '修正禁止、くちばし調整禁止',
    'No water': '水は禁止',
    'Defeated if': '敗北条件',
    'Lies Flat': '平らに倒れる',
    'Runs Away / Cries': '逃げる / 鳴く',
    'No Retaliation × 3': '反撃なし × 3',
    'Standing beats Kneeling;': '立っている状態は膝をついた状態に勝つ；',
    'Kneeling beats Lying Flat': '膝をついた状態は平らに倒れた状態に勝つ',
    'NO ABUSED or POISONING ALLOWED': '虐待または毒物使用は禁止',
    'Tabletop Game Guide': 'テーブルトップゲームガイド',
    'RULE: DON\'T FALL OFF!': 'ルール：落ちてはいけません！',
    'Roosters fight on the table top arena.': '鶏はテーブルトップアリーナで戦います。',
    'First rooster to touch the floor LOSES.': '最初に床に触れた鶏が負けです。',
    'Rooster remaining on the table WINS.': 'テーブル上に残った鶏が勝ちです。',
    'Draw when both rooster fall off at the same time': '両方の鶏が同時にテーブルから落ちた場合は引き分けです',
    'A match is declared DRAW (NO WINNER) if:': '次の場合、試合は引き分け（勝者なし）と宣言されます：',
    'The match began, but Arena Management determined that cock was injured. Arena management has the right to cancel the fight if neither cock has a cut or bleed. Any other unforeseeable events.': '試合は開始されたが、アリーナ管理者が鶏の負傷を確認した場合。どちらの鶏にも切り傷や出血がない場合、アリーナ管理者は試合をキャンセルする権利を有します。その他の予期しない事象も含まれます。',
    Philippines: 'フィリピン',
    Tabletop: 'テーブルトップ',
    'Max bet reached for this selection.': 'この選択の最大ベット額に達しました。',
    'This arena has ended': 'このアリーナは終了しました',
    'Thank you for your support': 'ご支援ありがとうございます',
    Portuguese: 'Português',
    Uzbek: 'Uzbek',
  },
  mm: {
    'Khmer': 'ភាសាខ្មែរ',
    Copy: 'ကူးယူ',
    Copied: 'ကူးယူပြီးပြီ',
    Oops: 'အိုဟို!',
    'We could not find the page.': 'ဒီစာမျက်နှာကို ရှာမတွေ့ပါ။',
    'You are not authorized to view this page.': 'ဤစာမျက်နှာကို ကြည့်ရှုရန် သင့်တွင် ခွင့်ပြုချက် မရှိပါ။',
    'Min-max': 'အနည်းဆုံး–အများဆုံး',
    History: 'မှတ်တမ်း',
    Help: 'အကူအညီ',
    Banker: 'Banker',
    Player: 'Player',
    Undo: 'ပြန်ဖျက်',
    Bet: 'Bet',
    Jackpot: 'ဂျက်ပေါ့',
    'No fight at the moment': 'ယခုအချိန်တွင် တိုက်ပွဲမရှိပါ။',
    'F{fightNumber} is {fightStatus}': 'F{fightNumber} သည် {fightStatus} ဖြစ်သည်။',
    Hrs: 'နာရီ',
    Min: 'မိနစ်',
    Sec: 'စက္ကန့်',
    'Load more': 'ပို၍ ဖော်ပြရန်',
    loading: 'တင်နေသည်…',
    'Congratulations!': 'ဂုဏ်ယူပါတယ်!',
    'Major ticket': 'မေဂျာ လက်မှတ်',
    'Claim your prize': 'ဆုကို တောင်းယူပါ။',
    'Current jackpot': 'လက်ရှိ ဂျက်ပေါ့',
    'Past winner': 'ယခင် အနိုင်သူ',
    'My tickets': 'ကျွန်ုပ်၏ လက်မှတ်များ',
    'Super draw': 'စူပါ ဒရော့',
    Winners: 'အနိုင်သူများ',
    Today: 'ယနေ့',
    'No tickets earned': 'လက်မှတ် မရရှိသေးပါ',
    'You earn lucky draw ticket #{ticketId}': 'သင်သည် လတ်ကီဒရော့ လက်မှတ် #{ticketId} ရရှိပါသည်',
    'Instant prize': 'ချက်ချင်းပေးဆု',
    Date: 'ရက်စွဲ',
    Time: 'အချိန်',
    Ante: 'Ante',
    'You can\'t place bet': 'သင် မလောင်းကြေးတင်နိုင်ပါ။',
    Odds: 'အချိုးကိန်း',
    Results: 'ရလဒ်',
    'Win/lose': 'နိုင်/ရှုံး',
    Id: 'ID',
    Match: 'ပွဲ',
    'Start time': 'စတင်ချိန်',
    Created: 'ဖန်တီးပြီး',
    Confirmed: 'အတည်ပြုပြီး',
    Closing: 'ပိတ်နေသည်',
    Closed: 'ပိတ်ပြီး',
    Started: 'စတင်ပြီး',
    Ended: 'ပြီးဆုံးပြီး',
    Declared: 'ကြေညာပြီး',
    Approved: 'အတည်ပြုပြီး',
    Processed: 'ဆောင်ရွက်ပြီး',
    Cancelled: 'ဖျက်သိမ်းပြီး',
    Hold: 'ဆိုင်းငံ့',
    Close: 'ပိတ်',
    Draw: 'သရေ',
    'Bet detail': 'လောင်းကြေး အသေးစိတ်',
    Yesterday: 'မနေ့',
    'This week': 'ဤအပတ်',
    'Last week': 'ပြီးခဲ့သော အပတ်',
    Viet: 'Tiếng Việt',
    Thai: 'ภาษาไทย',
    Indo: 'Bahasa indo',
    'Account disabled': 'အကောင့် ပိတ်ထားသည်',
    'Invalid token': 'မမှန်ကန်သော တိုကင်',
    'Draw will be declared after 10-minute countdown': 'မိနစ် ၁၀ အချိန်နောက်ဆုတ် ပြီးဆုံးသည့်အခါ ဒရော့ကို ကြေညာပါမည်။',
    Balance: 'လက်ကျန်',
    Tnc: 'စည်းကမ်း သတ်မှတ်ချက်များ',
    Progress: 'တိုးတက်မှု',
    Open: 'ဖွင့်',
    'Okay, got it.': 'ကောင်းပြီ၊ နားလည်ပါပြီ။',
    'Please come back again': 'နောက်တစ်ကြိမ် ပြန်လာပါ။',
    Voided: 'ပယ်ဖျက်ပြီး',
    'Jackpot history': 'ဂျက်ပေါ့ မှတ်တမ်း',
    'Jackpot help': 'ဂျက်ပေါ့ အကူအညီ',
    'Lucky draw': 'လတ်ကီဒရော့',
    'ANTE FOR JACKPOT GAME': 'ဂျက်ပေါ့ ဂိမ်းအတွက် အန်တီ',
    'Along with your bet, a small portion (known as the "ante") is automatically collected and added to the jackpot pool. This pool is a special fund that accumulates over time, contributed to by all players participating in the game.': 'သင်၏လောင်းကြေးနှင့် အတူ “အန်တီ” ဟုခေါ်သော ငွေပမာဏအသေးငယ်ကို အလိုအလျောက်ကောက်ခံပြီး ဂျက်ပေါ့ အငွေစုရေကန်ထဲသို့ ထည့်သွင်းပါသည်။ ဤရေကန်သည် ကစားသမားအားလုံးမှ အချိန်အလိုက် စုပုံဝင်ဒုတိယဖြစ်သည့် အထူးရန်ပုံငွာဖြစ်သည်။',
    'ACCUMULATING PROGRESS FOR JACKPOT GAME': 'Jackpot ဂိမ်းအတွက် တိုးတက်မှုကို စုစည်းနေသည်။',
    'Each time you play, you make progress towards triggering the jackpot game. This progress is measured through a meter that fills up a little more each time you bet.': 'သင်ကစားသည့်အခါတိုင်း၊ သင်သည် jackpot ဂိမ်းကိုစတင်ရန်တိုးတက်မှုရှိသည်။ ဤတိုးတက်မှုကို သင်လောင်းတိုင်းတွင် အနည်းငယ်ပိုဖြည့်သည့် မီတာဖြင့် တိုင်းတာသည်။',
    'JACKPOT GAME OCCURRENCE': 'Jackpot ဂိမ်းဖြစ်ပွားမှု',
    'Once you have accumulated enough progress, the jackpot game is triggered. This is a special event where you have the chance to win big prizes.': 'သင်လုံလောက်သောတိုးတက်မှုကိုစုဆောင်းပြီးသည်နှင့် jackpot ဂိမ်းကိုစတင်သည်။ ဤအရာသည် သင့်တွင် ဆုကြီးကြီးများကို ဆွတ်ခူးနိုင်သည့် အထူးအစီအစဉ်တစ်ခုဖြစ်သည်။',
    'Whether you win a Major, Minor, or Mini ticket, you\'re guaranteed an instant prize payout, with the value varying based on the type of ticket. Each ticket color represents a different prize level.': 'Major၊ Minor သို့မဟုတ် Mini လက်မှတ်ကို သင်အနိုင်ရသည်ဖြစ်စေ လက်မှတ်အမျိုးအစားပေါ်မူတည်၍ တန်ဖိုးကွာခြားမှုနှင့်အတူ လက်ငင်းဆုပေးချေမှုကို အာမခံပါသည်။ လက်မှတ်အရောင်တစ်ခုစီသည် မတူညီသောဆုအဆင့်ကို ကိုယ်စားပြုသည်။',
    'Each ticket type indicates the number of winners and the size of the prize. The lucky draw happens at the end of a countdown, creating anticipation and excitement. So, whether you have a Major, Minor, or Mini ticket, stay tuned for the draw to see if you\'ve won!': 'လက်မှတ်အမျိုးအစားတစ်ခုစီသည် ဆုရရှိသူအရေအတွက်နှင့် ဆုအရွယ်အစားကို ဖော်ပြသည်။ Lucky Draw သည် နှစ်သစ်ကြိုဆိုပွဲ၏ အဆုံးတွင် ဖြစ်ပေါ်လာပြီး မျှော်လင့်ချက်နှင့် စိတ်လှုပ်ရှားမှုများကို ဖန်တီးပေးပါသည်။ ထို့ကြောင့် သင့်တွင် Major၊ Minor သို့မဟုတ် Mini လက်မှတ်ရှိမရှိ၊ သင်အနိုင်ရပြီးပါက မဲနှိုက်ခြင်းကို စောင့်ကြည့်ပါ။',
    'Instant prize & lucky draw': 'ချက်ချင်းပေးဆုနှင့် လတ်ကီဒရော့',
    '{arena} Video Stream': '{arena} ဗီဒီယို စတ്രീမ်း',
    'Toggle video auto scale': 'ဗီဒီယို အလိုအလျောက် အရွယ်အစား ချိန်/ပိတ်',
    'Reload the streaming': 'စတရီမ်ကို ပြန်လည်ဖွင့်မည်',
    Commission: 'ကော်မရှင်',
    Total: 'စုစုပေါင်း',
    Win: 'အနိုင်',
    'Your session expired, please login again.': 'သင့်ဆက်ရှင် သက်တမ်းကုန်သွားပါသည်။ ထပ်မံ လော့ဂင်ဝင်ပါ။',
    'Go to login page': 'လော့ဂင် စာမျက်နှာသို့ သွားရန်',
    Chinese: '简体中文',
    Statement: 'စာရင်းမှတ်တမ်း',
    Main: 'ပင်မ',
    Limits: 'ကန့်သတ်ချက်များ',
    Settings: 'ဆက်တင်များ',
    Notification: 'အသိပေးချက်',
    Logout: 'ထွက်မည်',
    General: 'အထွေထွေ',
    'To read more': 'ပိုပြီး ဖတ်ရန်',
    'Jackpot prize': 'ဂျက်ပေါ့ ဆု',
    Schedules: 'အချိန်ဇယားများ',
    'Schedule details': 'အချိန်ဇယား အသေးစိတ်',
    Save: 'သိမ်းဆည်း',
    Custom: 'စိတ်ကြိုက်',
    Maximum: 'အများဆုံး',
    'Float Video': 'ပေါ်နေသော ဗီဒီယို',
    Spanish: 'Español',
    Pakistan: 'اُردُو ',
    Korean: '한국어',
    Japanese: '日本語',
    'Stream locked': 'စတရီမ် သော့ခတ်ထားသည်',
    'You need at least {CURRENCY} {AMOUNT} in your wallet to watch this stream.': 'ဤစတရီမ်ကို ကြည့်ရန် သင့်ပိုက်ဆံအိတ်တွင် အနည်းဆုံး {CURRENCY} {AMOUNT} လိုအပ်ပါသည်။',
    'Cockfighting Rules': 'ကြက်တိုက်ပွဲ စည်းကမ်းချက်များ',
    Burmese: 'မြန်မာဘာသာစကား',
    'Bengali-Bangladesh': 'বাংলা',
    'Traditional Chinese': '繁體中文',
    'Hindi-India': 'हिन्दी',
    Earning: 'အမြတ်',
    'Bet not successful': 'လောင်းကြေး မအောင်မြင်ပါ',
    'Betting is paused. Please try again shortly. E25': 'လောင်းကြေးတင်ခြင်းကို ခေတ္တရပ်ဆိုင်းထားပါသည်။ ခဏအကြာတွင် ပြန်လည်ကြိုးစားပါ။ E25',
    'Bet guide': 'လောင်းကြေးလမ်းညွှန်',
    'Placing bet': 'လောင်းကြေးတင်ခြင်း',
    'Select bet chip': 'လောင်းကြေးချစ်ပ်ကို ရွေးချယ်ပါ',
    'Place chip by clicking on preferred bet selection': 'နှစ်သက်သော လောင်းကြေးရွေးချယ်မှုကို နှိပ်ပြီး ချစ်ပ်တင်ပါ',
    'Click Bet button to confirm your bet': 'သင့်လောင်းကြေးကို အတည်ပြုရန် Bet ခလုတ်ကို နှိပ်ပါ',
    'Fair game rules': 'မျှတသောဂိမ်း စည်းမျဉ်းများ',
    'Live streaming': 'တိုက်ရိုက်ထုတ်လွှင့်မှု',
    'Unforeseen issues such as internet connectivity, power supply, or weather disruptions caused the live stream to be interrupted before the fight began.': 'အင်တာနက်ချိတ်ဆက်မှု၊ လျှပ်စစ်မီး သို့မဟုတ် မိုးလေဝသအခြေအနေများကဲ့သို့ မမျှော်လင့်ထားသော ပြဿနာများကြောင့် ပွဲမစတင်မီ တိုက်ရိုက်ထုတ်လွှင့်မှု ပြတ်တောက်ခဲ့ပါသည်။',
    'If the fight is not displayed on the game site, all bets will be refunded.': 'ဂိမ်းဝဘ်ဆိုက်တွင် ပွဲမပြသပါက လောင်းကြေးအားလုံးကို ပြန်အမ်းမည်။',
    'Arena management decision': 'အာရင်နာ စီမံခန့်ခွဲမှု ဆုံးဖြတ်ချက်',
    'Arena management reserves the right to cancel any match; announcements regarding arena decisions will be made on a case-by-case basis.': 'အာရင်နာ စီမံခန့်ခွဲမှုသည် မည်သည့်ပွဲစဉ်ကိုမဆို ဖျက်သိမ်းပိုင်ခွင့်ရှိပြီး၊ အာရင်နာဆုံးဖြတ်ချက်များနှင့်ပတ်သက်သော ကြေညာချက်များကို အခြေအနေတစ်ခုချင်းစီအလိုက် ထုတ်ပြန်မည်။',
    'Bet not closed in time': 'လောင်းကြေးကို အချိန်မီ မပိတ်နိုင်ပါ',
    'Bets placed after the fight began will be void and refunded to members due to unforeseen technical issues.': 'မမျှော်လင့်ထားသော နည်းပညာပြဿနာများကြောင့် ပွဲစတင်ပြီးနောက် တင်ထားသော လောင်းကြေးများကို ပယ်ဖျက်ပြီး အဖွဲ့ဝင်များထံ ပြန်အမ်းမည်။',
    'Terms & Conditions': 'စည်းကမ်းနှင့် သတ်မှတ်ချက်များ',
    'Philippines Cockfighting': 'ဖိလစ်ပိုင် ကြက်တိုက်ပွဲ',
    'Challenge Rules': 'စိန်ခေါ်မှု စည်းမျဉ်းများ',
    'Banker / Meron': 'ဘဏ်ကာ / Meron',
    'Player / Wala': 'ကစားသမား / Wala',
    'Draw / No Winner': 'သရေ / အနိုင်ရသူမရှိ',
    'During the Carreo Procedure (3 UP & 3 DOWN), neither rooster lands two (2) successful pecks, or': 'Carreo လုပ်ထုံးလုပ်နည်း (3 UP & 3 DOWN) အတွင်း ကြက်နှစ်ကောင်လုံးမှ နှစ် (2) ကြိမ်အောင်မြင်သော ထိုးဆိတ်မှု မပြုလုပ်နိုင်ပါက၊ သို့မဟုတ်',
    'No winner is declared within 10 minutes from the first contact.': 'ပထမဆုံး ထိတွေ့မှုမှ 10 မိနစ်အတွင်း အနိုင်ရသူ မကြေညာပါက။',
    '*Arena Judge decision is final.': '*အာရင်နာ ဒိုင်လူကြီး၏ ဆုံးဖြတ်ချက်သည် နောက်ဆုံးဖြစ်သည်။',
    Cambodia: 'ကမ္ဘောဒီးယား',
    'Cockfight Rules': 'ကြက်တိုက်ပွဲ စည်းမျဉ်းများ',
    'Touching or Catching =': 'ထိခြင်း သို့မဟုတ် ဖမ်းခြင်း =',
    'Automatic Loss': 'အလိုအလျောက် ရှုံးနိမ့်ခြင်း',
    'No External Help': 'ပြင်ပအကူအညီ မရ',
    'No fixing, No beak adjustment': 'ပြင်ဆင်ခြင်း မလုပ်ရ၊ နှုတ်သီးညှိခြင်း မလုပ်ရ',
    'No water': 'ရေမပေးရ',
    'Defeated if': 'ရှုံးနိမ့်သတ်မှတ်မည့် အခြေအနေ',
    'Lies Flat': 'ပြားပြားဝပ်နေခြင်း',
    'Runs Away / Cries': 'ထွက်ပြေးခြင်း / အော်ခြင်း',
    'No Retaliation × 3': 'ပြန်လည်တိုက်ခိုက်မှု မရှိခြင်း × 3',
    'Standing beats Kneeling;': 'မတ်တပ်ရပ်ခြင်းသည် ဒူးထောက်ခြင်းကို အနိုင်ရသည်;',
    'Kneeling beats Lying Flat': 'ဒူးထောက်ခြင်းသည် ပြားပြားဝပ်ခြင်းကို အနိုင်ရသည်',
    'NO ABUSED or POISONING ALLOWED': 'နှိပ်စက်ခြင်း သို့မဟုတ် အဆိပ်ခတ်ခြင်းကို လုံးဝခွင့်မပြုပါ',
    'Tabletop Game Guide': 'စားပွဲပေါ်ဂိမ်း လမ်းညွှန်',
    'RULE: DON\'T FALL OFF!': 'စည်းမျဉ်း: အောက်မကျပါစေနှင့်!',
    'Roosters fight on the table top arena.': 'ကြက်များသည် စားပွဲပေါ် အာရင်နာတွင် တိုက်ခိုက်ကြသည်။',
    'First rooster to touch the floor LOSES.': 'ကြမ်းပြင်ကို ပထမဆုံး ထိသောကြက်သည် ရှုံးသည်။',
    'Rooster remaining on the table WINS.': 'စားပွဲပေါ်တွင် ကျန်ရှိသောကြက်သည် အနိုင်ရသည်။',
    'Draw when both rooster fall off at the same time': 'ကြက်နှစ်ကောင်လုံး တစ်ချိန်တည်း စားပွဲမှ ကျပါက သရေဖြစ်သည်',
    'A match is declared DRAW (NO WINNER) if:': 'အောက်ပါအခြေအနေတွင် ပွဲကို သရေ အနိုင်ရသူမရှိဟု ကြေညာမည်:',
    'The match began, but Arena Management determined that cock was injured. Arena management has the right to cancel the fight if neither cock has a cut or bleed. Any other unforeseeable events.': 'ပွဲစတင်ပြီးဖြစ်သော်လည်း အာရင်နာ စီမံခန့်ခွဲမှုက ကြက်ဒဏ်ရာရရှိကြောင်း သတ်မှတ်ပါက။ ကြက်နှစ်ကောင်လုံးတွင် ဖြတ်ရာ သို့မဟုတ် သွေးထွက်မှု မရှိပါက အာရင်နာ စီမံခန့်ခွဲမှုသည် ပွဲကို ဖျက်သိမ်းပိုင်ခွင့်ရှိသည်။ အခြား မမျှော်လင့်ထားသော ဖြစ်ရပ်များလည်း ပါဝင်သည်။',
    Philippines: 'ဖိလစ်ပိုင်',
    Tabletop: 'စားပွဲပေါ်',
    'Max bet reached for this selection.': 'ဤရွေးချယ်မှု၏ လောင်းကြေးကန့်သတ်ချက် ပြည့်ပါပြီ။',
    'This arena has ended': 'ဤအရီနာ ပြီးဆုံးသွားပါပြီ',
    'Thank you for your support': 'သင်၏အားပေးမှုအတွက် ကျေးဇူးတင်ပါသည်',
    Portuguese: 'Português',
    Uzbek: 'Uzbek',
  },
  bd: {
    'Khmer': 'ភាសាខ្មែរ',
    Copy: 'কপি',
    Copied: 'কপি হয়েছে',
    Oops: 'উফ!',
    'We could not find the page.': 'আমরা পৃষ্ঠাটি খুঁজে পাইনি।',
    'You are not authorized to view this page.': 'আপনি এই পৃষ্ঠা দেখার অনুমতিপ্রাপ্ত নন।',
    'Min-max': 'সর্বনিম্ন–সর্বোচ্চ',
    History: 'ইতিহাস',
    Help: 'সহায়তা',
    Banker: 'Banker',
    Player: 'Player',
    Undo: 'আনডু',
    Bet: 'Bet',
    Jackpot: 'জ্যাকপট',
    'No fight at the moment': 'এই মুহূর্তে কোনো লড়াই নেই',
    'F{fightNumber} is {fightStatus}': 'F{fightNumber} হলো {fightStatus}',
    Hrs: 'ঘণ্টা',
    Min: 'মিনিট',
    Sec: 'সেকেন্ড',
    'Load more': 'আরও লোড করুন',
    loading: 'লোড হচ্ছে…',
    'Congratulations!': 'অভিনন্দন!',
    'Major ticket': 'মেজর টিকিট',
    'Claim your prize': 'আপনার পুরস্কার নিন',
    'Current jackpot': 'বর্তমান জ্যাকপট',
    'Past winner': 'পূর্ববর্তী বিজয়ী',
    'My tickets': 'আমার টিকিটসমূহ',
    'Super draw': 'সুপার ড্র',
    Winners: 'বিজয়ীরা',
    Today: 'আজ',
    'No tickets earned': 'কোনো টিকিট অর্জিত হয়নি',
    'You earn lucky draw ticket #{ticketId}': 'আপনি লাকি ড্র টিকিট #{ticketId} অর্জন করেছেন',
    'Instant prize': 'তাৎক্ষণিক পুরস্কার',
    Date: 'তারিখ',
    Time: 'সময়',
    Ante: 'Ante ফি',
    'You can\'t place bet': 'আপনি বেট করতে পারবেন না',
    Odds: 'অডস',
    Results: 'ফলাফল',
    'Win/lose': 'জয়/পরাজয়',
    Id: 'আইডি',
    Match: 'ম্যাচ',
    'Start time': 'শুরুর সময়',
    Created: 'তৈরি হয়েছে',
    Confirmed: 'নিশ্চিত',
    Closing: 'বন্ধ হচ্ছে',
    Closed: 'বন্ধ',
    Started: 'শুরু হয়েছে',
    Ended: 'শেষ হয়েছে',
    Declared: 'ঘোষণা করা হয়েছে',
    Approved: 'অনুমোদিত',
    Processed: 'প্রক্রিয়াকৃত',
    Cancelled: 'বাতিল করা হয়েছে',
    Hold: 'স্থগিত',
    Close: 'বন্ধ করুন',
    Draw: 'ড্র',
    'Bet detail': 'বেটের বিস্তারিত',
    Yesterday: 'গতকাল',
    'This week': 'এই সপ্তাহ',
    'Last week': 'গত সপ্তাহ',
    Viet: 'Tiếng Việt',
    Thai: 'ภาษาไทย',
    Indo: 'Bahasa indo',
    'Account disabled': 'অ্যাকাউন্ট নিষ্ক্রিয়',
    'Invalid token': 'অবৈধ টোকেন',
    'Draw will be declared after 10-minute countdown': '১০ মিনিটের কাউন্টডাউন শেষে ড্র ঘোষণা করা হবে',
    Balance: 'ব্যালেন্স',
    Tnc: 'শর্তাবলী',
    Progress: 'অগ্রগতি',
    Open: 'খুলুন',
    'Okay, got it.': 'ঠিক আছে, বুঝেছি।',
    'Please come back again': 'অনুগ্রহ করে আবার আসুন',
    Voided: 'অকার্যকর করা হয়েছে',
    'Jackpot history': 'জ্যাকপট ইতিহাস',
    'Jackpot help': 'জ্যাকপট সহায়তা',
    'Lucky draw': 'লাকি ড্র',
    'ANTE FOR JACKPOT GAME': 'জ্যাকপট গেমের জন্য অ্যান্টি',
    'Along with your bet, a small portion (known as the "ante") is automatically collected and added to the jackpot pool. This pool is a special fund that accumulates over time, contributed to by all players participating in the game.': 'আপনার বেটের সঙ্গে সঙ্গে “অ্যান্টি” নামে একটি ছোট অংশ স্বয়ংক্রিয়ভাবে কাটা হয় এবং জ্যাকপট পুলে যোগ হয়। এই পুলটি একটি বিশেষ তহবিল, যা সময়ের সাথে সাথে জমা হয় এবং গেমে অংশ নেওয়া সব খেলোয়াড়ের অবদানে গঠিত।',
    'ACCUMULATING PROGRESS FOR JACKPOT GAME': 'জ্যাকপট গেমের জন্য অগ্রগতির সঞ্চয়',
    'Each time you play, you make progress towards triggering the jackpot game. This progress is measured through a meter that fills up a little more each time you bet.': 'আপনি যখনই খেলেন, জ্যাকপট গেম ট্রিগার হওয়ার দিকে অগ্রগতি বাড়ে। এই অগ্রগতি একটি মিটারের মাধ্যমে মাপা হয়, যা প্রতিবার বেট দেওয়ার সঙ্গে সামান্য করে পূর্ণ হয়।',
    'JACKPOT GAME OCCURRENCE': 'জ্যাকপট গেম শুরু হওয়া',
    'Once you have accumulated enough progress, the jackpot game is triggered. This is a special event where you have the chance to win big prizes.': 'পর্যাপ্ত অগ্রগতি জমা হলে জ্যাকপট গেম ট্রিগার হয়। এটি একটি বিশেষ ইভেন্ট, যেখানে বড় পুরস্কার জেতার সুযোগ থাকে।',
    'Whether you win a Major, Minor, or Mini ticket, you\'re guaranteed an instant prize payout, with the value varying based on the type of ticket. Each ticket color represents a different prize level.': 'আপনি মেজর, মাইনর বা মিনি—যে কোনো টিকিটই জিতুন না কেন, তাৎক্ষণিক পুরস্কার নিশ্চিত; টিকিটের ধরন অনুযায়ী পুরস্কারের মূল্য ভিন্ন হয়। প্রতিটি টিকিটের রং আলাদা পুরস্কারের স্তর নির্দেশ করে।',
    'Each ticket type indicates the number of winners and the size of the prize. The lucky draw happens at the end of a countdown, creating anticipation and excitement. So, whether you have a Major, Minor, or Mini ticket, stay tuned for the draw to see if you\'ve won!': 'প্রতিটি টিকিটের ধরন বিজয়ীর সংখ্যা এবং পুরস্কারের পরিমাণ নির্দেশ করে। কাউন্টডাউন শেষেই লাকি ড্র হয়, যা উত্তেজনা বাড়ায়। তাই আপনার কাছে মেজর, মাইনর বা মিনি—যে টিকিটই থাকুক, জিতেছেন কি না জানতে ড্র পর্যন্ত অপেক্ষা করুন!',
    'Instant prize & lucky draw': 'তাৎক্ষণিক পুরস্কার ও লাকি ড্র',
    '{arena} Video Stream': '{arena} ভিডিও স্ট্রিম',
    'Toggle video auto scale': 'ভিডিও অটো-স্কেল চালু/বন্ধ',
    'Reload the streaming': 'স্ট্রিম পুনরায় লোড করুন',
    Commission: 'কমিশন',
    Total: 'মোট',
    Win: 'জয়',
    'Your session expired, please login again.': 'আপনার সেশন মেয়াদোত্তীর্ণ হয়েছে, অনুগ্রহ করে আবার লগইন করুন।',
    'Go to login page': 'লগইন পাতায় যান',
    Chinese: '简体中文',
    Statement: 'স্টেটমেন্ট',
    Main: 'প্রধান',
    Limits: 'সীমা',
    Settings: 'সেটিংস',
    Notification: 'নোটিফিকেশন',
    Logout: 'লগআউট',
    General: 'সাধারণ',
    'To read more': 'আরও পড়ুন',
    'Jackpot prize': 'জ্যাকপট পুরস্কার',
    Schedules: 'সময়সূচি',
    'Schedule details': 'সময়সূচির বিস্তারিত',
    Save: 'সেভ করুন',
    Custom: 'কাস্টম',
    Maximum: 'সর্বোচ্চ',
    'Float Video': 'ভাসমান ভিডিও',
    Spanish: 'Español',
    Pakistan: 'اُردُو ',
    Korean: '한국어',
    Japanese: '日本語',
    'Stream locked': 'স্ট্রিম লক করা হয়েছে',
    'You need at least {CURRENCY} {AMOUNT} in your wallet to watch this stream.': 'এই স্ট্রিম দেখতে আপনার ওয়ালেটে কমপক্ষে {CURRENCY} {AMOUNT} থাকতে হবে।',
    'Cockfighting Rules': 'মোরগ লড়াইয়ের নিয়মাবলী',
    Burmese: 'မြန်မာဘာသာစကား',
    'Bengali-Bangladesh': 'বাংলা',
    'Traditional Chinese': '繁體中文',
    'Hindi-India': 'हिन्दी',
    Earning: 'লাভ',
    'Bet not successful': 'বাজি সফল হয়নি',
    'Betting is paused. Please try again shortly. E25': 'বাজি সাময়িকভাবে স্থগিত আছে। অনুগ্রহ করে কিছুক্ষণ পরে আবার চেষ্টা করুন। E25',
    'Bet guide': 'বাজির নির্দেশিকা',
    'Placing bet': 'বাজি ধরা',
    'Select bet chip': 'বেট চিপ নির্বাচন করুন',
    'Place chip by clicking on preferred bet selection': 'পছন্দের বেট নির্বাচনটিতে ক্লিক করে চিপ বসান',
    'Click Bet button to confirm your bet': 'আপনার বাজি নিশ্চিত করতে Bet বোতামে ক্লিক করুন',
    'Fair game rules': 'ন্যায্য খেলার নিয়ম',
    'Live streaming': 'লাইভ স্ট্রিমিং',
    'Unforeseen issues such as internet connectivity, power supply, or weather disruptions caused the live stream to be interrupted before the fight began.': 'ইন্টারনেট সংযোগ, বিদ্যুৎ সরবরাহ বা আবহাওয়ার মতো অনাকাঙ্ক্ষিত সমস্যার কারণে লড়াই শুরু হওয়ার আগে লাইভ স্ট্রিম ব্যাহত হয়েছে।',
    'If the fight is not displayed on the game site, all bets will be refunded.': 'যদি লড়াইটি গেম সাইটে প্রদর্শিত না হয়, সব বাজি ফেরত দেওয়া হবে।',
    'Arena management decision': 'এরিনা ব্যবস্থাপনার সিদ্ধান্ত',
    'Arena management reserves the right to cancel any match; announcements regarding arena decisions will be made on a case-by-case basis.': 'এরিনা ব্যবস্থাপনা যেকোনো ম্যাচ বাতিল করার অধিকার সংরক্ষণ করে; এরিনার সিদ্ধান্ত সম্পর্কিত ঘোষণা প্রতিটি ঘটনার ভিত্তিতে করা হবে।',
    'Bet not closed in time': 'বাজি সময়মতো বন্ধ হয়নি',
    'Bets placed after the fight began will be void and refunded to members due to unforeseen technical issues.': 'লড়াই শুরু হওয়ার পরে ধরা বাজিগুলো অনাকাঙ্ক্ষিত প্রযুক্তিগত সমস্যার কারণে বাতিল করা হবে এবং সদস্যদের ফেরত দেওয়া হবে।',
    'Terms & Conditions': 'শর্তাবলী',
    'Philippines Cockfighting': 'ফিলিপাইনের মোরগ লড়াই',
    'Challenge Rules': 'চ্যালেঞ্জের নিয়ম',
    'Banker / Meron': 'ব্যাংকার / Meron',
    'Player / Wala': 'প্লেয়ার / Wala',
    'Draw / No Winner': 'ড্র / কোনো বিজয়ী নেই',
    'During the Carreo Procedure (3 UP & 3 DOWN), neither rooster lands two (2) successful pecks, or': 'Carreo পদ্ধতি (3 UP & 3 DOWN) চলাকালে, কোনো মোরগ যদি দুই (2) বার সফল ঠোকর দিতে না পারে, অথবা',
    'No winner is declared within 10 minutes from the first contact.': 'প্রথম সংস্পর্শের ১০ মিনিটের মধ্যে কোনো বিজয়ী ঘোষণা করা না হয়।',
    '*Arena Judge decision is final.': '*এরিনা বিচারকের সিদ্ধান্তই চূড়ান্ত।',
    Cambodia: 'কম্বোডিয়া',
    'Cockfight Rules': 'মোরগ লড়াইয়ের নিয়ম',
    'Touching or Catching =': 'ছোঁয়া বা ধরা =',
    'Automatic Loss': 'স্বয়ংক্রিয় হার',
    'No External Help': 'কোনো বাহ্যিক সাহায্য নয়',
    'No fixing, No beak adjustment': 'কোনো ঠিক করা নয়, ঠোঁট সমন্বয় নয়',
    'No water': 'পানি নয়',
    'Defeated if': 'পরাজিত হবে যদি',
    'Lies Flat': 'চিৎ হয়ে পড়ে থাকে',
    'Runs Away / Cries': 'পালিয়ে যায় / চিৎকার করে',
    'No Retaliation × 3': 'প্রতিআক্রমণ না করে × ৩',
    'Standing beats Kneeling;': 'দাঁড়ানো হাঁটু গেড়ে থাকাকে হারায়;',
    'Kneeling beats Lying Flat': 'হাঁটু গেড়ে থাকা চিৎ হয়ে পড়ে থাকাকে হারায়',
    'NO ABUSED or POISONING ALLOWED': 'নির্যাতন বা বিষপ্রয়োগ অনুমোদিত নয়',
    'Tabletop Game Guide': 'টেবিলটপ গেম গাইড',
    'RULE: DON\'T FALL OFF!': 'নিয়ম: নিচে পড়বেন না!',
    'Roosters fight on the table top arena.': 'মোরগগুলো টেবিলটপ এরিনায় লড়াই করে।',
    'First rooster to touch the floor LOSES.': 'যে মোরগ প্রথমে মেঝে স্পর্শ করবে সে হারবে।',
    'Rooster remaining on the table WINS.': 'যে মোরগ টেবিলে থাকবে সে জিতবে।',
    'Draw when both rooster fall off at the same time': 'দুই মোরগ একই সময়ে টেবিল থেকে পড়ে গেলে ড্র হবে',
    'A match is declared DRAW (NO WINNER) if:': 'নিম্নলিখিত ক্ষেত্রে ম্যাচটি ড্র অর্থাৎ কোনো বিজয়ী নেই ঘোষণা করা হবে:',
    'The match began, but Arena Management determined that cock was injured. Arena management has the right to cancel the fight if neither cock has a cut or bleed. Any other unforeseeable events.': 'ম্যাচ শুরু হয়েছে, কিন্তু এরিনা ব্যবস্থাপনা নির্ধারণ করেছে যে মোরগটি আহত। যদি কোনো মোরগের কাটা বা রক্তপাত না থাকে, তবে এরিনা ব্যবস্থাপনার ম্যাচ বাতিল করার অধিকার রয়েছে। এছাড়াও অন্য যেকোনো অনাকাঙ্ক্ষিত ঘটনা।',
    Philippines: 'ফিলিপাইন',
    Tabletop: 'টেবিলটপ',
    'Max bet reached for this selection.': 'এই নির্বাচনের জন্য সর্বোচ্চ বাজির সীমা পূর্ণ হয়েছে।',
    'This arena has ended': 'এই অ্যারেনা শেষ হয়েছে',
    'Thank you for your support': 'আপনার সমর্থনের জন্য ধন্যবাদ',
    Portuguese: 'Português',
    Uzbek: 'Uzbek',
  },
  hant: {
    'Khmer': 'ភាសាខ្មែរ',
    Copy: '複製',
    Copied: '已複製',
    Oops: '哎呀',
    'We could not find the page.': '我們找不到該頁面。',
    'You are not authorized to view this page.': '您無權查看此頁面。',
    'Min-max': '最小-最大',
    History: '投注歷史',
    Help: '幫助',
    Banker: '莊',
    Player: '閒',
    Undo: '撤銷',
    Bet: '投注',
    Jackpot: '獎金池',
    'No fight at the moment': '目前沒有賽事',
    'F{fightNumber} is {fightStatus}': '賽事{fightNumber}狀態： {fightStatus}',
    Hrs: '時',
    Min: '分',
    Sec: '秒',
    'Load more': '加載更多',
    loading: '正在載入',
    'Congratulations!': '恭喜！',
    'Major ticket': '主要彩票',
    'Claim your prize': '領取您的獎品',
    'Current jackpot': '當前累積獎池',
    'Past winner': '往期獲勝者',
    'My tickets': '我的彩票',
    'Super draw': '超抽獎',
    Winners: '得獎者',
    Today: '今天',
    'No tickets earned': '目前無彩券',
    'You earn lucky draw ticket #{ticketId}': '您獲得幸運抽獎票 #{ticketId}',
    'Instant prize': '即時獎勵',
    Date: '日期',
    Time: '時間',
    Ante: '底注',
    'You can\'t place bet': '無法下注',
    Odds: '賠率',
    Results: '結果',
    'Win/lose': '贏/輸',
    Id: '編號',
    Match: '賽事',
    'Start time': '開始時間',
    Created: '創建',
    Confirmed: '投注開始',
    Closing: '投注即將結束',
    Closed: '投注結束',
    Started: '已開始',
    Ended: '已結束',
    Declared: '已宣布',
    Approved: '已批准',
    Processed: '已處理',
    Cancelled: '已取消',
    Hold: '暫停',
    Close: '關閉',
    Draw: '平手',
    'Bet detail': '投注詳情',
    Yesterday: '昨天',
    'This week': '本週',
    'Last week': '上週',
    Viet: 'Tiếng Việt',
    Thai: 'ภาษาไทย',
    Indo: 'Bahasa indo',
    'Account disabled': '帳戶已停用',
    'Invalid token': '認證無效',
    'Draw will be declared after 10-minute countdown': '持續超過10分鐘的戰鬥將被宣佈為平局。',
    Balance: '餘額',
    Tnc: '條款與條件',
    Progress: '進度',
    Open: '投注開始',
    'Okay, got it.': '好的，明白了。',
    'Please come back again': '請再次回來',
    Voided: '作廢',
    'Jackpot history': '獎金池歷史',
    'Jackpot help': '獎金池幫助',
    'Lucky draw': '幸運抽獎',
    'ANTE FOR JACKPOT GAME': '獎金池遊戲的底注',
    'Along with your bet, a small portion (known as the "ante") is automatically collected and added to the jackpot pool. This pool is a special fund that accumulates over time, contributed to by all players participating in the game.': '與您的投注同時，一小部分（稱為「底注」）會自動收集並添加到累積獎金池中。這個獎金池是一個特別的基金，隨著時間的推移而累積，由所有參與遊戲的玩家共同貢獻。',
    'ACCUMULATING PROGRESS FOR JACKPOT GAME': '獎金池遊戲的進度累積',
    'Each time you play, you make progress towards triggering the jackpot game. This progress is measured through a meter that fills up a little more each time you bet.': '每次您玩遊戲時，都會向觸發遊戲獎池的目標邁進一步。這個進度透過一個計量器來計算，每次您投注時，計量器就會稍微增加一點。',
    'JACKPOT GAME OCCURRENCE': '遊戲獎池',
    'Once you have accumulated enough progress, the jackpot game is triggered. This is a special event where you have the chance to win big prizes.': '一旦您累積了足夠的進度，獎金池遊戲就會被觸發。這是一個特別的事件，您有機會贏得大獎。\n\n',
    'Whether you win a Major, Minor, or Mini ticket, you\'re guaranteed an instant prize payout, with the value varying based on the type of ticket. Each ticket color represents a different prize level.': '無論您贏得大獎、小獎或迷你獎票，您都保證能獲得即時獎金支付，其價值會根據票種類而有所不同。每種票的顏色代表不同的獎勵等級。',
    'Each ticket type indicates the number of winners and the size of the prize. The lucky draw happens at the end of a countdown, creating anticipation and excitement. So, whether you have a Major, Minor, or Mini ticket, stay tuned for the draw to see if you\'ve won!': '每種票類型都表示了獲勝者的數量和獎品的大小。幸運抽獎在倒數結束時進行，創造了期待和興奮。因此，無論您持有大獎、小獎還是迷你獎票，請等待抽獎結果，看看您是否贏得了獎品！',
    'Instant prize & lucky draw': '即時獎勵 & 抽獎',
    '{arena} Video Stream': '{arena} 視訊直播',
    'Toggle video auto scale': '切換影片自動縮放',
    'Reload the streaming': '刷新直播串流',
    Commission: '佣金',
    Total: '總計',
    Win: '贏',
    'Your session expired, please login again.': '您的會話已過期，請重新登入。',
    'Go to login page': '前往登入頁面',
    Chinese: '简体中文',
    Statement: '對帳單',
    Main: '首頁',
    Limits: '限制',
    Settings: '設定',
    Notification: '通知',
    Logout: '登出',
    General: '幫助',
    'To read more': '閱讀更多',
    'Jackpot prize': '獎勵',
    Schedules: '賽事日曆',
    'Schedule details': '賽事詳情',
    Save: '儲存',
    Custom: '自訂',
    Maximum: '最大限額',
    'Float Video': '浮動視頻',
    Spanish: 'Español',
    Pakistan: 'اُردُو ',
    Korean: '한국어',
    Japanese: '日本語',
    'Stream locked': '直播已鎖定',
    'You need at least {CURRENCY} {AMOUNT} in your wallet to watch this stream.': '您的錢包餘額需至少達到 {CURRENCY} {AMOUNT} 才能觀看此直播。',
    'Cockfighting Rules': '鬥雞規則',
    Burmese: 'မြန်မာဘာသာစကား',
    'Bengali-Bangladesh': 'বাংলা',
    'Traditional Chinese': '繁體中文',
    'Hindi-India': 'हिन्दी',
    Earning: '盈利',
    'Bet not successful': '下注未成功',
    'Betting is paused. Please try again shortly. E25': '投注已暫停。請稍後再試。E25',
    'Bet guide': '下注指南',
    'Placing bet': '下注方式',
    'Select bet chip': '選擇下注籌碼',
    'Place chip by clicking on preferred bet selection': '點擊您想下注的位置放置籌碼',
    'Click Bet button to confirm your bet': '點擊「下注」按鈕確認下注',
    'Fair game rules': '公平遊戲規則',
    'Live streaming': '現場直播',
    'Unforeseen issues such as internet connectivity, power supply, or weather disruptions caused the live stream to be interrupted before the fight began.': '由於網路連線、電力供應或天氣等不可預見的問題，導致比賽開始前直播中斷。',
    'If the fight is not displayed on the game site, all bets will be refunded.': '如果比賽未在遊戲網站顯示，所有下注將會退款。',
    'Arena management decision': '賽場管理決定',
    'Arena management reserves the right to cancel any match; announcements regarding arena decisions will be made on a case-by-case basis.': '賽場管理方保留取消任何比賽的權利；有關賽場決定的公告將根據具體情況發布。',
    'Bet not closed in time': '下注未及時關閉',
    'Bets placed after the fight began will be void and refunded to members due to unforeseen technical issues.': '由於不可預見的技術問題，比賽開始後所下注單將作廢並退還給會員。',
    'Terms & Conditions': '條款與條件',
    'Philippines Cockfighting': '菲律賓鬥雞',
    'Challenge Rules': '挑戰規則',
    'Banker / Meron': '莊家 / Meron',
    'Player / Wala': '玩家 / Wala',
    'Draw / No Winner': '平局 / 無勝方',
    'During the Carreo Procedure (3 UP & 3 DOWN), neither rooster lands two (2) successful pecks, or': '在 Carreo 程序（3 UP & 3 DOWN）期間，若雙方鬥雞均未完成兩（2）次有效啄擊，或',
    'No winner is declared within 10 minutes from the first contact.': '從第一次接觸開始後 10 分鐘內未宣布勝方。',
    '*Arena Judge decision is final.': '*賽場裁判的決定為最終決定。',
    Cambodia: '柬埔寨',
    'Cockfight Rules': '鬥雞規則',
    'Touching or Catching =': '觸碰或抓住 =',
    'Automatic Loss': '自動判負',
    'No External Help': '不得外部協助',
    'No fixing, No beak adjustment': '不得修整，不得調整雞嘴',
    'No water': '不得餵水',
    'Defeated if': '判負條件',
    'Lies Flat': '平躺',
    'Runs Away / Cries': '逃跑 / 鳴叫',
    'No Retaliation × 3': '連續三次不反擊',
    'Standing beats Kneeling;': '站立勝過跪伏；',
    'Kneeling beats Lying Flat': '跪伏勝過平躺',
    'NO ABUSED or POISONING ALLOWED': '嚴禁虐待或投毒',
    'Tabletop Game Guide': '桌面賽遊戲指南',
    'RULE: DON\'T FALL OFF!': '規則：不要掉下去！',
    'Roosters fight on the table top arena.': '鬥雞在桌面賽場上進行比賽。',
    'First rooster to touch the floor LOSES.': '第一隻觸碰地面的鬥雞判負。',
    'Rooster remaining on the table WINS.': '留在桌面上的鬥雞獲勝。',
    'Draw when both rooster fall off at the same time': '雙方鬥雞同時掉下桌面則判為平局',
    'A match is declared DRAW (NO WINNER) if:': '以下情況比賽將判定為平局（無勝方）：',
    'The match began, but Arena Management determined that cock was injured. Arena management has the right to cancel the fight if neither cock has a cut or bleed. Any other unforeseeable events.': '比賽已經開始，但賽場管理方判定鬥雞受傷。若雙方鬥雞均無割傷或流血，賽場管理方有權取消比賽。以及任何其他不可預見的事件。',
    Philippines: '菲律賓',
    Tabletop: '桌面賽',
    'Max bet reached for this selection.': '此選項已達到最高投注限額。',
    'This arena has ended': '本場已結束',
    'Thank you for your support': '感謝您的支持',
    Portuguese: 'Português',
    Uzbek: 'Uzbek',
  },
  in: {
    'Khmer': 'ភាសាខ្មែរ',
    Copy: 'कॉपी करें',
    Copied: 'कॉपी हो गया',
    Oops: 'ओह!',
    'We could not find the page.': 'हमें पृष्ठ नहीं मिला।',
    'You are not authorized to view this page.': 'आपको इस पृष्ठ को देखने की अनुमति नहीं है।',
    'Min-max': 'न्यूनतम–अधिकतम',
    History: 'इतिहास',
    Help: 'सहायता',
    Banker: 'Banker',
    Player: 'Player',
    Undo: 'पूर्ववत करें',
    Bet: 'Bet',
    Jackpot: 'जैकपॉट',
    'No fight at the moment': 'इस समय कोई लड़ाई नहीं है',
    'F{fightNumber} is {fightStatus}': 'F{fightNumber} {fightStatus} है',
    Hrs: 'घंटे',
    Min: 'मिन',
    Sec: 'सेकंड',
    'Load more': 'और लोड करें',
    loading: 'लोड हो रहा है…',
    'Congratulations!': 'बधाई हो!',
    'Major ticket': 'मेजर टिकट',
    'Claim your prize': 'अपना पुरस्कार प्राप्त करें',
    'Current jackpot': 'वर्तमान जैकपॉट',
    'Past winner': 'पिछले विजेता',
    'My tickets': 'मेरे टिकट',
    'Super draw': 'सुपर ड्रॉ',
    Winners: 'विजेता',
    Today: 'आज',
    'No tickets earned': 'कोई टिकट प्राप्त नहीं हुआ',
    'You earn lucky draw ticket #{ticketId}': 'आपने लकी ड्रॉ टिकट #{ticketId} प्राप्त किया',
    'Instant prize': 'त्वरित पुरस्कार',
    Date: 'तिथि',
    Time: 'समय',
    Ante: 'एंटे',
    'You can\'t place bet': 'आप दांव नहीं लगा सकते',
    Odds: 'ऑड्स',
    Results: 'परिणाम',
    'Win/lose': 'जीत/हार',
    Id: 'आईडी',
    Match: 'मैच',
    'Start time': 'प्रारंभ समय',
    Created: 'बनाया गया',
    Confirmed: 'पुष्टि की गई',
    Closing: 'बंद हो रहा है',
    Closed: 'बंद',
    Started: 'शुरू हुआ',
    Ended: 'समाप्त हुआ',
    Declared: 'घोषित',
    Approved: 'स्वीकृत',
    Processed: 'संसाधित',
    Cancelled: 'रद्द किया गया',
    Hold: 'होल्ड',
    Close: 'बंद करें',
    Draw: 'ड्रा',
    'Bet detail': 'दांव विवरण',
    Yesterday: 'कल',
    'This week': 'इस सप्ताह',
    'Last week': 'पिछले सप्ताह',
    Viet: 'Tiếng Việt',
    Thai: 'ภาษาไทย',
    Indo: 'Bahasa indo',
    'Account disabled': 'खाता निष्क्रिय कर दिया गया है',
    'Invalid token': 'अमान्य टोकन',
    'Draw will be declared after 10-minute countdown': '10 मिनट की उलटी गिनती के बाद ड्रा घोषित किया जाएगा',
    Balance: 'शेष राशि',
    Tnc: 'नियम और शर्तें',
    Progress: 'प्रगति',
    Open: 'खोलें',
    'Okay, got it.': 'ठीक है, समझ गया।',
    'Please come back again': 'कृपया बाद में फिर आएँ',
    Voided: 'अमान्य किया गया',
    'Jackpot history': 'जैकपॉट इतिहास',
    'Jackpot help': 'जैकपॉट सहायता',
    'Lucky draw': 'लकी ड्रॉ',
    'ANTE FOR JACKPOT GAME': 'जैकपॉट गेम के लिए एंटे',
    'Along with your bet, a small portion (known as the "ante") is automatically collected and added to the jackpot pool. This pool is a special fund that accumulates over time, contributed to by all players participating in the game.': 'आपके दांव के साथ, एक छोटा हिस्सा (जिसे “एंटे” कहा जाता है) स्वचालित रूप से लिया जाता है और जैकपॉट पूल में जोड़ दिया जाता है। यह पूल समय के साथ जमा होने वाला विशेष कोष है, जिसमें खेल में भाग लेने वाले सभी खिलाड़ियों का योगदान होता है।',
    'ACCUMULATING PROGRESS FOR JACKPOT GAME': 'जैकपॉट गेम के लिए प्रगति संचय',
    'Each time you play, you make progress towards triggering the jackpot game. This progress is measured through a meter that fills up a little more each time you bet.': 'हर बार खेलने पर, आप जैकपॉट गेम ट्रिगर करने की दिशा में प्रगति करते हैं। यह प्रगति एक मीटर से मापी जाती है, जो हर दांव के साथ थोड़ा-थोड़ा भरता है।',
    'JACKPOT GAME OCCURRENCE': 'जैकपॉट गेम की घटना',
    'Once you have accumulated enough progress, the jackpot game is triggered. This is a special event where you have the chance to win big prizes.': 'पर्याप्त प्रगति जमा होने पर जैकपॉट गेम ट्रिगर होता है। यह एक विशेष इवेंट है जिसमें आपको बड़े पुरस्कार जीतने का अवसर मिलता है।',
    'Whether you win a Major, Minor, or Mini ticket, you\'re guaranteed an instant prize payout, with the value varying based on the type of ticket. Each ticket color represents a different prize level.': 'आप मेजर, माइनर या मिनी टिकट में से जो भी जीतें, आपको त्वरित पुरस्कार भुगतान की गारंटी होती है, जिसकी राशि टिकट के प्रकार के अनुसार बदलती है। प्रत्येक टिकट का रंग अलग पुरस्कार स्तर दर्शाता है।',
    'Each ticket type indicates the number of winners and the size of the prize. The lucky draw happens at the end of a countdown, creating anticipation and excitement. So, whether you have a Major, Minor, or Mini ticket, stay tuned for the draw to see if you\'ve won!': 'प्रत्येक टिकट प्रकार विजेताओं की संख्या और पुरस्कार की राशि दर्शाता है। लकी ड्रॉ काउंटडाउन के अंत में होता है, जो उत्सुकता और रोमांच बढ़ाता है। इसलिए आपके पास मेजर, माइनर या मिनी टिकट हो—ड्रा तक जुड़े रहें और देखें कि आप जीते हैं या नहीं!',
    'Instant prize & lucky draw': 'त्वरित पुरस्कार और लकी ड्रॉ',
    '{arena} Video Stream': '{arena} वीडियो स्ट्रीम',
    'Toggle video auto scale': 'वीडियो ऑटो-स्केल टॉगल करें',
    'Reload the streaming': 'स्ट्रीमिंग दोबारा लोड करें',
    Commission: 'कमीशन',
    Total: 'कुल',
    Win: 'जीत',
    'Your session expired, please login again.': 'आपका सत्र समाप्त हो गया है, कृपया दोबारा लॉगिन करें।',
    'Go to login page': 'लॉगिन पेज पर जाएँ',
    Chinese: '简体中文',
    Statement: 'स्टेटमेंट',
    Main: 'मुख्य',
    Limits: 'सीमाएँ',
    Settings: 'सेटिंग्स',
    Notification: 'सूचनाएँ',
    Logout: 'लॉगआउट',
    General: 'सामान्य',
    'To read more': 'और पढ़ें',
    'Jackpot prize': 'जैकपॉट पुरस्कार',
    Schedules: 'समय-सारिणी',
    'Schedule details': 'समय-सारिणी विवरण',
    Save: 'सहेजें',
    Custom: 'कस्टम',
    Maximum: 'अधिकतम',
    'Float Video': 'फ्लोट वीडियो',
    Spanish: 'Español',
    Pakistan: 'اُردُو ',
    Korean: '한국어',
    Japanese: '日本語',
    'Stream locked': 'स्ट्रीम लॉक है',
    'You need at least {CURRENCY} {AMOUNT} in your wallet to watch this stream.': 'यह स्ट्रीम देखने के लिए आपके वॉलेट में कम से कम {CURRENCY} {AMOUNT} होना चाहिए।',
    'Cockfighting Rules': 'कॉकफाइटिंग के नियम',
    Burmese: 'မြန်မာဘာသာစကား',
    'Bengali-Bangladesh': 'বাংলা',
    'Traditional Chinese': '繁體中文',
    'Hindi-India': 'हिन्दी',
    Earning: 'लाभ',
    'Bet not successful': 'बेट सफल नहीं हुई',
    'Betting is paused. Please try again shortly. E25': 'बेटिंग अस्थायी रूप से रोकी गई है। कृपया थोड़ी देर बाद फिर प्रयास करें। E25',
    'Bet guide': 'बेट गाइड',
    'Placing bet': 'बेट लगाना',
    'Select bet chip': 'बेट चिप चुनें',
    'Place chip by clicking on preferred bet selection': 'अपनी पसंदीदा बेट चयन पर क्लिक करके चिप रखें',
    'Click Bet button to confirm your bet': 'अपनी बेट की पुष्टि करने के लिए Bet बटन पर क्लिक करें',
    'Fair game rules': 'निष्पक्ष खेल के नियम',
    'Live streaming': 'लाइव स्ट्रीमिंग',
    'Unforeseen issues such as internet connectivity, power supply, or weather disruptions caused the live stream to be interrupted before the fight began.': 'इंटरनेट कनेक्टिविटी, बिजली आपूर्ति या मौसम जैसी अप्रत्याशित समस्याओं के कारण लड़ाई शुरू होने से पहले लाइव स्ट्रीम बाधित हो गई।',
    'If the fight is not displayed on the game site, all bets will be refunded.': 'यदि लड़ाई गेम साइट पर प्रदर्शित नहीं होती है, तो सभी बेट वापस कर दी जाएंगी।',
    'Arena management decision': 'एरीना प्रबंधन का निर्णय',
    'Arena management reserves the right to cancel any match; announcements regarding arena decisions will be made on a case-by-case basis.': 'एरीना प्रबंधन किसी भी मैच को रद्द करने का अधिकार सुरक्षित रखता है; एरीना निर्णयों से संबंधित घोषणाएं प्रत्येक मामले के आधार पर की जाएंगी।',
    'Bet not closed in time': 'बेट समय पर बंद नहीं हुई',
    'Bets placed after the fight began will be void and refunded to members due to unforeseen technical issues.': 'लड़ाई शुरू होने के बाद लगाई गई बेट अप्रत्याशित तकनीकी समस्याओं के कारण अमान्य कर दी जाएगी और सदस्यों को वापस कर दी जाएगी।',
    'Terms & Conditions': 'नियम और शर्तें',
    'Philippines Cockfighting': 'फिलिपींस मुर्गा लड़ाई',
    'Challenge Rules': 'चैलेंज नियम',
    'Banker / Meron': 'बैंकर / Meron',
    'Player / Wala': 'प्लेयर / Wala',
    'Draw / No Winner': 'ड्रॉ / कोई विजेता नहीं',
    'During the Carreo Procedure (3 UP & 3 DOWN), neither rooster lands two (2) successful pecks, or': 'Carreo प्रक्रिया (3 UP & 3 DOWN) के दौरान, यदि कोई भी मुर्गा दो (2) सफल चोंच मारने में सफल नहीं होता, या',
    'No winner is declared within 10 minutes from the first contact.': 'पहले संपर्क से 10 मिनट के भीतर कोई विजेता घोषित नहीं किया जाता।',
    '*Arena Judge decision is final.': '*एरीना जज का निर्णय अंतिम है।',
    Cambodia: 'कंबोडिया',
    'Cockfight Rules': 'मुर्गा लड़ाई के नियम',
    'Touching or Catching =': 'छूना या पकड़ना =',
    'Automatic Loss': 'स्वचालित हार',
    'No External Help': 'कोई बाहरी सहायता नहीं',
    'No fixing, No beak adjustment': 'कोई सुधार नहीं, चोंच समायोजन नहीं',
    'No water': 'पानी नहीं',
    'Defeated if': 'हार घोषित होगी यदि',
    'Lies Flat': 'सीधा लेट जाए',
    'Runs Away / Cries': 'भाग जाए / आवाज करे',
    'No Retaliation × 3': 'तीन बार जवाबी हमला न करे',
    'Standing beats Kneeling;': 'खड़ा होना घुटने टेकने से बेहतर है;',
    'Kneeling beats Lying Flat': 'घुटने टेकना सीधे लेटने से बेहतर है',
    'NO ABUSED or POISONING ALLOWED': 'दुर्व्यवहार या ज़हर देने की अनुमति नहीं',
    'Tabletop Game Guide': 'टेबलटॉप गेम गाइड',
    'RULE: DON\'T FALL OFF!': 'नियम: नीचे न गिरें!',
    'Roosters fight on the table top arena.': 'मुर्गे टेबलटॉप एरीना पर लड़ते हैं।',
    'First rooster to touch the floor LOSES.': 'जो मुर्गा पहले फर्श को छूता है वह हारता है।',
    'Rooster remaining on the table WINS.': 'जो मुर्गा टेबल पर रहता है वह जीतता है।',
    'Draw when both rooster fall off at the same time': 'यदि दोनों मुर्गे एक ही समय पर टेबल से गिरते हैं तो ड्रॉ होगा',
    'A match is declared DRAW (NO WINNER) if:': 'मैच को ड्रॉ यानी कोई विजेता नहीं घोषित किया जाएगा यदि:',
    'The match began, but Arena Management determined that cock was injured. Arena management has the right to cancel the fight if neither cock has a cut or bleed. Any other unforeseeable events.': 'मैच शुरू हो चुका है, लेकिन एरीना प्रबंधन ने निर्धारित किया कि मुर्गा घायल है। यदि किसी भी मुर्गे को कट या खून नहीं है, तो एरीना प्रबंधन को लड़ाई रद्द करने का अधिकार है। कोई अन्य अप्रत्याशित घटना भी शामिल है।',
    Philippines: 'फिलिपींस',
    Tabletop: 'टेबलटॉप',
    'Max bet reached for this selection.': 'इस चयन के लिए अधिकतम बेट सीमा पूरी हो गई है।',
    'This arena has ended': 'यह एरीना समाप्त हो गया है',
    'Thank you for your support': 'आपके समर्थन के लिए धन्यवाद',
    Portuguese: 'Português',
    Uzbek: 'Uzbek',
  },
  kh: {
    'Khmer': 'ភាសាខ្មែរ',
    Copy: 'ចម្លង',
    Copied: 'បានចម្លង',
    Oops: 'អូ៎!',
    'We could not find the page.': 'យើងមិនអាចរកឃើញទំព័រនេះទេ។',
    'You are not authorized to view this page.': 'អ្នកមិនមានសិទ្ធិមើលទំព័រនេះទេ។',
    'Min-max': 'អប្បបរមា-អតិបរមា',
    History: 'ប្រវត្តិ',
    Help: 'ជំនួយ',
    Banker: 'Banker',
    Player: 'Player',
    Undo: 'មិនធ្វើវិញ',
    Bet: 'Bet',
    Jackpot: 'ជែកផត',
    'No fight at the moment': 'បច្ចុប្បន្នមិនមានការប្រកួតទេ',
    'F{fightNumber} is {fightStatus}': 'ការប្រកួត F{fightNumber} គឺ {fightStatus}',
    Hrs: 'ម៉ោង',
    Min: 'នាទី',
    Sec: 'វិនាទី',
    'Load more': 'ផ្ទុកបន្ថែម',
    loading: 'កំពុងផ្ទុក',
    'Congratulations!': 'សូមអបអរសាទរ!',
    'Major ticket': 'សំបុត្រ Major',
    'Claim your prize': 'ទាមទាររង្វាន់របស់អ្នក',
    'Current jackpot': 'ជែកផតបច្ចុប្បន្ន',
    'Past winner': 'អ្នកឈ្នះកន្លងមក',
    'My tickets': 'សំបុត្ររបស់ខ្ញុំ',
    'Super draw': 'ការចាប់រង្វាន់ធំ',
    Winners: 'អ្នកឈ្នះ',
    Today: 'ថ្ងៃនេះ',
    'No tickets earned': 'មិនទទួលបានសំបុត្រទេ',
    'You earn lucky draw ticket #{ticketId}': 'អ្នកទទួលបានសំបុត្រចាប់រង្វាន់លេខ #{ticketId}',
    'Instant prize': 'រង្វាន់ភ្លាមៗ',
    Date: 'កាលបរិច្ឆេទ',
    Time: 'ពេលវេលា',
    Ante: 'ថ្លៃ Ante',
    'You can\'t place bet': 'អ្នកមិនអាចដាក់ភ្នាល់បានទេ',
    Odds: 'ហាងឆេង',
    Results: 'លទ្ធផល',
    'Win/lose': 'ឈ្នះ/ចាញ់',
    Id: 'លេខសម្គាល់',
    Match: 'ការប្រកួត',
    'Start time': 'ពេលចាប់ផ្តើម',
    Created: 'បានបង្កើត',
    Confirmed: 'បានបញ្ជាក់',
    Closing: 'កំពុងបិទ',
    Closed: 'បានបិទ',
    Started: 'បានចាប់ផ្តើម',
    Ended: 'បានបញ្ចប់',
    Declared: 'បានប្រកាស',
    Approved: 'បានអនុម័ត',
    Processed: 'បានដំណើរការ',
    Cancelled: 'បានលុបចោល',
    Hold: 'ផ្អាក',
    Close: 'បិទ',
    Draw: 'ស្មើ',
    'Bet detail': 'ព័ត៌មានលម្អិតនៃការភ្នាល់',
    Yesterday: 'ម្សិលមិញ',
    'This week': 'សប្ដាហ៍នេះ',
    'Last week': 'សប្ដាហ៍មុន',
    Viet: 'Tiếng Việt',
    Thai: 'ภาษาไทย',
    Indo: 'Bahasa indo',
    'Account disabled': 'គណនីត្រូវបានបិទ',
    'Invalid token': 'Token មិនត្រឹមត្រូវ',
    'Draw will be declared after 10-minute countdown': 'លទ្ធផលស្មើនឹងត្រូវប្រកាសបន្ទាប់ពីការរាប់ថយក្រោយ 10 នាទី',
    Balance: 'សមតុល្យ',
    Tnc: 'លក្ខខណ្ឌ',
    Progress: 'វឌ្ឍនភាព',
    Open: 'បើក',
    'Okay, got it.': 'យល់ព្រម ខ្ញុំបានយល់ហើយ។',
    'Please come back again': 'សូមត្រឡប់មកម្តងទៀត',
    Voided: 'បានចាត់ទុកជាមោឃៈ',
    'Jackpot history': 'ប្រវត្តិជែកផត',
    'Jackpot help': 'ជំនួយជែកផត',
    'Lucky draw': 'ការចាប់រង្វាន់',
    'ANTE FOR JACKPOT GAME': 'ថ្លៃ ANTE សម្រាប់ហ្គេម JACKPOT',
    'Along with your bet, a small portion (known as the "ante") is automatically collected and added to the jackpot pool. This pool is a special fund that accumulates over time, contributed to by all players participating in the game.': 'រួមជាមួយការភ្នាល់របស់អ្នក ប្រាក់មួយផ្នែកតូចដែលហៅថា “Ante” នឹងត្រូវប្រមូលដោយស្វ័យប្រវត្តិ និងបញ្ចូលទៅក្នុងមូលនិធិជែកផត។ មូលនិធិនេះជាប្រាក់រង្វាន់ពិសេសដែលកើនឡើងជាបន្តបន្ទាប់ពីការរួមចំណែករបស់អ្នកលេងទាំងអស់ដែលចូលរួមក្នុងហ្គេម។',
    'ACCUMULATING PROGRESS FOR JACKPOT GAME': 'ការប្រមូលវឌ្ឍនភាពសម្រាប់ហ្គេម JACKPOT',
    'Each time you play, you make progress towards triggering the jackpot game. This progress is measured through a meter that fills up a little more each time you bet.': 'រាល់ពេលដែលអ្នកលេង អ្នកនឹងបង្កើនវឌ្ឍនភាពឆ្ពោះទៅរកការបើកហ្គេមជែកផត។ វឌ្ឍនភាពនេះត្រូវបានបង្ហាញតាមរង្វាស់ ដែលនឹងកើនឡើងបន្តិចម្ដងៗរាល់ពេលអ្នកដាក់ភ្នាល់។',
    'JACKPOT GAME OCCURRENCE': 'ការកើតឡើងនៃហ្គេម JACKPOT',
    'Once you have accumulated enough progress, the jackpot game is triggered. This is a special event where you have the chance to win big prizes.': 'នៅពេលអ្នកប្រមូលវឌ្ឍនភាពបានគ្រប់គ្រាន់ ហ្គេមជែកផតនឹងត្រូវបានបើក។ នេះគឺជាព្រឹត្តិការណ៍ពិសេសដែលផ្តល់ឱកាសឱ្យអ្នកឈ្នះរង្វាន់ធំ។',
    'Whether you win a Major, Minor, or Mini ticket, you\'re guaranteed an instant prize payout, with the value varying based on the type of ticket. Each ticket color represents a different prize level.': 'មិនថាអ្នកឈ្នះសំបុត្រ Major, Minor ឬ Mini ទេ អ្នកនឹងទទួលបានរង្វាន់ភ្លាមៗជានិច្ច ដោយតម្លៃរង្វាន់អាស្រ័យលើប្រភេទសំបុត្រ។ ពណ៌នីមួយៗរបស់សំបុត្រតំណាងឱ្យកម្រិតរង្វាន់ខុសៗគ្នា។',
    'Each ticket type indicates the number of winners and the size of the prize. The lucky draw happens at the end of a countdown, creating anticipation and excitement. So, whether you have a Major, Minor, or Mini ticket, stay tuned for the draw to see if you\'ve won!': 'ប្រភេទសំបុត្រនីមួយៗបង្ហាញពីចំនួនអ្នកឈ្នះ និងទំហំរង្វាន់។ ការចាប់រង្វាន់នឹងធ្វើឡើងនៅពេលការរាប់ថយក្រោយបញ្ចប់ ដើម្បីបង្កើតភាពរំភើប និងការរំពឹងទុក។ ដូច្នេះ មិនថាអ្នកមានសំបុត្រ Major, Minor ឬ Mini ទេ សូមរង់ចាំការចាប់រង្វាន់ ដើម្បីដឹងថាអ្នកបានឈ្នះឬអត់!',
    'Instant prize & lucky draw': 'រង្វាន់ភ្លាមៗ និងការចាប់រង្វាន់',
    '{arena} Video Stream': 'ស្ទ្រីមវីដេអូ {arena}',
    'Toggle video auto scale': 'បើក/បិទការកែទំហំវីដេអូដោយស្វ័យប្រវត្តិ',
    'Reload the streaming': 'ផ្ទុកស្ទ្រីមឡើងវិញ',
    Commission: 'កម្រៃជើងសារ',
    Total: 'សរុប',
    Win: 'ឈ្នះ',
    'Your session expired, please login again.': 'Session របស់អ្នកបានផុតកំណត់ សូមចូលគណនីម្តងទៀត។',
    'Go to login page': 'ទៅកាន់ទំព័រចូលគណនី',
    Chinese: '简体中文',
    Statement: 'របាយការណ៍',
    Main: 'ទំព័រមេ',
    Limits: 'កម្រិត',
    Settings: 'ការកំណត់',
    Notification: 'ការជូនដំណឹង',
    Logout: 'ចាកចេញ',
    General: 'ទូទៅ',
    'To read more': 'អានបន្ថែម',
    'Jackpot prize': 'រង្វាន់ជែកផត',
    Schedules: 'កាលវិភាគ',
    'Schedule details': 'ព័ត៌មានលម្អិតនៃកាលវិភាគ',
    Save: 'រក្សាទុក',
    Custom: 'ផ្ទាល់ខ្លួន',
    Maximum: 'អតិបរមា',
    'Float Video': 'វីដេអូអណ្តែត',
    Spanish: 'Español',
    Pakistan: 'اُردُو ',
    Korean: '한국어',
    Japanese: '日本語',
    'Stream locked': 'ស្ទ្រីមត្រូវបានចាក់សោ',
    'You need at least {CURRENCY} {AMOUNT} in your wallet to watch this stream.': 'អ្នកត្រូវមានយ៉ាងហោចណាស់ {CURRENCY} {AMOUNT} នៅក្នុងកាបូបរបស់អ្នក ដើម្បីមើលស្ទ្រីមនេះ។',
    'Cockfighting Rules': 'ច្បាប់ប្រកួតមាន់',
    Burmese: 'မြန်မာဘာသာစကား',
    'Bengali-Bangladesh': 'বাংলা',
    'Traditional Chinese': '繁體中文',
    'Hindi-India': 'हिन्दी',
    Earning: 'ប្រាក់ចំណូល',
    'Bet not successful': 'ការភ្នាល់មិនបានជោគជ័យ',
    'Betting is paused. Please try again shortly. E25': 'ការភ្នាល់ត្រូវបានផ្អាក។ សូមព្យាយាមម្តងទៀតបន្តិចក្រោយ។ E25',
    'Bet guide': 'ការណែនាំអំពីការភ្នាល់',
    'Placing bet': 'ការដាក់ភ្នាល់',
    'Select bet chip': 'ជ្រើសរើសឈីបភ្នាល់',
    'Place chip by clicking on preferred bet selection': 'ដាក់ឈីបដោយចុចលើជម្រើសភ្នាល់ដែលអ្នកចង់បាន',
    'Click Bet button to confirm your bet': 'ចុចប៊ូតុង ភ្នាល់ ដើម្បីបញ្ជាក់ការភ្នាល់របស់អ្នក',
    'Fair game rules': 'ច្បាប់ហ្គេមយុត្តិធម៌',
    'Live streaming': 'ការផ្សាយផ្ទាល់',
    'Unforeseen issues such as internet connectivity, power supply, or weather disruptions caused the live stream to be interrupted before the fight began.': 'បញ្ហាដែលមិនអាចព្យាករណ៍បាន ដូចជាការរំខានអ៊ីនធឺណិត អគ្គិសនី ឬអាកាសធាតុ បានធ្វើឱ្យការផ្សាយផ្ទាល់ត្រូវបានផ្អាក មុនពេលការប្រកួតចាប់ផ្តើម។',
    'If the fight is not displayed on the game site, all bets will be refunded.': 'ប្រសិនបើការប្រកួតមិនត្រូវបានបង្ហាញនៅលើគេហទំព័រហ្គេម ការភ្នាល់ទាំងអស់នឹងត្រូវសងវិញ។',
    'Arena management decision': 'ការសម្រេចចិត្តរបស់អ្នកគ្រប់គ្រងសង្វៀន',
    'Arena management reserves the right to cancel any match; announcements regarding arena decisions will be made on a case-by-case basis.': 'អ្នកគ្រប់គ្រងសង្វៀនរក្សាសិទ្ធិក្នុងការលុបចោលការប្រកួតណាមួយ។ ការជូនដំណឹងអំពីការសម្រេចចិត្តរបស់សង្វៀននឹងធ្វើឡើងតាមករណីនីមួយៗ។',
    'Bet not closed in time': 'ការភ្នាល់មិនបានបិទទាន់ពេល',
    'Bets placed after the fight began will be void and refunded to members due to unforeseen technical issues.': 'ការភ្នាល់ដែលបានដាក់បន្ទាប់ពីការប្រកួតចាប់ផ្តើម នឹងត្រូវចាត់ទុកជាមោឃៈ និងសងប្រាក់ទៅសមាជិកវិញ ដោយសារបញ្ហាបច្ចេកទេសដែលមិនអាចព្យាករណ៍បាន។',
    'Terms & Conditions': 'លក្ខខណ្ឌនានា',
    'Philippines Cockfighting': 'ការប្រកួតមាន់ហ្វីលីពីន',
    'Challenge Rules': 'ច្បាប់ប្រកួត',
    'Banker / Meron': 'មេរ៉ុន / Meron',
    'Player / Wala': 'វ៉ាឡា / Wala',
    'Draw / No Winner': 'ស្មើ / គ្មានអ្នកឈ្នះ',
    'During the Carreo Procedure (3 UP & 3 DOWN), neither rooster lands two (2) successful pecks, or': 'ក្នុងអំឡុងនីតិវិធី Carreo (ឡើង 3 ដង និងចុះ 3 ដង) មាន់ទាំងពីរមិនអាចចឹកបានជោគជ័យពីរ (2) ដង ឬ',
    'No winner is declared within 10 minutes from the first contact.': '*សេចក្ដីសម្រេចរបស់អាជ្ញាកណ្ដាលសង្វៀនគឺជាចុងក្រោយ។',
    '*Arena Judge decision is final.': '',
    Cambodia: 'កម្ពុជា',
    'Cockfight Rules': 'ច្បាប់ប្រកួតមាន់',
    'Touching or Catching =': 'ការប៉ះ ឬការចាប់ =',
    'Automatic Loss': 'ចាញ់ដោយស្វ័យប្រវត្តិ',
    'No External Help': 'ហាមជំនួយពីខាងក្រៅ',
    'No fixing, No beak adjustment': 'ហាមជួសជុល ហាមកែចំពុះ',
    'No water': 'ហាមឱ្យទឹក',
    'Defeated if': 'ចាញ់ ប្រសិនបើ',
    'Lies Flat': 'ដេករាបស្មើ',
    'Runs Away / Cries': 'រត់គេច / ស្រែក',
    'No Retaliation × 3': 'មិនតបត × 3',
    'Standing beats Kneeling;': 'ឈរឈ្នះលុតជង្គង់;',
    'Kneeling beats Lying Flat': 'លុតជង្គង់ឈ្នះដេករាបស្មើ',
    'NO ABUSED or POISONING ALLOWED': 'ហាមការធ្វើបាប ឬការដាក់ថ្នាំពុល',
    'Tabletop Game Guide': 'ការណែនាំហ្គេមលើតុ',
    'RULE: DON\'T FALL OFF!': 'ច្បាប់៖ កុំធ្លាក់ពីតុ!',
    'Roosters fight on the table top arena.': 'មាន់ប្រកួតនៅលើសង្វៀនលើតុ។',
    'First rooster to touch the floor LOSES.': 'មាន់ដែលប៉ះដីមុនគេ ចាញ់។',
    'Rooster remaining on the table WINS.': 'មាន់ដែលនៅសល់លើតុ ឈ្នះ។',
    'Draw when both rooster fall off at the same time': 'ស្មើ ប្រសិនបើមាន់ទាំងពីរធ្លាក់ពីតុក្នុងពេលតែមួយ។',
    'A match is declared DRAW (NO WINNER) if:': 'ការប្រកួតនឹងត្រូវប្រកាសថា ស្មើ (គ្មានអ្នកឈ្នះ) ប្រសិនបើ៖',
    'The match began, but Arena Management determined that cock was injured. Arena management has the right to cancel the fight if neither cock has a cut or bleed. Any other unforeseeable events.': 'ការប្រកួតបានចាប់ផ្តើម ប៉ុន្តែអ្នកគ្រប់គ្រងសង្វៀនកំណត់ថា មាន់មួយបានរងរបួស។ អ្នកគ្រប់គ្រងសង្វៀនមានសិទ្ធិលុបចោលការប្រកួត ប្រសិនបើមាន់ទាំងពីរមិនមានស្នាមកាត់ ឬហូរឈាម។ ឬមានព្រឹត្តិការណ៍ផ្សេងទៀតដែលមិនអាចព្យាករណ៍បាន។',
    Philippines: 'ហ្វីលីពីន',
    Tabletop: 'លើតុ',
    'Max bet reached for this selection.': 'បានដល់កម្រិតភ្នាល់អតិបរមាសម្រាប់ជម្រើសនេះ។',
    'This arena has ended': 'សង្វៀននេះបានបញ្ចប់ហើយ',
    'Thank you for your support': 'សូមអរគុណសម្រាប់ការគាំទ្ររបស់អ្នក',
    Portuguese: 'Português',
    Uzbek: 'Uzbek',
  },
  pt: {
    'Khmer': 'ភាសាខ្មែរ',
    Copy: 'Copiar',
    Copied: 'Copiado',
    Oops: 'Ops',
    'We could not find the page.': 'Não foi possível encontrar a página.',
    'You are not authorized to view this page.': 'Você não tem autorização para acessar esta página.',
    'Min-max': 'Mín.-máx.',
    History: 'Histórico',
    Help: 'Ajuda',
    Banker: 'Banker',
    Player: 'Player',
    Undo: 'Par',
    Bet: 'Bet',
    Jackpot: 'Jackpot',
    'No fight at the moment': 'Nenhuma luta no momento',
    'F{fightNumber} is {fightStatus}': 'F{fightNumber} está {fightStatus}',
    Hrs: 'Hrs',
    Min: 'Min',
    Sec: 'Seg',
    'Load more': 'Carregar mais',
    loading: 'Carregando',
    'Congratulations!': 'Parabéns!',
    'Major ticket': 'Bilhete Major',
    'Claim your prize': 'Resgate seu prêmio',
    'Current jackpot': 'Jackpot atual',
    'Past winner': 'Vencedor anterior',
    'My tickets': 'Meus bilhetes',
    'Super draw': 'Supersorteio',
    Winners: 'Vencedores',
    Today: 'Hoje',
    'No tickets earned': 'Nenhum bilhete ganho',
    'You earn lucky draw ticket #{ticketId}': 'Você ganhou o bilhete de sorteio #{ticketId}',
    'Instant prize': 'Prêmio instantâneo',
    Date: 'Data',
    Time: 'Hora',
    Ante: 'Ante',
    'You can\'t place bet': 'Você não pode apostar',
    Odds: 'Cotações',
    Results: 'Resultados',
    'Win/lose': 'Ganho/perda',
    Id: 'ID',
    Match: 'Partida',
    'Start time': 'Horário de início',
    Created: 'Criado',
    Confirmed: 'Confirmado',
    Closing: 'Encerrando',
    Closed: 'Encerrado',
    Started: 'Iniciado',
    Ended: 'Finalizado',
    Declared: 'Declarado',
    Approved: 'Aprovado',
    Processed: 'Processado',
    Cancelled: 'Cancelado',
    Hold: 'Retido',
    Close: 'Fechar',
    Draw: 'Empate',
    'Bet detail': 'Detalhes da aposta',
    Yesterday: 'Ontem',
    'This week': 'Esta semana',
    'Last week': 'Semana passada',
    Viet: 'Tiếng Việt',
    Thai: 'ภาษาไทย',
    Indo: 'Bahasa indo',
    'Account disabled': 'Conta desativada',
    'Invalid token': 'Token inválido',
    'Draw will be declared after 10-minute countdown': 'O empate será declarado após a contagem regressiva de 10 minutos',
    Balance: 'Saldo',
    Tnc: 'Termos e Condições',
    Progress: 'Progresso',
    Open: 'Abrir',
    'Okay, got it.': 'Ok, entendi.',
    'Please come back again': 'Por favor, volte mais tarde.',
    Voided: 'Anulado',
    'Jackpot history': 'Histórico do jackpot',
    'Jackpot help': 'Ajuda do jackpot',
    'Lucky draw': 'Sorteio',
    'ANTE FOR JACKPOT GAME': 'ANTE PARA O JOGO DE JACKPOT',
    'Along with your bet, a small portion (known as the "ante") is automatically collected and added to the jackpot pool. This pool is a special fund that accumulates over time, contributed to by all players participating in the game.': 'Ao fazer sua aposta, uma pequena quantia, conhecida como “ante”, é automaticamente recolhida e adicionada ao fundo do jackpot. Esse fundo especial acumula valores ao longo do tempo com as contribuições de todos os jogadores participantes.',
    'ACCUMULATING PROGRESS FOR JACKPOT GAME': 'ACÚMULO DE PROGRESSO PARA O JOGO DE JACKPOT',
    'Each time you play, you make progress towards triggering the jackpot game. This progress is measured through a meter that fills up a little more each time you bet.': 'ada vez que você joga, avança em direção à ativação do jogo de jackpot. Esse progresso é indicado por um medidor que aumenta um pouco a cada aposta.',
    'JACKPOT GAME OCCURRENCE': 'ATIVAÇÃO DO JOGO DE JACKPOT',
    'Once you have accumulated enough progress, the jackpot game is triggered. This is a special event where you have the chance to win big prizes.': 'Quando você acumula progresso suficiente, o jogo de jackpot é ativado. Esse é um evento especial no qual você tem a oportunidade de ganhar grandes prêmios.',
    'Whether you win a Major, Minor, or Mini ticket, you\'re guaranteed an instant prize payout, with the value varying based on the type of ticket. Each ticket color represents a different prize level.': 'Ao ganhar um bilhete Major, Minor ou Mini, você recebe um prêmio instantâneo garantido. O valor varia de acordo com o tipo de bilhete, e cada cor representa um nível de prêmio diferente.',
    'Each ticket type indicates the number of winners and the size of the prize. The lucky draw happens at the end of a countdown, creating anticipation and excitement. So, whether you have a Major, Minor, or Mini ticket, stay tuned for the draw to see if you\'ve won!': 'Cada tipo de bilhete indica a quantidade de vencedores e o valor do prêmio. O sorteio acontece ao final de uma contagem regressiva, tornando o momento ainda mais emocionante. Portanto, se você tiver um bilhete Major, Minor ou Mini, acompanhe o sorteio para descobrir se ganhou!',
    'Instant prize & lucky draw': 'Prêmio instantâneo e sorteio',
    '{arena} Video Stream': 'Transmissão de vídeo de {arena}',
    'Toggle video auto scale': 'Ativar/desativar ajuste automático do vídeo',
    'Reload the streaming': 'Recarregar a transmissão',
    Commission: 'Comissão',
    Total: 'Total',
    Win: 'Ganho',
    'Your session expired, please login again.': 'Sua sessão expirou. Faça login novamente.',
    'Go to login page': 'Ir para a página de login',
    Chinese: '简体中文',
    Statement: 'Extrato',
    Main: 'Principal',
    Limits: 'Limites',
    Settings: 'Configurações',
    Notification: 'Notificações',
    Logout: 'Sair',
    General: 'Geral',
    'To read more': 'Saiba mais',
    'Jackpot prize': 'Prêmio do jackpot',
    Schedules: 'Programação',
    'Schedule details': 'Detalhes da programação',
    Save: 'Salvar',
    Custom: 'Personalizado',
    Maximum: 'Máximo',
    'Float Video': 'Vídeo flutuante',
    Spanish: 'Español',
    Pakistan: 'اُردُو ',
    Korean: '한국어',
    Japanese: '日本語',
    'Stream locked': 'Transmissão bloqueada',
    'You need at least {CURRENCY} {AMOUNT} in your wallet to watch this stream.': 'Você precisa ter pelo menos {CURRENCY} {AMOUNT} em sua carteira para assistir a esta transmissão.',
    'Cockfighting Rules': 'Regras da rinha de galos',
    Burmese: 'မြန်မာဘာသာစကား',
    'Bengali-Bangladesh': 'বাংলা',
    'Traditional Chinese': '繁體中文',
    'Hindi-India': 'हिन्दी',
    Earning: 'Ganhos',
    'Bet not successful': 'Aposta não realizada',
    'Betting is paused. Please try again shortly. E25': 'As apostas estão pausadas. Tente novamente em instantes. E25',
    'Bet guide': 'Guia de apostas',
    'Placing bet': 'Como apostar',
    'Select bet chip': 'Selecione a ficha de aposta',
    'Place chip by clicking on preferred bet selection': 'Coloque a ficha clicando na opção de aposta desejada',
    'Click Bet button to confirm your bet': 'Clique no botão Apostar para confirmar sua aposta',
    'Fair game rules': 'Regras de jogo limpo',
    'Live streaming': 'Transmissão ao vivo',
    'Unforeseen issues such as internet connectivity, power supply, or weather disruptions caused the live stream to be interrupted before the fight began.': 'Problemas imprevistos, como falhas de conexão com a internet, fornecimento de energia ou condições climáticas, fizeram com que a transmissão ao vivo fosse interrompida antes do início da luta.',
    'If the fight is not displayed on the game site, all bets will be refunded.': 'Se a luta não for exibida no site do jogo, todas as apostas serão reembolsadas.',
    'Arena management decision': 'Decisão da administração da arena',
    'Arena management reserves the right to cancel any match; announcements regarding arena decisions will be made on a case-by-case basis.': 'A administração da arena reserva-se o direito de cancelar qualquer partida. Os comunicados sobre as decisões da arena serão feitos caso a caso.',
    'Bet not closed in time': 'Apostas não encerradas a tempo',
    'Bets placed after the fight began will be void and refunded to members due to unforeseen technical issues.': 'Apostas realizadas após o início da luta serão anuladas e reembolsadas aos membros devido a problemas técnicos imprevistos.',
    'Terms & Conditions': 'Termos e Condições',
    'Philippines Cockfighting': 'Rinha de galos das Filipinas',
    'Challenge Rules': 'Regras do desafio',
    'Banker / Meron': 'Banqueiro / Meron',
    'Player / Wala': 'Jogador / Wala',
    'Draw / No Winner': 'Empate / Sem vencedor',
    'During the Carreo Procedure (3 UP & 3 DOWN), neither rooster lands two (2) successful pecks, or': 'Durante o procedimento Carreo (3 PARA CIMA E 3 PARA BAIXO), nenhum dos galos acerta duas (2) bicadas válidas; ou',
    'No winner is declared within 10 minutes from the first contact.': 'Nenhum vencedor é declarado em até 10 minutos após o primeiro contato.',
    '*Arena Judge decision is final.': '*A decisão do juiz da arena é definitiva.',
    Cambodia: 'Camboja',
    'Cockfight Rules': 'Regras da rinha de galos',
    'Touching or Catching =': 'Tocar ou segurar =',
    'Automatic Loss': 'Derrota automática',
    'No External Help': 'Sem ajuda externa',
    'No fixing, No beak adjustment': 'Sem manipulação e sem ajuste do bico',
    'No water': 'Sem água',
    'Defeated if': 'Derrota se:',
    'Lies Flat': 'Ficar completamente deitado',
    'Runs Away / Cries': 'Fugir / gritar',
    'No Retaliation × 3': 'Não reagir × 3',
    'Standing beats Kneeling;': 'Em pé vence ajoelhado;',
    'Kneeling beats Lying Flat': 'Ajoelhado vence deitado',
    'NO ABUSED or POISONING ALLOWED': 'NÃO SÃO PERMITIDOS MAUS-TRATOS NEM ENVENENAMENTO',
    'Tabletop Game Guide': 'Guia do jogo de mesa',
    'RULE: DON\'T FALL OFF!': 'REGRA: NÃO CAIA DA MESA!',
    'Roosters fight on the table top arena.': 'Os galos lutam em uma arena sobre a mesa.',
    'First rooster to touch the floor LOSES.': 'O primeiro galo a tocar o chão PERDE.',
    'Rooster remaining on the table WINS.': 'O galo que permanecer sobre a mesa VENCE.',
    'Draw when both rooster fall off at the same time': 'Há empate quando os dois galos caem da mesa ao mesmo tempo.',
    'A match is declared DRAW (NO WINNER) if:': 'Uma partida é declarada EMPATE (SEM VENCEDOR) quando:',
    'The match began, but Arena Management determined that cock was injured. Arena management has the right to cancel the fight if neither cock has a cut or bleed. Any other unforeseeable events.': 'A partida começou, mas a administração da arena determinou que um dos galos estava ferido. A administração da arena tem o direito de cancelar a luta se nenhum dos galos apresentar corte ou sangramento. Isso também se aplica a quaisquer outros eventos imprevistos.',
    Philippines: 'Filipinas',
    Tabletop: 'Mesa',
    'Max bet reached for this selection.': 'O limite máximo de aposta para esta seleção foi atingido.',
    'This arena has ended': 'Esta arena foi encerrada.',
    'Thank you for your support': 'Obrigado pelo seu apoio.',
    Portuguese: 'Português',
    Uzbek: 'Uzbek',
  },
  uz: {
    'Khmer': 'ភាសាខ្មែរ',
    Copy: 'Nusxalash',
    Copied: 'Nusxalandi',
    Oops: 'Voy!',
    'We could not find the page.': 'Sahifani topa olmadik.',
    'You are not authorized to view this page.': 'Bu sahifani ko‘rishga ruxsatingiz yo‘q.',
    'Min-max': 'Min–maks',
    History: 'Tarix',
    Help: 'Yordam',
    Banker: 'Banker',
    Player: 'Player',
    Undo: 'Bekor',
    Bet: 'Bet',
    Jackpot: 'Jekpot',
    'No fight at the moment': 'Hozircha jang yo‘q',
    'F{fightNumber} is {fightStatus}': 'F{fightNumber} holati: {fightStatus}',
    Hrs: 'Soat',
    Min: 'Daq',
    Sec: 'Son',
    'Load more': 'Ko‘proq yuklash',
    loading: 'Yuklanmoqda',
    'Congratulations!': 'Tabriklaymiz!',
    'Major ticket': 'Major chiptasi',
    'Claim your prize': 'Mukofotingizni oling',
    'Current jackpot': 'Joriy jekpot',
    'Past winner': 'Avvalgi g‘olib',
    'My tickets': 'Chiptalarim',
    'Super draw': 'Super qur’a',
    Winners: 'G‘oliblar',
    Today: 'Bugun',
    'No tickets earned': 'Hech qanday chipta qo‘lga kiritilmadi',
    'You earn lucky draw ticket #{ticketId}': 'Omadli qur’a uchun #{ticketId}-raqamli chiptani qo‘lga kiritdingiz',
    'Instant prize': 'Darhol beriladigan mukofot',
    Date: 'Sana',
    Time: 'Vaqt',
    Ante: 'Ante',
    'You can\'t place bet': 'Garov qo‘ya olmaysiz',
    Odds: 'Koef.',
    Results: 'Natijalar',
    'Win/lose': 'Yut./Yutq.',
    Id: 'ID',
    Match: 'Uchrashuv',
    'Start time': 'Boshlanish vaqti',
    Created: 'Yaratilgan',
    Confirmed: 'Tasdiqlangan',
    Closing: 'Yopilmoqda',
    Closed: 'Yopilgan',
    Started: 'Boshlangan',
    Ended: 'Tugagan',
    Declared: 'E’lon qilingan',
    Approved: 'Ma’qullangan',
    Processed: 'Qayta ishlangan',
    Cancelled: 'Bekor qilingan',
    Hold: 'Kutishda',
    Close: 'Yopish',
    Draw: 'Durang',
    'Bet detail': 'Garov tafsilotlari',
    Yesterday: 'Kecha',
    'This week': 'Shu hafta',
    'Last week': 'O‘tgan hafta',
    Viet: 'Tiếng Việt',
    Thai: 'ภาษาไทย',
    Indo: 'Bahasa indo',
    'Account disabled': 'Hisob o‘chirib qo‘yilgan',
    'Invalid token': 'Yaroqsiz token',
    'Draw will be declared after 10-minute countdown': 'Qur’a 10 daqiqalik teskari sanoq tugagach e’lon qilinadi',
    Balance: 'Balans',
    Tnc: 'Shartlar va qoidalar',
    Progress: 'Jarayon',
    Open: 'Ochiq',
    'Okay, got it.': 'Tushunarli.',
    'Please come back again': 'Iltimos, keyinroq yana keling',
    Voided: 'Bekor qilingan',
    'Jackpot history': 'Jekpot tarixi',
    'Jackpot help': 'Jekpot bo‘yicha yordam',
    'Lucky draw': 'Omadli qur’a',
    'ANTE FOR JACKPOT GAME': 'JEKPOT O‘YINI UCHUN ANTE',
    'Along with your bet, a small portion (known as the "ante") is automatically collected and added to the jackpot pool. This pool is a special fund that accumulates over time, contributed to by all players participating in the game.': 'Garovingiz bilan birga kichik miqdor ("ante" deb ataladi) avtomatik ravishda olinib, jekpot jamg‘armasiga qo‘shiladi. Bu jamg‘arma vaqt o‘tishi bilan to‘planadigan va o‘yinda qatnashayotgan barcha o‘yinchilar hissasi bilan shakllanadigan maxsus fonddir.',
    'ACCUMULATING PROGRESS FOR JACKPOT GAME': 'JEKPOT O‘YINI UCHUN JARAYONNI TO‘PLASH',
    'Each time you play, you make progress towards triggering the jackpot game. This progress is measured through a meter that fills up a little more each time you bet.': 'Har safar o‘ynaganingizda, jekpot o‘yinini ishga tushirish yo‘lida siljish hosil qilasiz. Bu siljish o‘lchagich orqali ko‘rsatiladi va har bir garovda biroz to‘lib boradi.',
    'JACKPOT GAME OCCURRENCE': 'JEKPOT O‘YININING ISHGA TUSHISHI',
    'Once you have accumulated enough progress, the jackpot game is triggered. This is a special event where you have the chance to win big prizes.': 'Yetarli darajada siljish to‘plangach, jekpot o‘yini ishga tushadi. Bu katta mukofotlarni yutish imkonini beradigan maxsus tadbirdir.',
    'Whether you win a Major, Minor, or Mini ticket, you\'re guaranteed an instant prize payout, with the value varying based on the type of ticket. Each ticket color represents a different prize level.': 'Major, Minor yoki Mini chiptasini yutishingizdan qat’i nazar, darhol mukofot to‘lovi kafolatlanadi; uning qiymati chipta turiga qarab farq qiladi. Har bir chipta rangi boshqa mukofot darajasini bildiradi.',
    'Each ticket type indicates the number of winners and the size of the prize. The lucky draw happens at the end of a countdown, creating anticipation and excitement. So, whether you have a Major, Minor, or Mini ticket, stay tuned for the draw to see if you\'ve won!': 'Har bir chipta turi g‘oliblar soni va mukofot miqdorini ko‘rsatadi. Omadli qur’a teskari sanoq yakunida o‘tkaziladi va hayajonni oshiradi. Shuning uchun Major, Minor yoki Mini chiptangiz bo‘lsa, g‘olib bo‘lgan-bo‘lmaganingizni bilish uchun qur’ani kuting!',
    'Instant prize & lucky draw': 'Darhol mukofot va omadli qur’a',
    '{arena} Video Stream': '{arena} video translyatsiyasi',
    'Toggle video auto scale': 'Videoni avtomatik masshtablashni yoqish/o‘chirish',
    'Reload the streaming': 'Translyatsiyani qayta yuklash',
    Commission: 'Komissiya',
    Total: 'Jami',
    Win: 'Yutuq',
    'Your session expired, please login again.': 'Seansingiz muddati tugadi. Iltimos, qayta kiring.',
    'Go to login page': 'Kirish sahifasiga o‘tish',
    Chinese: '简体中文',
    Statement: 'Extrato',
    Main: 'Asosiy',
    Limits: 'Limitlar',
    Settings: 'Sozlamalar',
    Notification: 'Bildirishnoma',
    Logout: 'Chiqish',
    General: 'Umumiy',
    'To read more': 'Batafsil o‘qish',
    'Jackpot prize': 'Jekpot mukofoti',
    Schedules: 'Jadvallar',
    'Schedule details': 'Jadval tafsilotlari',
    Save: 'Saqlash',
    Custom: 'Maxsus',
    Maximum: 'Maksimal',
    'Float Video': 'Qalqib turuvchi video',
    Spanish: 'Español',
    Pakistan: 'اُردُو ',
    Korean: '한국어',
    Japanese: '日本語',
    'Stream locked': 'Translyatsiya qulflangan',
    'You need at least {CURRENCY} {AMOUNT} in your wallet to watch this stream.': 'Ushbu translyatsiyani tomosha qilish uchun hamyoningizda kamida {CURRENCY} {AMOUNT} bo‘lishi kerak.',
    'Cockfighting Rules': 'Xo‘roz urishtirish qoidalari',
    Burmese: 'မြန်မာဘာသာစကား',
    'Bengali-Bangladesh': 'বাংলা',
    'Traditional Chinese': '繁體中文',
    'Hindi-India': 'हिन्दी',
    Earning: 'Daromad',
    'Bet not successful': 'Garov muvaffaqiyatsiz',
    'Betting is paused. Please try again shortly. E25': 'Garov qo‘yish vaqtincha to‘xtatildi. Iltimos, birozdan so‘ng qayta urinib ko‘ring. E25',
    'Bet guide': 'Garov bo‘yicha qo‘llanma',
    'Placing bet': 'Garov qo‘yish',
    'Select bet chip': 'Garov jetonini tanlang',
    'Place chip by clicking on preferred bet selection': 'O‘zingiz xohlagan garov variantini bosib, jetonni joylashtiring',
    'Click Bet button to confirm your bet': 'Garovni tasdiqlash uchun "Garov" tugmasini bosing',
    'Fair game rules': 'Halol o‘yin qoidalari',
    'Live streaming': 'Jonli translyatsiya',
    'Unforeseen issues such as internet connectivity, power supply, or weather disruptions caused the live stream to be interrupted before the fight began.': 'Internet aloqasi, elektr ta’minoti yoki ob-havo bilan bog‘liq kutilmagan muammolar sabab jang boshlanishidan oldin jonli translyatsiya uzildi.',
    'If the fight is not displayed on the game site, all bets will be refunded.': 'Agar jang o‘yin saytida ko‘rsatilmasa, barcha garovlar qaytariladi.',
    'Arena management decision': 'Arena rahbariyatining qarori',
    'Arena management reserves the right to cancel any match; announcements regarding arena decisions will be made on a case-by-case basis.': 'Arena rahbariyati istalgan jangni bekor qilish huquqini o‘zida saqlab qoladi; arena qarorlari haqidagi e’lonlar har bir holat bo‘yicha alohida beriladi.',
    'Bet not closed in time': 'Garovlar o‘z vaqtida yopilmadi',
    'Bets placed after the fight began will be void and refunded to members due to unforeseen technical issues.': 'Kutilmagan texnik muammolar sabab jang boshlanganidan keyin qo‘yilgan garovlar bekor qilinadi va a’zolarga qaytariladi.',
    'Terms & Conditions': 'Shartlar va qoidalar',
    'Philippines Cockfighting': 'Filippin xo‘roz urishtirishi',
    'Challenge Rules': 'Bellashuv qoidalari',
    'Banker / Meron': 'Banker / Meron',
    'Player / Wala': 'O‘yinchi / Wala',
    'Draw / No Winner': 'Durang / G‘olib yo‘q',
    'During the Carreo Procedure (3 UP & 3 DOWN), neither rooster lands two (2) successful pecks, or': 'Carreo jarayoni (3 YUQORIGA va 3 PASTGA) davomida xo‘rozlarning hech biri ikkita (2) muvaffaqiyatli cho‘qimasa yoki',
    'No winner is declared within 10 minutes from the first contact.': 'Birinchi to‘qnashuvdan keyin 10 daqiqa ichida g‘olib e’lon qilinmasa.',
    '*Arena Judge decision is final.': '*Arena hakamining qarori qat’iy.',
    Cambodia: 'Kambodja',
    'Cockfight Rules': 'Xo‘roz jangi qoidalari',
    'Touching or Catching =': 'Tegish yoki ushlash =',
    'Automatic Loss': 'Avtomatik mag‘lubiyat',
    'No External Help': 'Tashqi yordam taqiqlanadi',
    'No fixing, No beak adjustment': 'Hech qanday tuzatish va tumshuqni moslash mumkin emas',
    'No water': 'Suv berilmaydi',
    'Defeated if': 'Quyidagi holatlarda mag‘lub hisoblanadi',
    'Lies Flat': 'Yassi yotib qolsa',
    'Runs Away / Cries': 'Qochib ketsa / qichqirsa',
    'No Retaliation × 3': '3 marta javob hujumi qilmasa',
    'Standing beats Kneeling;': 'Tik turgan tiz cho‘kkanni yengadi;',
    'Kneeling beats Lying Flat': 'Tiz cho‘kkan yassi yotganni yengadi',
    'NO ABUSED or POISONING ALLOWED': 'ZO‘RAVONLIK YOKI ZAHARLASHGA YO‘L QO‘YILMAYDI',
    'Tabletop Game Guide': 'Stol usti o‘yini bo‘yicha qo‘llanma',
    'RULE: DON\'T FALL OFF!': 'QOIDA: STOLDAN TUSHIB KETMANG!',
    'Roosters fight on the table top arena.': 'Xo‘rozlar stol ustidagi arenada jang qiladi.',
    'First rooster to touch the floor LOSES.': 'Polga birinchi bo‘lib tekkan xo‘roz YUTQAZADI.',
    'Rooster remaining on the table WINS.': 'Stolda qolgan xo‘roz YUTADI.',
    'Draw when both rooster fall off at the same time': 'Ikkala xo‘roz bir vaqtda tushib ketsa, durang',
    'A match is declared DRAW (NO WINNER) if:': 'Uchrashuv quyidagi hollarda DURANG (G‘OLIB YO‘Q) deb e’lon qilinadi:',
    'The match began, but Arena Management determined that cock was injured. Arena management has the right to cancel the fight if neither cock has a cut or bleed. Any other unforeseeable events.': 'Uchrashuv boshlangan, biroq Arena rahbariyati xo‘roz jarohatlanganini aniqlagan bo‘lsa. Agar hech bir xo‘rozda kesilgan yoki qonagan joy bo‘lmasa, Arena rahbariyati jangni bekor qilish huquqiga ega. Boshqa har qanday kutilmagan hodisalar.',
    Philippines: 'Filipinas',
    Tabletop: 'Stol usti',
    'Max bet reached for this selection.': 'Ushbu variant uchun maksimal garov miqdoriga yetildi.',
    'This arena has ended': 'Bu arenadagi o‘yin yakunlandi',
    'Thank you for your support': 'Qo‘llab-quvvatlaganingiz uchun rahmat',
    Portuguese: 'Português',
    Uzbek: 'Uzbek',
  },
};

export default languages;
